// @ts-nocheck
/**
 * Brinuti.hu - CRO Projekt JS
 * Interstitial Modal & Live Free Shipping Bar & Product QuickView & TEEINBLUE BUNDLE LOGIC & CART GALLERY & PAPIER QTY LOGIC
 */

(function() {
    const originalFetch = window.fetch;
    // Forintban (nem fillérben) — ez a szám hajtja a szállítási sávot.
    // Ha változik, a cart-drawer.liquid és a két termék-sablon custom_liquid
    // blokkja is átírandó, mert azok fillérben tárolják ugyanezt.
    const FREE_SHIPPING_THRESHOLD = 20000;
    /* A GLS-díj forintban. Ugyanez a szám a
       snippets/brinuti-pdp-szallitasi-sav.liquid-ben is ott van fillérben —
       átárazáskor mindkettőt át kell írni. */
    const SZALLITASI_DIJ = 2490;
    let quickviewSplide = null;
    let isEditingCartItem = false;

    /**
     * A Splide IGÉNY SZERINT töltődik be — csak akkor, amikor a látogató
     * először nyit gyorsnézetet.
     *
     * Korábban minden oldal jelölésében benne volt (defer szkript + stíluslap),
     * pedig CSAK ennek a modálnak a galériájához kell. Ez oldalanként 29 KB JS
     * és 5 KB CSS, ráadásul egy külön külső kiszolgálóról (cdn.jsdelivr.net),
     * vagyis egy plusz DNS + TLS kapcsolat is járt vele — olyan látogatóknak
     * is, akik soha nem nyitnak gyorsnézetet.
     *
     * A hívó oldalon nincs szükség hibakezelésre: ha a betöltés elbukik, a
     * galéria egyszerű képlistaként jelenik meg (a modál jelölése enélkül is
     * érvényes), tehát a gyorsnézet működik tovább.
     *
     * @returns {Promise<boolean>} igaz, ha a Splide használható
     */
    let splideIgeret = null;
    function splideBetoltes() {
        if (window.Splide) return Promise.resolve(true);
        if (splideIgeret) return splideIgeret;

        const ALAP = 'https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/';

        splideIgeret = new Promise(function (kesz) {
            const stilus = document.createElement('link');
            stilus.rel = 'stylesheet';
            stilus.href = ALAP + 'css/splide.min.css';
            document.head.appendChild(stilus);

            const szkript = document.createElement('script');
            szkript.src = ALAP + 'js/splide.min.js';
            szkript.onload = function () { kesz(!!window.Splide); };
            szkript.onerror = function () { kesz(false); };
            document.head.appendChild(szkript);
        });

        return splideIgeret;
    }

    /**
     * Forintra formázás a bolt többi részével egyezően: 4900 -> "4.900 Ft".
     * A toLocaleString('hu-HU') a négyjegyű számokat nem tagolja (4900),
     * a Shopify money szűrője viszont ponttal tagol, ezért írjuk kézzel.
     * @param {number} amount - összeg forintban (nem fillérben)
     */
    function formatFt(amount) {
        const egesz = Math.round(Number(amount) || 0);
        return egesz.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' Ft';
    }

    /* Kosárszerkesztés után ez nyitja vissza a kosarat.

       Régen a kosárikonra küldött egy kattintást, és osztályokat aggatott
       #CartDrawer / .cart-drawer elemekre. Az mind a Dawn témából maradt itt:
       ez a bolt Horizonon fut, ahol a fiók egy natív <dialog>, amit csak a
       saját open() metódusa nyit — osztálytól meg sem moccan. A kattintás
       viszont hatott, csak rosszul: egy <a href="/cart"> elemen a kattintás
       elnavigál, vagyis ez a függvény a kosároldalra vitte a vásárlót.
       Pont azt, amit ki akartunk venni a folyamatból.

       Innentől a téma saját nyitóját hívja, semmi mást. */
    function forceOpenCart() {
        nyisdMegAKosarFiokot();
    }

    /* 2026-10-15: a jelzés a mentés IDŐPONTJA. Eddig 'true' volt, és 8 mp
       után törlődött — a Teeinblue viszont mérten ~11 mp múlva tölti újra a
       lapot, így a fiók nem nyílt vissza. Most bármikor érvényes, ha a
       mentés óta legfeljebb 60 mp telt el. */
    function frissSzerkesztesJelzes() {
        const ertek = sessionStorage.getItem('brinuti_cart_edited');
        if (!ertek) return false;
        const ido = Number(ertek);
        return ertek === 'true' || (ido > 0 && Date.now() - ido < 60000);
    }
    /* Nem várjuk meg a DOMContentLoaded-et: az csak akkor jön, ha a lap
       ÖSSZES késleltetett szkriptje lefutott, és mérten 1–11 mp-et késett
       egy lassú külső szkript miatt (2026-10-15). Ez a fájl maga is
       késleltetett (defer), vagyis mire fut, a jelölés már kész — a fióknak
       csak a saját elemére kell várnia. */
    const szerkesztesUtaniNyitas = () => {
        if (!frissSzerkesztesJelzes()) { sessionStorage.removeItem('brinuti_cart_edited'); return; }
        sessionStorage.removeItem('brinuti_cart_edited');
        /* A Teeinblue a „Kosár frissítése" végén ÚJRATÖLTI az oldalt, és az
           újratöltött lapon a fiók jelölése már a kész, végleges kosarat
           tartalmazza — nincs mire várni, csak arra, hogy a téma eleme éljen.
           A régi, vakon várt 800 ms helyett erre várunk. A setTimeout csak
           tartalék; a még nem definiált elemre nem nyitunk (és nem is
           jelöljük késznek), mert akkor a whenDefined-ág már nem nyitna. */
        let megnyilt = false;
        const nyisd = () => {
            if (megnyilt || !customElements.get('cart-drawer-component')) return;
            megnyilt = true;
            forceOpenCart();
        };
        customElements.whenDefined('cart-drawer-component').then(() => requestAnimationFrame(nyisd));
        setTimeout(nyisd, 2000);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', szerkesztesUtaniNyitas);
    else szerkesztesUtaniNyitas();

    /* VISSZA GOMB: a kosár a valódi állapotot mutassa (2026-10-15, a tulaj
       jelezte élesben, iPhone-on). A böngésző a „Vissza” gombra a korábbi
       lapot a memóriájából teszi vissza (bfcache), a korábbi fiókkal együtt:
       kosárbeli szerkesztés után így a RÉGI terv és szalag látszott, az
       előnézet is a régit mutatta, és az ottani módosítás hibára futott,
       mert a sor azóta már nem létezett. Ilyenkor a fiókot a kosár mostani
       állapotából rajzoljuk újra. A gyorsítótárból visszatöltött lapra
       (back_forward) ugyanez áll. */
    window.addEventListener('pageshow', (e) => {
        let visszalepes = !!e.persisted;
        if (!visszalepes) {
            try {
                const nav = performance.getEntriesByType('navigation')[0];
                visszalepes = !!nav && nav.type === 'back_forward';
            } catch (x) {}
        }
        if (!visszalepes) return;
        brinutiKosarFrissitesVisszalepeskor();
    });

    async function updateFreeShippingBar() {
        try {
            const res = await fetch('/cart.js');
            const cart = await res.json();
            const cartTotal = cart.total_price / 100; 
            
            const upsellTotalTracker = document.getElementById('UpsellCartTotalTracker');
            if (upsellTotalTracker) {
                upsellTotalTracker.innerHTML = formatFt(cartTotal);
            }

            const barFill = document.getElementById('shipping-progress-fill');
            const barText = document.getElementById('shipping-bar-text');
            
            // A köztes oldal saját sávja, a termékoldali sáv és a kártyák
            // számai akkor is frissüljenek, ha a régi (#shipping-bar-text)
            // sáv nincs az oldalon — a köztes oldal óta sehol sincs.
            frissitsdAKoztesOldalt(cartTotal);
            frissitsdAzUpsellSzamokat(cartTotal);
            frissitsdATermekoldaliSavot(cartTotal);
            if (!barFill || !barText) return;

            if (cartTotal >= FREE_SHIPPING_THRESHOLD) {
                barFill.style.width = '100%';
                barFill.style.background = '#4CAF50'; 
                barText.innerHTML = '🎉 Gratulálunk! Elérted az <strong>ingyenes szállítást!</strong>';
            } else {
                const remaining = FREE_SHIPPING_THRESHOLD - cartTotal;
                let percentage = (cartTotal / FREE_SHIPPING_THRESHOLD) * 100;
                if (percentage < 5) percentage = 5; 

                barFill.style.width = `${percentage}%`;
                barFill.style.background = '#1a1a1a'; 
                barText.innerHTML = `Még <strong>${formatFt(remaining)}</strong> az <strong>ingyenes szállításig!</strong>`;
            }
        } catch (error) {
            console.error('Hiba a szállítási sáv frissítésekor:', error);
        }
    }

    /* Az upsell kártyák „→ még {x} Ft" sora (C10).
     *
     * A doksi 1. callout-ja: a küszöb-sáv fent jó, de a 15 termék nem
     * kapcsolódott hozzá — a vásárló nem tudta, melyikkel lépi át a 20 000-et.
     * Minden kártya megmondja, mennyi maradna UTÁNA. A Liquid kiírja a
     * kezdőértéket, innentől ez a függvény tartja karban.
     *
     * @param {number} kosarFt - a kosár értéke forintban
     */
    function frissitsdAzUpsellSzamokat(kosarFt) {
        const elemek = document.querySelectorAll('[data-brinuti-upsell-meg]');
        if (!elemek.length) return;

        elemek.forEach(function (elem) {
            const arFt = Number(elem.dataset.ar || '0') / 100;
            const hianyzik = FREE_SHIPPING_THRESHOLD - kosarFt - arFt;

            if (hianyzik <= 0) {
                elem.textContent = 'ezzel ingyenes a szállítás ✓';
                elem.classList.add('upsell-card__meg--eleg');
            } else {
                elem.textContent = '→ még ' + formatFt(hianyzik);
                elem.classList.remove('upsell-card__meg--eleg');
            }
        });
    }

    /* A termékoldali szállítási sáv (C4).
     *
     * A sáv CSAK az aktív kosarat nézi (a tulaj kérése, 2026-09-17), ezért a
     * kosár változásakor újra kell számolni. A szerver adja a kezdőértéket
     * (snippets/brinuti-pdp-szallitasi-sav.liquid), innentől ez tartja karban.
     *
     * @param {number} kosarFt - a kosár értéke forintban
     */
    function frissitsdATermekoldaliSavot(kosarFt) {
        const sav = document.querySelector('[data-brinuti-szallitas]');
        if (!sav) return;

        const hianyzik = FREE_SHIPPING_THRESHOLD - kosarFt;

        /* Csak SZÖVEGET írunk át, jelölést nem: a kamion-ikon és a
           „Ingyenes szállítás" címke a snippetben áll, és sosem változik.
           Régen itt egy teljes SVG-string volt lemásolva — a kettőt együtt
           kellett karbantartani, ami csapda. */
        const cim = sav.querySelector('[data-brinuti-szallitas-cim]');
        if (cim) {
            cim.textContent = hianyzik > 0
                ? 'Még ' + formatFt(hianyzik) + ' az ingyenes szállításig'
                : formatFt(SZALLITASI_DIJ) + ' szállítási díjat megspóroltál';
        }

        const csik = sav.querySelector('[data-brinuti-szallitas-csik]');
        if (csik) {
            let szazalek = (kosarFt / FREE_SHIPPING_THRESHOLD) * 100;
            if (szazalek > 100) szazalek = 100;
            csik.style.width = szazalek + '%';
        }

        const alsor = sav.querySelector('[data-brinuti-szallitas-alsor]');
        if (alsor) {
            alsor.textContent = formatFt(kosarFt) + ' / ' + formatFt(FREE_SHIPPING_THRESHOLD);
        }
    }

    /* Kosárfiók: ajándékdoboz kapcsoló.
       Bekapcsolva annyi doboz megy be, ahány napló van a kosárban;
       kikapcsolva mind kijön. A fiók nyitva marad. */
    document.addEventListener('change', async function (esemeny) {
        const kapcsolo = esemeny.target.closest ? esemeny.target.closest('[data-brinuti-doboz]') : null;
        if (!kapcsolo) return;

        const varians = Number(kapcsolo.dataset.brinutiDoboz || '0');
        const mennyi = Number(kapcsolo.dataset.brinutiDobozDb || '1');
        if (!varians) return;

        kapcsolo.disabled = true;
        try {
            if (kapcsolo.checked) {
                await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ id: varians, quantity: mennyi })
                });
            } else {
                // A /cart/change.js a MENNYISÉGET állítja: nullára véve a
                // tételt kiveszi. Az azonosító a variánsé, ezért az `id`
                // kulcsot használjuk, nem a sorkulcsot.
                await fetch('/cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ id: String(varians), quantity: 0 })
                });
            }
            await frissitsdAKosarFeluletet();
        } catch (hiba) {
            console.warn('[brinuti] ajándékdoboz hiba:', hiba);
            kapcsolo.checked = !kapcsolo.checked;
            kapcsolo.disabled = false;
        }
    }, true);

    /* Kosárfiók: ajándékdoboz léptető (− 2 +), 2026-09-19.
       A gomb a kívánt ÚJ darabszámot hordozza; a /cart/change.js a
       variáns azonosítójával erre állítja a doboz-sort. */
    document.addEventListener('click', async function (esemeny) {
        const gomb = esemeny.target.closest ? esemeny.target.closest('[data-brinuti-doboz-lepes]') : null;
        if (!gomb) return;

        esemeny.preventDefault();
        esemeny.stopPropagation();

        const varians = String(gomb.dataset.brinutiDobozVarians || '');
        const uj = Number(gomb.dataset.brinutiDobozLepes || '0');
        if (!varians || uj < 1) return;

        gomb.disabled = true;
        try {
            await fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: varians, quantity: uj })
            });
            await frissitsdAKosarFeluletet();
        } catch (hiba) {
            console.warn('[brinuti] ajándékdoboz léptető hiba:', hiba);
            gomb.disabled = false;
        }
    }, true);

    /* Kosárfiók: kiegészítő hozzáadása a kerek „+" gombbal.
       A látványterv elfogadási feltétele, hogy a FIÓK NE ZÁRÓDJON BE — ezért
       a hozzáadás után a meglévő frissítő fut, ami a fiók tartalmát cseréli,
       nem az egész oldalt. */
    document.addEventListener('click', async function (esemeny) {
        const gomb = esemeny.target.closest ? esemeny.target.closest('[data-brinuti-kosar-plusz]') : null;
        if (!gomb) return;

        esemeny.preventDefault();
        esemeny.stopPropagation();

        const varians = Number(gomb.dataset.brinutiKosarPlusz || '0');
        if (!varians) return;

        gomb.disabled = true;
        try {
            await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: varians, quantity: 1 })
            });
            await frissitsdAKosarFeluletet();
        } catch (hiba) {
            console.warn('[brinuti] kosár-upsell hiba:', hiba);
            gomb.disabled = false;
        }
    }, true);

    /* Kosár-felugró (2026-09-19, a tulaj kérése): a kiegészítő kártyájára
       kattintva a termék középen, felugró ablakban jön be — az oldalról nem
       visz el. Saját <dialog>, showModal()-lal: a kosárfiók fölé kerül, és
       bezáráskor a fiók ugyanúgy nyitva marad mögötte. */
    let felugro = null;
    function felugroAblak() {
        if (felugro) return felugro;
        felugro = document.createElement('dialog');
        felugro.className = 'brinuti-felugro';
        felugro.setAttribute('aria-label', 'Termék részletei');
        felugro.innerHTML =
            '<button type="button" class="brinuti-felugro__x" aria-label="Bezárás">' +
            '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
            '<div class="brinuti-felugro__tartalom"></div>';
        felugro.addEventListener('click', function (e) {
            // A háttérre (a dialog saját felületén kívülre) kattintás bezár.
            if (e.target === felugro || e.target.closest('.brinuti-felugro__x')) felugro.close();
        });
        document.body.appendChild(felugro);
        return felugro;
    }
    function szovegbol(html, max) {
        const d = document.createElement('div');
        // Minden címke után szóköz, különben a bekezdések összeragadnak
        // („stílusosan!A cipzáras").
        d.innerHTML = (html || '').replace(/>/g, '> ');
        const t = (d.textContent || '').replace(/\s+/g, ' ').trim();
        return t.length > max ? t.slice(0, max).replace(/\s+\S*$/, '') + '…' : t;
    }
    function escHtml(s) {
        return String(s).replace(/[&<>"']/g, function (c) {
            return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
        });
    }
    async function nyisdAFelugrot(handle) {
        const ablak = felugroAblak();
        const tartalom = ablak.querySelector('.brinuti-felugro__tartalom');
        tartalom.innerHTML = '<p class="brinuti-felugro__tolt">Betöltés…</p>';
        if (!ablak.open) ablak.showModal();
        try {
            const v = await fetch('/products/' + encodeURIComponent(handle) + '.js').then(function (r) { return r.json(); });
            const varians = (v.variants || []).find(function (x) { return x.available; }) || (v.variants || [])[0];
            const kep = v.featured_image || (v.images || [])[0] || '';
            const kepUrl = kep ? (kep.indexOf('?') > -1 ? kep + '&width=600' : kep + '?width=600') : '';
            const ar = formatFt(v.price / 100);
            const regi = v.compare_at_price > v.price ? formatFt(v.compare_at_price / 100) : '';
            const leiras = szovegbol(v.description, 320);
            tartalom.innerHTML =
                (kepUrl ? '<div class="brinuti-felugro__kep"><img src="' + escHtml(kepUrl) + '" alt="' + escHtml(v.title) + '"></div>' : '') +
                '<h3 class="brinuti-felugro__cim">' + escHtml(v.title.replace(/ - /g, ' – ')) + '</h3>' +
                '<p class="brinuti-felugro__ar">' + (regi ? '<s>' + regi + '</s> ' : '') + ar + '</p>' +
                (leiras ? '<p class="brinuti-felugro__leiras">' + escHtml(leiras) + '</p>' : '') +
                (varians && varians.available
                    ? '<button type="button" class="brinuti-felugro__gomb" data-brinuti-felugro-kosarba="' + varians.id + '">Kosárba teszem</button>'
                    : '<p class="brinuti-felugro__elfogyott">Jelenleg nem elérhető</p>');
        } catch (hiba) {
            console.warn('[brinuti] kosár-felugró hiba:', hiba);
            tartalom.innerHTML = '<p class="brinuti-felugro__tolt">Nem sikerült betölteni. Próbáld újra!</p>';
        }
    }
    document.addEventListener('click', function (esemeny) {
        if (!esemeny.target.closest) return;
        if (esemeny.target.closest('[data-brinuti-kosar-plusz]')) return;
        const kartya = esemeny.target.closest('[data-brinuti-felugro]');
        if (!kartya) return;
        esemeny.preventDefault();
        nyisdAFelugrot(kartya.dataset.brinutiFelugro);
    });
    document.addEventListener('keydown', function (esemeny) {
        if (esemeny.key !== 'Enter' && esemeny.key !== ' ') return;
        const kartya = esemeny.target.matches && esemeny.target.matches('[data-brinuti-felugro]') ? esemeny.target : null;
        if (!kartya) return;
        esemeny.preventDefault();
        nyisdAFelugrot(kartya.dataset.brinutiFelugro);
    });
    document.addEventListener('click', async function (esemeny) {
        const gomb = esemeny.target.closest ? esemeny.target.closest('[data-brinuti-felugro-kosarba]') : null;
        if (!gomb) return;
        esemeny.preventDefault();
        gomb.disabled = true;
        gomb.textContent = 'Hozzáadás…';
        try {
            await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: Number(gomb.dataset.brinutiFelugroKosarba), quantity: 1 })
            });
            await frissitsdAKosarFeluletet();
            if (felugro && felugro.open) felugro.close();
        } catch (hiba) {
            console.warn('[brinuti] kosár-felugró hozzáadás hiba:', hiba);
            gomb.disabled = false;
            gomb.textContent = 'Kosárba teszem';
        }
    });

    /* „Szettet a kosárba": a három tétel egy kattintással.
       A gomb a variánsazonosítókat vesszővel kapja meg a Liquidtől. */
    document.addEventListener('click', async function (esemeny) {
        const gomb = esemeny.target.closest ? esemeny.target.closest('[data-brinuti-szett]') : null;
        if (!gomb) return;

        const azonositok = (gomb.dataset.brinutiSzett || '')
            .split(',')
            .map(function (x) { return x.trim(); })
            .filter(Boolean);
        if (!azonositok.length) return;

        const eredetiFelirat = gomb.textContent;
        gomb.disabled = true;
        gomb.textContent = 'Hozzáadás…';

        try {
            // Egyetlen kéréssel megy be mind: így egyszer fut le a kosár
            // újraszámolása, és nem villog háromszor a felület.
            await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    items: azonositok.map(function (id) { return { id: Number(id), quantity: 1 }; })
                })
            });
            gomb.textContent = 'A kosárban ✓';
            updateFreeShippingBar();
        } catch (hiba) {
            console.warn('[brinuti] a szett hozzáadása nem sikerült:', hiba);
            gomb.textContent = eredetiFelirat;
            gomb.disabled = false;
        }
    });

    document.addEventListener('click', (e) => {
        const btn = e.target.closest('button, [type="button"], [type="submit"], .tee-btn');
        if (btn) {
            const text = (btn.textContent || '').toLowerCase();
            if (text.includes('frissít') || text.includes('update') || text.includes('mentés') || text.includes('save')) {
                isEditingCartItem = true;
                sessionStorage.setItem('brinuti_cart_edited', String(Date.now()));
                tiltsdAzOnnyitast();
                /* A jelzést itt NEM töröljük: a Teeinblue az újratöltést
                   olykor 10 mp után indítja, és az újratöltött lapnak még
                   látnia kell (lásd frissSzerkesztesJelzes). */
                setTimeout(() => {
                    isEditingCartItem = false;
                    engeddAzOnnyitast();
                }, 8000);
                // Ha 20 mp múlva is ez a lap él, nem volt újratöltés: a jelzés mehet.
                setTimeout(() => sessionStorage.removeItem('brinuti_cart_edited'), 20000);
            }
        }
    }, true);

    /* Teeinblue "Szerkesztés" a kosárban: előbb húzódjon vissza a fiók.

       A szerkesztő eddig a kosár MÖGÖTT nyílt meg. Ez nem z-index kérdése:
       a fiók natív <dialog>, amit a téma showModal()-lal nyit, így a böngésző
       legfelső rétegébe (top layer) kerül. Abba a rétegbe rendes CSS-sel nem
       lehet betolakodni — akármekkora z-indexet kapna a szerkesztő, alatta
       maradna. Az egyetlen tiszta megoldás becsukni a fiókot.

       ELFOGÓ (capture) fázisban figyelünk, nem buborékban. Első nekifutásra
       buborék volt, és nem működött: a Teeinblue saját kezelője megállítja
       az esemény terjedését, így a dokumentumig már el sem jutott. Az elfogó
       fázis felülről lefelé fut, még a cél elem kezelői előtt — azt egy
       stopPropagation sem tudja megelőzni.

       Pointerdownra NEM figyelünk, pedig kézenfekvőnek tűnt. Az a kattintás
       előtt tüzel, így a fiók már azelőtt csukódni kezdett, hogy az egérgombot
       felengedte volna a vásárló. A gomb ezzel kikerült a megjelenített fából,
       a click esemény meg sem született, és a Teeinblue kezelője soha nem
       futott le: a kosár eltűnt, a szerkesztő pedig nem jött be. Csak clickre
       figyelünk.

       Szándékosan nincs preventDefault és nincs stopPropagation: a Teeinblue
       saját kezelőjének le kell futnia, mi csak melléállunk. A setTimeout
       pedig azért kell, hogy a saját kezelőik biztosan előbb fussanak,
       függetlenül attól, milyen sorrendben iratkoztak fel.

       Visszafelé az út már megvan: mentés után a fenti figyelő beállítja a
       brinuti_cart_edited jelzést, és a fiók magától visszanyílik. */
    /* A második választó tartalék arra az esetre, ha az app a gombot nem a
       nekik odaadott div-be tenné. Szándékosan szűk: csak olyasmire illeszkedik,
       aminek a class-ában szerepel a "tee-edit". A data-customization-id-t NEM
       használjuk kapaszkodónak — ha azt az app a sor konténerére is ráteszi,
       a mennyiséggombra kattintva is becsukódna a fiók. */
    function szerkesztesreKattintott(e) {
        if (e.target.closest('.tee-edit-customization, [class*="tee-edit"]')) {
            setTimeout(csukdBeAKosarFiokot, 0);
        }
    }
    document.addEventListener('click', szerkesztesreKattintott, true);

    /* A „Szerkesztés” gomb visszaállítása a fiók újrarajzolása után.
       A téma (cart:update) újrarajzolja a fiókot, és közben kiüríti a
       .tee-edit-customization div-et, de a div maga ugyanaz az elem marad.
       A teeinblue Vue-ja ezen a div-en még a régi, már nem látható gombot
       tartja nyilván, ezért újrainduláskor nem rajzolja ki újra (a termék-
       oldalon a szerkesztés után így tűnt el a gomb). Megoldás: az üres div-et
       egy friss másolatra cseréljük, és az app saját eseményeivel újraindítjuk
       a kosárrészét (friss /cart.js-sel). Időablakonként legfeljebb néhányszor
       próbálkozunk, hogy semmi ne pöröghessen körbe. */
    let teeGombIdozito = null;
    let teeGombProbak = 0;
    let teeGombAblakKezdete = 0;
    function allitsdVisszaATeeGombokat() {
        const uresek = [...document.querySelectorAll('.tee-edit-customization[data-customization-id]')]
            .filter(el => el.dataset.customizationId && !el.querySelector('.tee-edit-button__wrapper'));
        if (!uresek.length) return;
        const most = Date.now();
        if (most - teeGombAblakKezdete > 10000) { teeGombAblakKezdete = most; teeGombProbak = 0; }
        if (teeGombProbak >= 4) return;
        teeGombProbak++;
        uresek.forEach(el => el.replaceWith(el.cloneNode(false)));
        document.dispatchEvent(new Event('shopify-event-cart-modified'));
        document.dispatchEvent(new Event('shopify-event-cart-ajax'));
    }
    function utemezdATeeGombokat() {
        clearTimeout(teeGombIdozito);
        teeGombIdozito = setTimeout(allitsdVisszaATeeGombokat, 1200);
    }
    /* GYORSÍTÁS (2026-10-02): ha az oldalon egyetlen szerkesztőgomb sincs
       (a legtöbb oldalon, üres kosárnál), nincs mit keresni — az élő
       gyűjtemény hosszát olvasni nem kerül semmibe. */
    const teeSzerkesztoGombok = document.getElementsByClassName('tee-edit-customization');
    new MutationObserver(function (valtozasok) {
        if (!teeSzerkesztoGombok.length) return;
        for (const v of valtozasok) {
            const cel = v.target;
            if (cel.nodeType === 1 && (cel.matches('.tee-edit-customization') || cel.querySelector('.tee-edit-customization'))) {
                utemezdATeeGombokat();
                return;
            }
        }
    }).observe(document.documentElement, { childList: true, subtree: true });

    /* Pénztár előtti figyelmeztetés.

       A személyre szabott naplókra és füzetekre írt szöveget nyomtatás után
       nem lehet javítani, ezért a vásárló a pénztárba lépés előtt kapjon egy
       utolsó emlékeztetőt, hogy nézze át a feliratait.

       Miért <dialog> és miért nem sima div: a kosárfiók maga is natív
       <dialog>, amit a téma showModal()-lal nyit, így a böngésző legfelső
       rétegében (top layer) van. Abba a rétegbe közönséges elem nem tud
       betolakodni, akármekkora z-indexet kapna — a figyelmeztetés a fiók
       MÖGÖTT jelenne meg. Ugyanez a csapda ütött ki korábban a Teeinblue
       szerkesztőjénél is. Saját showModal()-lal viszont a mi ablakunk kerül
       legfelülre.

       A gomb type="submit", és a Shopify csak akkor visz pénztárra, ha az
       űrlap a name="checkout" gombbal megy el. Ezért nem az űrlapot
       küldjük el kézzel (az elhagyná a gomb nevét), hanem a megerősítés
       után ÚJRA kattintunk ugyanarra a gombra, egy jelzővel átengedve. */
    /* KIKAPCSOLVA (2026-09-16, a tulaj kérése): a pénztár előtti
       figyelmeztetés egy plusz kattintás a fizetés előtt, ezért egyelőre
       nem jelenik meg. A kód szándékosan bent marad — a doboz szövegével,
       ábrájával és a brinuti-custom.css-beli stílusával együtt —, hogy egy
       true-val vissza lehessen kapcsolni. Az élő témán ugyanígy áll, hogy
       a két téma ne csússzon szét egy későbbi átvitelnél. */
    const PENZTAR_FIGYELMEZTETES_BEKAPCSOLVA = false;

    let penztarAtengedve = false;
    let penztarParbeszed = null;

    function keszitsdElAPenztarParbeszedet() {
        if (penztarParbeszed) return penztarParbeszed;
        penztarParbeszed = document.createElement('dialog');
        penztarParbeszed.className = 'brinuti-penztar-figyelmeztetes';
        penztarParbeszed.innerHTML =
            '<div class="brinuti-penztar-figyelmeztetes__doboz">' +
              '<p class="brinuti-penztar-figyelmeztetes__cim">Fontos!</p>' +
              '<p class="brinuti-penztar-figyelmeztetes__szoveg">Kérlek nézd át a rendelésed, illetve a naplóra vagy füzetre írt szövegeket. Az elírt feliratokat sajnos nem tudjuk utólag javítani.</p>' +
              /* Az ábra a kosársor kicsinyített mása. Szándékosan HTML és
                 nem kép: minden kijelzőn éles marad, telefonon magától
                 tördelődik, és nincs feltöltött fájl, ami elavulhatna, ha a
                 kosár kinézete változik. A piros gyűrűk a két gombot
                 emelik ki, amivel a vásárló ellenőrizni és javítani tud. */
              '<div class="brinuti-penztar-abra" aria-hidden="true">' +
                '<div class="brinuti-penztar-abra__sor">' +
                  '<span class="brinuti-penztar-abra__kep"></span>' +
                  '<span class="brinuti-penztar-abra__nev">Dragon’s Embrace füzet (A/5)</span>' +
                '</div>' +
                '<div class="brinuti-penztar-abra__gombok">' +
                  '<span class="brinuti-penztar-abra__kiemelt">Előnézet</span>' +
                  '<span class="brinuti-penztar-abra__kiemelt">Szerkesztés</span>' +
                  '<span class="brinuti-penztar-abra__halvany">Törlés</span>' +
                '</div>' +
              '</div>' +
              '<p class="brinuti-penztar-figyelmeztetes__alszoveg">A kosárban minden tételnél ott ez a két gomb.</p>' +
              '<div class="brinuti-penztar-figyelmeztetes__gombok">' +
                '<button type="button" class="brinuti-penztar-figyelmeztetes__vissza">Átnézem még egyszer</button>' +
                '<button type="button" class="brinuti-penztar-figyelmeztetes__tovabb">Rendben, mehet a pénztár</button>' +
              '</div>' +
            '</div>';
        document.body.appendChild(penztarParbeszed);
        return penztarParbeszed;
    }

    document.addEventListener('click', function (esemeny) {
        if (!PENZTAR_FIGYELMEZTETES_BEKAPCSOLVA) return;
        const gomb = esemeny.target.closest && esemeny.target.closest('button[name="checkout"]');
        if (!gomb) return;
        if (penztarAtengedve) { penztarAtengedve = false; return; }

        esemeny.preventDefault();
        esemeny.stopPropagation();

        const parbeszed = keszitsdElAPenztarParbeszedet();
        const tovabb = parbeszed.querySelector('.brinuti-penztar-figyelmeztetes__tovabb');
        const vissza = parbeszed.querySelector('.brinuti-penztar-figyelmeztetes__vissza');

        const zarasEsTovabb = function () {
            parbeszed.close();
            penztarAtengedve = true;
            /* Halasztva kattintunk: a záráskor a böngésző még ezt az eseményt
               dolgozza fel, és az azonnali kattintás elveszne. */
            setTimeout(function () { gomb.click(); }, 0);
        };
        const csakZaras = function () { parbeszed.close(); };

        tovabb.onclick = zarasEsTovabb;
        vissza.onclick = csakZaras;

        parbeszed.showModal();
    }, true);

    /* A Teeinblue "hozzáadva a kosárhoz" visszajelzésének eltüntetése.

       A bolt kosárfiókkal dolgozik, a /cart oldal nincs használatban. A
       Teeinblue viszont a sikeres kosárba tétel után kiír egy saját dobozt
       ("Ez a termék hozzá lett adva a kosárhoz!" + "Kosár megtekintése"),
       aminek a hivatkozása a köztes kosároldalra visz. A vásárló ezt akkor
       látja meg, amikor az upsell ablakból visszalép a termékhez.

       Két réteg véd:

       1) A dobozt szöveg alapján keressük meg és rejtjük el. Ez törékeny —
          ha a Teeinblue átfogalmazza, nem talál. Ezért van a második réteg.
       2) MINDEN /cart hivatkozás a kosárfiókot nyitja meg navigálás helyett.
          Ez akkor is megfogja a bajt, ha a doboz kicsúszik a szűrőn: a
          vásárló nem kerül át a köztes oldalra.

       A dobozt nem töröljük, csak elrejtjük: a Teeinblue saját kódja
       hivatkozhat rá, és egy hiányzó csomópont náluk hibát dobhatna. */
    const KOSAR_UZENET_MINTA = /hozzá lett adva a kosárhoz|Kosár megtekintése/i;

    function rejtsdElAKosarUzenetet(gyoker) {
        /* GYORS ELŐSZŰRŐ.

           Ez a függvény két helyről hívódik: a betöltés végén az EGÉSZ
           oldaltörzsre, és az alatta lévő dokumentum-szintű figyelőből MINDEN
           beszúrt elemre. Az utóbbi sűrű: öt app (Teeinblue, OptiMonk,
           Clarity, Ads agent, Selleasy) folyamatosan szór be csomópontokat.
           Mérve a főoldalon, betöltés közben: 146 hívás, 5 704 bejárt elem.

           A drága rész az elemenkénti `closest()` és a szövegcsomópontok
           összefűzése. Ezt csak akkor van értelme elvégezni, ha a keresett
           szöveg egyáltalán ott van a fában — és ezt EGYETLEN `textContent`
           olvasással el lehet dönteni.

           A szűrő nem változtat a viselkedésen: ha egy elem saját szövege
           illeszkedne a mintára, akkor a fa `textContent`-je is illeszkedik,
           tehát nem eshet ki semmi, ami eddig megvolt. Fordítva előfordulhat
           téves riasztás (a minta két elem szövegéből áll össze), de olyankor
           az eredeti logika fut le, és egyszerűen nem talál semmit.

           Mérve (ugyanaz az oldal, ugyanaz a 146 hívás): 18,2 ms -> 6,0 ms,
           a bejárt elemek száma 5 704 -> 0. */
        if (!KOSAR_UZENET_MINTA.test(gyoker.textContent || '')) return;

        const jeloltek = (gyoker.querySelectorAll ? gyoker.querySelectorAll('*') : []);
        for (const elem of jeloltek) {
            if (elem.closest('#BrinutiUpsellModal, cart-drawer-component, .brinuti-arlepcso')) continue;
            const sajatSzoveg = Array.from(elem.childNodes)
                .filter(function (c) { return c.nodeType === 3; })
                .map(function (c) { return c.textContent; })
                .join(' ');
            if (!KOSAR_UZENET_MINTA.test(sajatSzoveg)) continue;

            /* A legkisebb doboz, ami lényegében csak ezt az üzenetet
               tartalmazza. Legfeljebb három szintet megyünk felfelé, és csak
               addig, amíg a szülő szövege nem lényegesen hosszabb — így nem
               rejtünk el véletlenül fél terméklapot. */
            let doboz = elem;
            for (let i = 0; i < 3; i++) {
                const szulo = doboz.parentElement;
                if (!szulo || szulo === document.body) break;
                const sajatHossz = (doboz.textContent || '').trim().length;
                const szuloHossz = (szulo.textContent || '').trim().length;
                if (szuloHossz > sajatHossz + 40) break;
                doboz = szulo;
            }
            if (doboz.dataset.brinutiRejtve === '1') continue;
            doboz.dataset.brinutiRejtve = '1';
            doboz.style.display = 'none';
        }
    }

    new MutationObserver(function (valtozasok) {
        valtozasok.forEach(function (v) {
            v.addedNodes.forEach(function (csomopont) {
                if (csomopont.nodeType === 1) rejtsdElAKosarUzenetet(csomopont);
            });
        });
    }).observe(document.documentElement, { childList: true, subtree: true });

    document.addEventListener('DOMContentLoaded', function () { rejtsdElAKosarUzenetet(document.body); });

    /* Minden kosároldalra mutató hivatkozás a fiókot nyissa meg.

       Elfogó fázisban figyelünk, hogy az alkalmazások saját kezelői előtt
       fussunk. A Ctrl/Cmd/középgombos kattintást szándékosan békén hagyjuk:
       aki új lapon akarja megnyitni, tegye. */
    /* MEGJEGYZÉS a /cart hivatkozásokról.

       Kipróbáltuk, hogy minden kosároldalra mutató hivatkozás a fiókot
       nyissa meg navigálás helyett — de a téma `open()` metódusa mérés
       szerint nem nyitja meg a fiókot ezekben a helyzetekben (közvetlen
       hívásra sem, tele kosárral sem, gyűjtő- és termékoldalon sem).
       Elfogással tehát a kattintás vagy elnyelődne, vagy egy visszaesés
       után ugyanoda vinne, csak lassabban — ezért kivettük.

       Ha valaha mégis kell, előbb azt kell kideríteni, miért nem nyit a
       téma open() metódusa: onnantól az elfogás egy sor. */

    /* A termékoldali árlépcső a Teeinblue ára ALÁ kerüljön.

       A füzetoldalon a látható árat nem a téma írja ki, hanem a Teeinblue
       személyre szabója (.tee-product-price), és az a saját blokkjában van,
       együtt az Előnézet és a Kosárba rakom gombbal. Ezért nincs téma-szintű
       hely az áruk és a gombjuk között: a sablonban a blokk fölé téve az ár
       FÖLÉ kerül, alá téve a gomb ALÁ. Egyik sem az, amit a makett mutat.

       A Liquid ezért a Teeinblue blokk elé rendereli — ez a biztonságos hely,
       mert ha ez a függvény bármiért nem fut le, a sáv akkor is látszik, csak
       feljebb. Itt pedig, ha megjött a Teeinblue ára, mögé csúsztatjuk.

       A figyelő azért kell, mert a Teeinblue a saját blokkját újrarendereli
       (szín- és szövegválasztáskor), és ilyenkor a beszúrt csomópont
       elveszne. Kifutásra várunk: sok apró DOM-változás egyetlen
       áthelyezéssé olvad össze. */
    function teddAzArlepcsotAzArAla() {
        const lepcso = document.querySelector('.brinuti-arlepcso');
        if (!lepcso) return;

        /* CRO-átépítés (2026-09): a termékoldalon a lépcső mostantól egy
           lenyitható, egysoros sávban él, a Teeinblue blokk FÖLÖTT. Oda
           szándékosan került (a 3 csempe 130 px-et vett el a fold-ból), tehát
           nem szabad a Teeinblue ára alá húzni. Máshol marad a régi viselkedés. */
        if (lepcso.closest('.brinuti-kedv')) return;

        const ar = document.querySelector('.tee-product-price');
        if (!ar || !ar.parentNode) return;
        if (ar.nextElementSibling === lepcso) return;   // már jó helyen van
        ar.parentNode.insertBefore(lepcso, ar.nextSibling);
    }

    if (document.querySelector('.brinuti-arlepcso')) {
        let idozito = null;
        const halasztottAthelyezes = function () {
            if (idozito) clearTimeout(idozito);
            idozito = setTimeout(teddAzArlepcsotAzArAla, 120);
        };
        document.addEventListener('DOMContentLoaded', halasztottAthelyezes);
        halasztottAthelyezes();
        new MutationObserver(halasztottAthelyezes).observe(document.body, { childList: true, subtree: true });
    }

    /* A CSOMAGAJÁNLAT ÉS AZ AJÁNDÉKDOBOZ az Előnézet gomb fölött (2026-09-19,
       a tulaj kérése). A Liquid a Kosárba gomb alá rendereli (brinuti-szett-doboz);
       innen emeljük át a Teeinblue űrlapba, a #teeFormActions (mennyiség +
       Előnézet + Kosárba) elé. Ha a szkript nem fut, a blokk a régi helyén marad.

       Magát a csomópontot mozgatjuk, nem másolatot: így a pipák állapota és az
       id-k (BundleCheckbox, BrinutiKieg-…) megmaradnak, a kattintásfigyelők
       pedig a dokumentumon ülnek, tehát tovább működnek.
       A Teeinblue szülője flex-oszlop, amit order-rel rendez (a gombsoré 3):
       ugyanazt az order-t kapja, különben az űrlap tetejére ugrana.
       A figyelő visszateszi, ha a Teeinblue újrarenderel. */
    (function () {
        const szett = document.querySelector('.brinuti-szett');
        if (!szett) return;
        const regiHely = szett.parentElement;

        /* ASZTALON A GOMB ALÁ, TELEFONON FÖLÉ (2026-09-22, a tulaj kérése).

           Az upsell a DÖNTÉS UTÁN jöjjön: előbb szánja el magát a naplóra,
           utána kínáljuk a csomagot és az ajándékdobozt. Ráadásul a blokk
           456 px magas, tehát fölüle elvéve a „Kosárba rakom" ennyivel
           feljebb kerül — a hajtás közelébe.

           Telefonon NEM mozdul: ott a doboz végigvezeti a vásárlót, és a
           mért 19,8%-os görgetés (a 12,0%-os alapérték felett) azt mutatja,
           hogy az a folyamat működik. */
        /* matchMedia és nem innerWidth: a lenti DOM-figyelő minden változásnál
           hívja, és az innerWidth olvasása az elrendezés újraszámolását
           kényszeríti (gyorsítás, 2026-10-02 — lemérve a gépelés közben). */
        const asztaliMq = window.matchMedia('(min-width: 750px)');
        const asztaliSzelesseg = function () { return asztaliMq.matches; };
        function tedd() {
            const gombsor = document.getElementById('teeFormActions');
            if (!gombsor || !gombsor.parentNode) return;
            szett.classList.add('brinuti-szett--urlapban');
            szett.style.order = getComputedStyle(gombsor).order;
            if (asztaliSzelesseg()) {
                if (gombsor.nextElementSibling !== szett) {
                    gombsor.parentNode.insertBefore(szett, gombsor.nextElementSibling);
                }
            } else if (gombsor.previousElementSibling !== szett) {
                gombsor.parentNode.insertBefore(szett, gombsor);
            }
            // Az üresen maradt blokk ne foglaljon helyet (a Horizon blokkköze se).
            if (regiHely && !regiHely.querySelector('.brinuti-szett')) regiHely.classList.add('brinuti-szett-ures');
        }
        let idozito = null;
        const halasztva = function () {
            if (idozito) clearTimeout(idozito);
            idozito = setTimeout(tedd, 120);
        };
        halasztva();
        /* A CSS asztalon elrejti a blokkot, amig a helyere nem kerult — igy a
           betoltes vegen nincs „helycsere" a szemelyre szabo es a csomag
           kozott (a tulaj 2026-09-22-en jelezte). Ha a Teeinblue valamiert
           nem rendereli ki a gombsort, negy masodperc utan a REGI helyen
           mutatjuk meg: az upsell inkabb rossz helyen alljon, mint sehol. */
        setTimeout(function () {
            if (!szett.classList.contains('brinuti-szett--urlapban')) {
                szett.classList.add('brinuti-szett--mutasd');
            }
        }, 4000);
        window.addEventListener('resize', halasztva);
        new MutationObserver(function () {
            const g = document.getElementById('teeFormActions');
            if (!g) return;
            const johelyen = asztaliSzelesseg()
                ? g.nextElementSibling === szett
                : g.previousElementSibling === szett;
            if (!johelyen) halasztva();
        }).observe(document.body, { childList: true, subtree: true });
    })();

    /* „✓ Előnézet: pont ilyen lesz…” A GOMBOK ALATT MARADJON (2. elemző PDF).

       A sort a Liquid a Teeinblue blokk UTÁN rendereli, a gombsor viszont
       `position: sticky; bottom: 0`. Görgetés közben tehát a gombok a képernyő
       alján állnak, a felirat meg az űrlap végén — a tulaj ezt látta
       „le-föl ugrálásnak”.

       Ezért a feliratot beköltöztetjük magába a gombsorba: onnantól együtt
       mozog a gombokkal, mindig közvetlenül alattuk. A figyelő azért kell,
       mert a Teeinblue a gombsorát is újrarendereli.

       2026-09-22: ASZTALON IS. Korábban asztalon az eredeti helyén maradt, egy
       −40 px-es felső margóval, ami a gombok alá húzta. Amióta a csomagblokk a
       gombsor ALATT áll, ugyanez a −40 px a csomagdobozba rántotta a sort —
       a tulaj ott találta, az „Ajándékdobozban kérem" alatt. A gombsorban
       nincs szükség a negatív margóra, és a ragadós gombsorral is együtt utazik. */
    (function () {
        const felirat = document.querySelector('p.brinuti-gomb-alatt');
        if (!felirat) return;

        function tedd() {
            const gombsor = document.getElementById('teeFormActions');
            if (!gombsor) return;
            felirat.classList.add('brinuti-gomb-alatt--urlapban');
            if (felirat.parentElement !== gombsor || gombsor.lastElementChild !== felirat) {
                gombsor.appendChild(felirat);
            }
        }

        let idozito = null;
        const halasztva = function () {
            if (idozito) clearTimeout(idozito);
            idozito = setTimeout(tedd, 120);
        };
        halasztva();
        window.addEventListener('resize', halasztva);
        new MutationObserver(function () {
            const g = document.getElementById('teeFormActions');
            if (g && g.lastElementChild !== felirat) halasztva();
        }).observe(document.body, { childList: true, subtree: true });
    })();

    /* A füzet mennyiségi kedvezmény kuponja minden kosárváltozás után.

       Miért a fetch-burkolóban és nem a frissitsdAKosarFeluletet()-ben:
       azt kizárólag az upsell ablak gombjai hívják. Aki a termékoldalról tesz
       be két füzetet és egyből fizetni megy, annál soha nem futna le, tehát
       kedvezmény nélkül maradna — pedig a kosárfiók sávja már ígérné neki.
       A burkoló viszont minden kosármódosítást lát.

       Nem esik önmagába: a kupont rátevő hívás originalFetch-csel megy, ami
       ide már el sem jut. */
    /* A termékoldali árlépcső újrarajzolása a szerverről.

       Nem JS-ből számoljuk újra a szöveget és a százalékokat: azzal
       megkettőznénk a lépcsőt, és előbb-utóbb elcsúszna a Liquid változattól.
       Helyette a Shopify szekció-rendereléssel újrakérjük ugyanazt a
       szekciót, és csak a sáv tartalmát cseréljük ki.

       A szekció azonosítója sablononként más (template--<szám>__main), ezért
       a DOM-ból olvassuk ki, nem beégetve. A csomópontot magát nem cseréljük,
       csak a belsejét: így marad ott, ahová a teddAzArlepcsotAzArAla() tette,
       a Teeinblue ára alatt. */
    function melyikSzekcioAzon() {
        const elem = document.querySelector('[id^="shopify-section-"][id$="__main"]');
        return elem ? elem.id.replace('shopify-section-', '') : '';
    }

    async function rajzoldUjraAzArlepcsot() {
        const sav = document.querySelector('.brinuti-arlepcso');
        if (!sav) return;
        const azon = melyikSzekcioAzon();
        if (!azon) return;
        try {
            const valasz = await originalFetch(window.location.pathname + '?section_id=' + encodeURIComponent(azon));
            if (!valasz.ok) return;
            const doc = new DOMParser().parseFromString(await valasz.text(), 'text/html');
            const uj = doc.querySelector('.brinuti-arlepcso');
            if (!uj) return;
            sav.innerHTML = uj.innerHTML;
            /* A darabszámot vivő attribútum családonként más (füzetnél
               data-fuzet-db, naplónál data-naplo-db), de a sáv osztályneve
               közös. Amelyik megjött az új változatban, azt visszük át. */
            ['data-fuzet-db', 'data-naplo-db'].forEach(function (nev) {
                if (uj.hasAttribute(nev)) sav.setAttribute(nev, uj.getAttribute(nev) || '0');
            });
        } catch (hiba) {
            console.error('Nem sikerült újrarajzolni az árlépcsőt:', hiba);
        }
    }

    /* A kosár darabszáma, ahogy a szerver kirenderelte az oldalt. Minden
       kosár-lekérés frissíti. Az üres-kosár őr ebből dolgozik, hogy ne kelljen
       hálózatot kérdezni ahhoz, hogy kiderüljön: nincs mit tenni.
       `null` = még nem tudjuk (ilyenkor a régi viselkedés fut). */
    let ismertKosarDb = typeof window.brinutiKosarDb === 'number' ? window.brinutiKosarDb : null;

    /* ÁRVA AJÁNDÉKDOBOZ (2026-09-19, a tulaj jelezte).
       Ha a vásárló kiveszi a naplót, amihez dobozt kért, a doboz eddig a
       kosárban maradt 1 890 Ft-tal, és kivenni sem tudta (a kapcsoló csak
       naplóval látszik). Ezért minden kosárváltozás után — és oldalbetöltéskor —
       a dobozok száma legfeljebb a naplók száma lehet; napló nélkül nulla.
       Napló = 'Customizer' típusú termék, ugyanúgy, mint a Liquid kapcsolóban.
       Igazat ad vissza, ha módosított. */
    async function igazitsdAzAjandekdobozt(kosar) {
        if (!kosar || !Array.isArray(kosar.items)) return false;
        let naplok = 0;
        const dobozSorok = [];
        kosar.items.forEach(function (t) {
            if (t.handle === 'naplo-ajandekdoboz') dobozSorok.push(t);
            else if (t.product_type === 'Customizer') naplok += t.quantity;
        });
        let dobozok = dobozSorok.reduce(function (s, t) { return s + t.quantity; }, 0);
        if (dobozok <= naplok) return false;

        let tobblet = dobozok - naplok;
        for (let i = dobozSorok.length - 1; i >= 0 && tobblet > 0; i--) {
            const sor = dobozSorok[i];
            const uj = Math.max(0, sor.quantity - tobblet);
            tobblet -= sor.quantity - uj;
            try {
                await originalFetch('/cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ id: sor.key, quantity: uj })
                });
            } catch (hiba) {
                console.warn('[brinuti] ajándékdoboz igazítás hiba:', hiba);
                return false;
            }
        }
        return true;
    }

    /* Oldalbetöltéskor is: aki már „beragadt" dobozzal jön vissza, annál is
       rendbe jön. Üres kosárnál nem kérdezünk semmit. */
    (async function () {
        if (typeof window.brinutiKosarDb === 'number' && window.brinutiKosarDb === 0) return;
        const kosar = await kerdLeAKosarat();
        if (kosar && await igazitsdAzAjandekdobozt(kosar)) frissitsdAKosarFeluletet();
    })();

    async function igazitsdAKupontHaKosarValtozott(url) {
        if (typeof url !== 'string') return;
        if (!/\/cart\/(add|change|update|clear)/.test(url)) return;

        /* ÜRES KOSÁRNÁL NINCS MIT IGAZÍTANI.

           Ez a függvény minden kosarat módosító kérésre lefut — és nem csak a
           sajátjainkra: több app is ír a kosárra betöltéskor. Lemérve a
           főoldalon, ÜRES kosárral: 13 `/cart` kérés ment ki, ebből három
           mindjárt az elején a Selleasy-től (`Object.cart`), egy `/cart/update.js`
           pedig egy app beágyazott kódjából. Mindegyikre ráindultunk egy
           kosár-lekéréssel és az árlépcső újrarajzolásával, holott nulla tétel
           mellett a `igazitsdAMennyisegiKupont` úgyis azonnal visszafordul.

           A `/cart/add` kivétel: az épp azt jelenti, hogy már nem lesz üres. */
        if (ismertKosarDb === 0 && !/\/cart\/add/.test(url)) return;

        let kosar = await kerdLeAKosarat();
        if (kosar && /\/cart\/(add|change|update)/.test(url) && await egyeztetdAzEgyedit(kosar)) {
            kosar = await kerdLeAKosarat();
            setTimeout(function () { frissitsdAKosarFeluletet(); }, 400);
        }
        if (kosar && await igazitsdAzAjandekdobozt(kosar)) {
            kosar = await kerdLeAKosarat();
            /* A téma a saját (még dobozos) válaszából rajzol; utána frissítünk. */
            setTimeout(function () { frissitsdAKosarFeluletet(); }, 400);
        }
        /* Ha a kódon változtattunk (vagy mérés közben váltogattuk), a fiók a
           téma közbülső rajzolását mutathatja: a végleges állapotból rajzoljuk
           újra (a második kör már a mentett mérésből dolgozik, nem mér). */
        if (kosar && await igazitsdAMennyisegiKupont(kosar)) {
            setTimeout(function () { frissitsdAKosarFeluletet(); }, 400);
        }
        /* A sáv frissítése a kupon rátétele UTÁN fut, hogy a kiírt százalék
           már a végleges kosárállapotot tükrözze. */
        await rajzoldUjraAzArlepcsot();
    }

    /* A SZETT CSAK A NÉZETT NAPLÓVAL EGYÜTT MEGY BE (PDF 62. pont, 2026-09-19).
       A pipa a kosárba tétel után is bepipálva marad, ezért eddig az oldalon
       bármely későbbi /cart/add (másik napló, app, ajánló) újra betette a tokot
       és a tollat. Most csak akkor, ha a kérés a nézett termék egyik
       variánsát viszi. Ha nem tudjuk eldönteni, a régi viselkedés marad. */
    function aNezettTermekKerulBe(torzs) {
        const meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product;
        if (!meta || !Array.isArray(meta.variants) || !meta.variants.length || torzs == null) return true;
        let szoveg = '';
        try {
            if (typeof torzs === 'string') szoveg = torzs;
            else if (torzs instanceof FormData || torzs instanceof URLSearchParams) {
                torzs.forEach(function (ertek, kulcs) { if (typeof ertek === 'string') szoveg += kulcs + '=' + ertek + '&'; });
            } else return true;
        } catch (e) { return true; }
        return meta.variants.some(function (v) { return new RegExp('(^|\\D)' + v.id + '(\\D|$)').test(szoveg); });
    }

    /* SZERKESZTÉS UTÁN CSAK A KÉSZ KOSÁR NYÍLJON KI (2026-09-22).

       A Teeinblue „Kosár frissítése" gombja három lépést tesz: előbb
       hozzáadja az ÚJ sort (/cart/add.js), utána kiveszi a RÉGIT
       (/cart/update.js, 0 darabbal), végül újratölti az oldalt.

       A régi kód az ELSŐ kosárkérés után 1,5 mp-cel nyitotta a fiókot — ami
       pont a két kérés közé esett —, így a vásárló egy pillanatra MINDKÉT
       naplót látta, mintha duplán rendelte volna. Aztán megjött az
       újratöltés, és a fiók eltűnt.

       És ami miatt kézzel kellett újranyitni: ugyanez a lépés törölte a
       brinuti_cart_edited jelzést is, pedig épp abból nyílt volna vissza a
       kosár az újratöltés után.

       Most megvárjuk, amíg a kosárkérések elcsendesednek. Ha közben megjön
       az újratöltés, a jelzés érintetlen, és a friss lap nyitja ki a kész
       kosarat. Ha nem jön újratöltés (a Teeinblue máskor máshogy dolgozik),
       a csend után mi magunk frissítünk és nyitunk. Mindkét úton csak
       KÉSZ kosarat lát a vásárló. */
    let szerkesztesCsendOra = null;
    function utemezdASzerkesztesUtaniNyitast() {
        clearTimeout(szerkesztesCsendOra);
        let varakozas = 0;
        const probald = async () => {
            // Az első körben még szerkesztés kell; a várakozó körök már nem
            // függnek a 8 mp-es nullázástól.
            if (!varakozas && !isEditingCartItem) return;
            /* Amíg a Teeinblue szerkesztőablaka látszik, az app még dolgozik
               (és többnyire újra is tölti a lapot). Ilyenkor NEM nyitunk: a
               fiók a nyitott ablak mögött, félkész kosárral villant fel (mérve:
               2026-10-15, három sorral). Ha az ablak eltűnt, vagy 12 mp után
               sem jött újratöltés, mi frissítünk és nyitunk. */
            if (document.querySelector('.tee-edit-popup') && varakozas < 20) {
                varakozas++;
                szerkesztesCsendOra = setTimeout(probald, 600);
                return;
            }
            isEditingCartItem = false;
            /* A jelzést NEM töröljük azonnal: ha mégis jön újratöltés, az új
               lapnak kell kinyitnia a fiókot. Ha 10 mp múlva még ez a lap él,
               újratöltés nem volt, a jelzés mehet. */
            setTimeout(() => sessionStorage.removeItem('brinuti_cart_edited'), 10000);
            await frissitsdAKosarFeluletet();
            updateFreeShippingBar();
            nyisdMegAKosarFiokot();
            engeddAzOnnyitast();
        };
        szerkesztesCsendOra = setTimeout(probald, 1200);
    }

    window.fetch = async (...args) => {
        /* SAFARI „VISSZA” (2026-10-16, a tulaj jelezte): a kosár és a fiók
           újrarajzolásához kért szakasz-HTML-t (section_id / sections) és a
           /cart.js-t a Safari a böngésző-gyorsítótárból is visszaadhatja —
           visszalépés után így a RÉGI, üres kosár rajzolódott vissza, amíg
           a vásárló újra nem töltötte a lapot. Ezeket mindig a szerverről
           kérjük. */
        try {
            const cel = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
            const modszer = String(((args[1] || {}).method) || (args[0] && args[0].method) || 'GET').toUpperCase();
            if (modszer === 'GET' && typeof args[0] === 'string' &&
                (/[?&](section_id|sections)=/.test(cel) || /\/cart(\.js)?(\?|$)/.test(cel.replace(location.origin, '')))) {
                args[1] = Object.assign({}, args[1] || {}, { cache: 'no-store' });
            }
        } catch (e) { /* marad az eredeti kérés */ }
        const response = await originalFetch(...args);
        const url = args[0];
        const options = args[1] || {};
        const isUpsellRequest = options.headers && options.headers['X-Brinuti-Upsell'] === 'true';

        /* A SAJÁT KÉRÉSEINK UTÁN IS ŐRIZZÜK A DOBOZT (2026-09-23).
           Az `X-Brinuti-Upsell` fejléc azért van, hogy a csomag tételei és a
           kupon ne induljanak újra a saját kosárírásainkra. Az árva doboz
           viszont ettől függetlenül baj: a kiegészítő-lapozó gyorsnézetéből
           napló nélkül berakva a fiók egy LÁTHATATLAN 1 890 Ft-os tételt
           mutatott, pénztár gombbal. Ezért a doboz-őrt ezekre is lefuttatjuk. */
        if (typeof url === 'string' && response.ok && isUpsellRequest && /\/cart\/(add|change|update)/.test(url)) {
            const kosar = await kerdLeAKosarat();
            if (kosar && await igazitsdAzAjandekdobozt(kosar)) {
                setTimeout(function () { frissitsdAKosarFeluletet(); }, 400);
            }
        }

        if (typeof url === 'string' && response.ok && !isUpsellRequest) {
            if (isEditingCartItem && url.includes('/cart')) {
                /* Szerkesztés közben NEM igazítjuk a kupont: a Teeinblue előbb
                   hozzáadja az új sort, csak utána veszi ki a régit, így egy
                   pillanatra két napló van a kosárban. Erre eddig felkerült a
                   2-napló kupon, majd a régi sor kivétele után le is jött —
                   két fölösleges kérés, ~2 mp-cel később jött a Teeinblue
                   újratöltése (mérve 2026-10-15). A darabszám a szerkesztéstől
                   nem változik; a végső állapotot a fiók frissítése igazítja. */
                utemezdASzerkesztesUtaniNyitast();
                return response;
            }

            await igazitsdAKupontHaKosarValtozott(url);

            if (url.includes('/cart/add')) {
                let itemsToAdd = [];
                const bundleCheckbox = document.getElementById('BundleCheckbox');
                // Csak akkor tesszük rá a csomag kuponját, ha tényleg csomagot
                // kért. A bepipált kiegészítő (pl. ajándékdoboz) önmagában nem
                // csomag, arra nem jár a kedvezmény.
                let csomagotKert = false;

                if (bundleCheckbox && bundleCheckbox.checked && aNezettTermekKerulBe(options.body)) {
                    csomagotKert = true;
                    // A csomag tételei a snippetből jönnek, és a vásárló színt is
                    // választhat hozzájuk. A rejtett mező mindig a kiválasztott
                    // szín variáns ID-jét tartalmazza.
                    const bundleSlots = document.querySelectorAll('.bundle-slot-variant');

                    if (bundleSlots.length > 0) {
                        bundleSlots.forEach(input => {
                            const variantId = parseInt(input.value, 10);
                            if (variantId) itemsToAdd.push({ id: variantId, quantity: 1 });
                        });
                    } else {
                        // Tartalék a régi, bedrótozott ID-kre, ha a snippet nem futna le
                        itemsToAdd.push({ id: 56082853560668, quantity: 1 });
                        itemsToAdd.push({ id: 56883929022812, quantity: 1 });
                    }
                }

                // A bepipált kiegészítők (pl. ajándékdoboz) a csomaggal együtt is
                // a kosárba kerülnek. Korábban ez a két ág kizárta egymást: ha a
                // vásárló csomagot kért, a bepipált ajándékdoboz némán kimaradt.
                //
                // 2026-09-23: CSAK A NÉZETT NAPLÓVAL EGYÜTT, ugyanúgy, mint a
                // csomag tételei. A pipa a kosárba tétel után is bepipálva
                // marad, ezért eddig az oldal MINDEN későbbi /cart/add-ja
                // (kosárfiók-ajánló, másik termék, app) újra betette a dobozt.
                // Lemérve élesben: bepipált doboz mellett a fiók ajánlójából
                // egy matricacsomagot berakva a doboz 1-ről 2-re ugrott.
                if (aNezettTermekKerulBe(options.body)) {
                    const checkedAddons = document.querySelectorAll('.addon-checkbox-input:checked');
                    checkedAddons.forEach(checkbox => itemsToAdd.push({ id: parseInt(checkbox.value), quantity: 1 }));
                }

                if (itemsToAdd.length > 0) {
                    try {
                        await originalFetch('/cart/add.js', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json', 'X-Brinuti-Upsell': 'true' },
                            body: JSON.stringify({ 'items': itemsToAdd })
                        });
                        // A kupon csak a sikeres hozzáadás után megy fel, és
                        // csak csomagnál. Ha a hozzáadás hibára fut, nincs mire
                        // kedvezményt adni.
                        if (csomagotKert) await teddRaACsomagKupont();
                    } catch (e) {
                        console.error("Hiba:", e);
                    }
                }

                // Kosárba tétel után mindig a kosárfiók fogad (2026-09-18).
                // Az upsell ablak már nem itt ugrik fel, hanem egyszer, a
                // fiók pénztár gombjára — lásd a „Köztes oldal" részt lent.
                //
                // A csomag tételei a téma saját kérése UTÁN mentek be, tehát
                // a fiók a tőle kapott (régi) tartalommal nyílna: ezért
                // ilyenkor újrakérjük a tartalmát.
                const voltPluszTetel = itemsToAdd.length > 0;
                setTimeout(async () => {
                    if (voltPluszTetel) await frissitsdAKosarFeluletet();
                    updateFreeShippingBar();
                    nyisdMegAKosarFiokot();
                }, 500);
            }
        }
        return response;
    };

    /* KIEGÉSZÍTŐ-PIPA A KOSÁRBA TÉTEL UTÁN IS (2026-09-19, a tulaj kérése).
       Az ajándékdoboz pipája a „Kosárba rakom" gomb ALATT van, így sokan csak
       a napló kosárba tétele után pipálják be. Eddig ilyenkor semmi nem
       történt: a doboz csak a gombnyomáskor ment be. Most, ha a nézett napló
       már a kosárban van, a pipa azonnal beteszi, a pipa levétele kiveszi.
       Ha a napló még nincs a kosárban, nem nyúlunk semmihez — azt a fenti
       /cart/add ág intézi, mint eddig.
       Egy dobozból legfeljebb annyi kerül be, ahány darab ebből a naplóból a
       kosárban van, így az ismételt ki-be pipálás nem halmoz. */
    let kiegPipaFut = Promise.resolve();
    async function kovesdAKiegeszitoPipat(pipa) {
        const foTermek = parseInt(pipa.dataset.foTermek, 10);
        const varians = parseInt(pipa.value, 10);
        if (!foTermek || !varians) return;
        const kosar = await kerdLeAKosarat();
        if (!kosar || !Array.isArray(kosar.items)) return;

        const naplokDb = kosar.items
            .filter(function (t) { return t.product_id === foTermek; })
            .reduce(function (s, t) { return s + t.quantity; }, 0);
        if (naplokDb === 0) return;

        const kiegSorok = kosar.items.filter(function (t) { return t.variant_id === varians; });
        const kiegDb = kiegSorok.reduce(function (s, t) { return s + t.quantity; }, 0);

        try {
            if (pipa.checked) {
                if (kiegDb >= naplokDb) return;
                await originalFetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'X-Brinuti-Upsell': 'true' },
                    body: JSON.stringify({ items: [{ id: varians, quantity: 1 }] })
                });
            } else {
                const sor = kiegSorok[kiegSorok.length - 1];
                if (!sor) return;
                await originalFetch('/cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'X-Brinuti-Upsell': 'true' },
                    body: JSON.stringify({ id: sor.key, quantity: sor.quantity - 1 })
                });
            }
        } catch (hiba) {
            console.error('[brinuti] kiegészítő pipa hiba:', hiba);
            return;
        }
        await frissitsdAKosarFeluletet();
        updateFreeShippingBar();
        if (pipa.checked) nyisdMegAKosarFiokot();
    }
    document.addEventListener('change', function (esemeny) {
        const pipa = esemeny.target && esemeny.target.closest && esemeny.target.closest('.addon-checkbox-input');
        if (!pipa) return;
        /* Sorba fűzve, hogy a gyors ki-be kattintás ne előzze meg önmagát. */
        kiegPipaFut = kiegPipaFut.then(function () { return kovesdAKiegeszitoPipat(pipa); });
    });
    /* Betöltéskor a pipa a kosarat tükrözze: ha a napló és a doboz is bent
       van, pipálva jelenik meg, így a levétele egyből ki is veszi. */
    (async function () {
        const pipak = document.querySelectorAll('.addon-checkbox-input[data-fo-termek]');
        if (!pipak.length) return;
        if (typeof window.brinutiKosarDb === 'number' && window.brinutiKosarDb === 0) return;
        const kosar = await kerdLeAKosarat();
        if (!kosar || !Array.isArray(kosar.items)) return;
        pipak.forEach(function (pipa) {
            const foTermek = parseInt(pipa.dataset.foTermek, 10);
            const varians = parseInt(pipa.value, 10);
            const naplo = kosar.items.some(function (t) { return t.product_id === foTermek; });
            const kieg = kosar.items.some(function (t) { return t.variant_id === varians; });
            if (naplo && kieg) pipa.checked = true;
        });
    })();

    /* Seprű a bennragadt görgetészárhoz.

       A téma a fiók nyitásakor görgetészárat tesz a body-ra (dialog.js:56-58:
       position: fixed, top: -<scrollY>px), és azt csak a saját closeDialog()-ja
       veszi le. A mi kódunk nem csuk be nyersen dialógust, de a boltban több
       idegen szkript is fut (Teeinblue, PickupBird, pixelek). Ha bármelyikük
       megtenné, a vásárló egy megfagyott, a tetejére ugrott oldalon maradna. Ezért az upsell ablak becsukásakor megnézzük: ha nincs egyetlen
       nyitott dialógus sem, de a zár fent van, levesszük és visszagörgetünk oda,
       ahol a vásárló járt. Nyitott dialógusnál nem nyúlunk hozzá — ott a zár
       jogos. */
    function olddFelABennragadtGorgeteszarat() {
        if (document.body.style.position !== 'fixed') return;
        if (document.querySelector('dialog[open]')) return;

        const eltolas = parseInt(document.body.style.top || '0', 10);
        document.body.style.width = '';
        document.body.style.position = '';
        document.body.style.top = '';
        window.scrollTo({ top: Math.abs(eltolas) || 0, behavior: 'instant' });
    }

    // A téma saját, oldalról becsúszó kosara.
    function nyisdMegAKosarFiokot() {
        const fiok = document.querySelector('cart-drawer-component');
        if (fiok && typeof fiok.open === 'function') {
            fiok.open();
            return;
        }
        const trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
        if (trigger) trigger.click();
    }

    /* A fiók becsukása.

       Mindig a téma saját close() metódusával, soha nem nyers dialog.close()-zal.
       A nyitás görgetészárat tesz a body-ra (position: fixed és egy negatív top),
       és azt kizárólag a téma záró útja oldja fel — nyers zárás után a vásárló
       egy megfagyott, a tetejére ugrott oldalon maradna.

       Ha nincs fiók az oldalon (a kosároldalon nem renderelődik), nem csinál
       semmit. Zárt fiókra hívva is ártalmatlan, a closeDialog kilép magától. */
    function csukdBeAKosarFiokot() {
        const fiok = document.querySelector('cart-drawer-component');
        if (fiok && typeof fiok.close === 'function') fiok.close();
    }

    /* AZ ÖNNYITÁS IDEIGLENES LEVÉTELE (2026-09-22).

       A fiókon ott az „auto-open" jelző, és a téma ettől minden kosárba
       tételkor magától kinyitja (cart-drawer.js, CartAddEvent).

       Szerkesztéskor ez árt. A Teeinblue „Kosár frissítése" először
       HOZZÁADJA az új sort, és a fiók már ekkor kinyílik — a régi sor még
       bent van, tehát a vásárló egy pillanatra KÉT naplót lát, mintha
       duplán rendelte volna. Csak utána megy ki a régi sor, és tölti újra
       az oldalt az app.

       Ezért a szerkesztés idejére levesszük a jelzőt, és a végén
       visszatesszük. A saját, szándékos nyitásunkat ez nem érinti:
       a nyisdMegAKosarFiokot() az open()-t hívja, ami a jelzőtől független. */
    let onnyitasTiltva = false;
    function tiltsdAzOnnyitast() {
        const fiok = document.querySelector('cart-drawer-component');
        if (!fiok || !fiok.hasAttribute('auto-open')) return;
        fiok.removeAttribute('auto-open');
        onnyitasTiltva = true;
    }
    function engeddAzOnnyitast() {
        if (!onnyitasTiltva) return;
        onnyitasTiltva = false;
        const fiok = document.querySelector('cart-drawer-component');
        if (fiok) fiok.setAttribute('auto-open', '');
    }

    /* A kosárfelület frissítése az upsell ablakból.

       A téma teljes kosárfelületét EGYETLEN esemény hajtja, a 'cart:update':
       erre morfolja újra magát a fiók tartalma (component-cart-items.js) és
       erre írja át a számot a fejléc buborék (cart-icon.js). Az upsell gombok
       eddig nem küldtek ilyet — csak a saját kártyájukat rajzolták át —, ezért
       maradt a kosár állott az oldal újratöltéséig. A szállítási sáv azért
       mozgott mégis, mert azt az updateFreeShippingBar() külön újrahúzza; ez
       tévesztett meg mindenkit.

       A csapda: ugyanerre az eseményre figyel a cart-drawer-component is, és
       ha rajta van az auto-open jelző, KINYITJA a fiókot. A jelző rajta van.
       A fiókot a brinuti-popup-active elrejtené, tehát a vásárló nem is látná,
       viszont a nyitás ráteszi a body-ra a görgetészárat — onnantól a "Tovább
       a kosárhoz" gomb némán nem csinálna semmit, mert a showDialog kilép, ha
       a dialógus már nyitva van. Ezért a küldés idejére levesszük a jelzőt.
       A dispatchEvent szinkron fut, a két sor közé nem ékelődik be semmi.

       Sections-t szándékosan nem küldünk: a fiók ilyenkor magától újrakéri a
       szekciót a szervertől. Eggyel több kérés, viszont mindig helyes, és így
       a Liquidből számolt ingyenes-szállítás sáv is helyre áll a fiókban.

       A /cart.js-t az originalFetch-csel kérjük, hogy a három fetch-burkoló
       közül egyik se szóljon bele. */
    /* A csomag-kedvezmény kuponkódja.

       Miért kód és miért nem automatikus akció: a Shopify automatikus
       kedvezménye csak annyit tud kikötni, hogy "legyen 3 darab ezekből a
       termékekből". Azt NEM, hogy a hármas egy naplóból, egy tokból és egy
       tollból álljon. Emiatt a 3 napló, a 3 tok és a napló + 2 tok is
       megkapta a 20%-ot — lemérve mind a négy eset.

       A kód viszont csak akkor kerül a kosárra, ha a vásárló tényleg
       bepipálta a csomagot, a csomag pedig mindig napló + tok + toll hármast
       tesz be. A kód saját szabálya (minimum 3 darab a két kollekcióból) a
       biztonsági háló: ha a vásárló utólag kivesz valamit, a kedvezmény
       magától nem érvényesül, nem kell levennünk a kódot.

       Egy rés marad, és ezt tudni kell: aki megnézi az oldal forrását,
       kiolvashatja a kódot. Ezt csak Shopify Functions alapú egyedi
       kedvezmény zárná ki teljesen.

       FIGYELEM: ehhez az adminban a "Bundle" AUTOMATIKUS akciót ki kell
       kapcsolni, különben az továbbra is mindenre lecsap, és a kód nem is
       tudna érvényesülni mellette (nem kombinálható). */
    const CSOMAG_KUPON = 'CSOMAG20';
    const FUZET_KUPON = 'FUZET20';

    /* Melyik kód kerüljön a kosárra.

       A füzeteknek saját kuponjuk van, mert a CSOMAG20 a Naplók és a Csomag
       kiegészítők kollekciókra szól — füzetnél a hármas küszöb sosem jönne
       össze, és a vásárló kedvezmény nélkül maradna.

       A sablon nevéből döntünk: a theme.liquid ráteszi a #MainContent-re a
       data-template attribútumot, füzetnél ez "product.fuzetek". Ez azért jobb
       kapaszkodó a terméktípusnál vagy a címkénél, mert a sablon az egyetlen,
       ami biztosan együtt vált a füzet-oldallal.

       KORLÁT: a /cart/update.js egyszerre egy kódot tud a kosárra tenni. Ha
       valaki előbb egy napló-, majd egy füzetcsomagot is bepipál, a második
       felülírja az elsőt, és csak az utóbbi kap kedvezményt. */
    function melyikCsomagKupon() {
        const sablon = (document.getElementById('MainContent') || {}).dataset;
        const nev = (sablon && sablon.template) || '';
        return nev.indexOf('fuzetek') !== -1 ? FUZET_KUPON : CSOMAG_KUPON;
    }

    async function teddRaACsomagKupont() {
        try {
            await originalFetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ discount: melyikCsomagKupon() })
            });
        } catch (hiba) {
            console.error('Nem sikerült a csomag kuponját a kosárra tenni:', hiba);
        }
    }

    /* ---- Füzet mennyiségi kedvezmény ---------------------------------

       Minél több füzet van a kosárban, annál nagyobb a kedvezmény. A lépcsőt
       a brinuti-fuzet-lepcso snippet írja le, és ugyanonnan jön a kosárfiókban
       látszó sáv is — így a kijelzés és az árazás nem tud szétcsúszni.

       Miért kell hozzá a termékazonosítók listája: a /cart.js válaszában nincs
       kollekció-információ, a product_type pedig nem segít, mert mind a 11
       füzeté "Customizer" — ugyanaz, mint a naplóké (a Teeinblue teszi rá).
       Lekérdezve a boltból. Ezért a snippet szerveroldalról adja át az
       azonosítókat. */
    const fuzetLepcso = (() => {
        const elem = document.getElementById('brinuti-fuzet-lepcso-adat');
        const ures = { fuzet_termek_idk: [], lepcso: [] };
        if (!elem) return ures;
        try {
            return JSON.parse(elem.textContent);
        } catch (hiba) {
            console.error('A füzet-lépcső adatblokkja nem olvasható:', hiba);
            return ures;
        }
    })();

    function hanyFuzetVanAKosarban(kosar) {
        const idk = fuzetLepcso.fuzet_termek_idk || [];
        if (!idk.length) return 0;
        return (kosar.items || []).reduce(function (db, sor) {
            return idk.indexOf(sor.product_id) !== -1 ? db + sor.quantity : db;
        }, 0);
    }

    /* A legmagasabb lépcsőfok, amit a kosár már elér. A ciklus végigmegy és
       mindig felülírja, így a legnagyobb marad bent. Kevesebb mint 2 füzetnél
       nincs kedvezmény, ilyenkor null jön vissza. */
    function melyikFuzetFok(db) {
        let talalat = null;
        (fuzetLepcso.lepcso || []).forEach(function (fok) {
            if (db >= fok.db) talalat = fok;
        });
        return talalat;
    }

    function fuzetKodE(kod) {
        return (fuzetLepcso.lepcso || []).some(function (fok) { return fok.kod === kod; });
    }

    /* A kód rátétele. A /cart/update.js a MÓDOSÍTOTT kosarat adja vissza,
       benne a total_discount-tal — ebből derül ki, mennyit ér a kód, anélkül
       hogy nekünk kellene kitalálnunk, mely termékekre szól. */
    async function teddRaAKupont(kod) {
        try {
            const valasz = await originalFetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ discount: kod })
            });
            if (!valasz.ok) return null;
            return await valasz.json();
        } catch (hiba) {
            console.error('Nem sikerült a kupont a kosárra tenni:', hiba);
            return null;
        }
    }

    /* ---- Napló mennyiségi kedvezmény ---------------------------------

       Ugyanaz az ígéret, mint a füzeteknél: 2 napló 15%, 3-tól 30% — és a 30
       a plafon. A megvalósítás viszont egy ponton MÁS, és ezt tudni kell,
       mielőtt bárki összevonná a kettőt.

       A füzeteknél a snippet átadja a 11 termékazonosítót, és pontosan
       megszámoljuk a kosárban lévő füzeteket. Naplónál ez nem járható út: a
       Naplók kollekcióban 100 termék van, a Liquid pedig a collection.products
       tömbből legfeljebb 50-et ad vissza — a lista csendben csonka lenne, és a
       naplók fele sosem kapna kedvezményt.

       Ezért itt nem számolunk pontosan, hanem MEGKÉRDEZZÜK a Shopifyt:
       felrakjuk a kódot, és a /cart/update.js válaszának total_discount
       mezőjéből derül ki, ér-e valamit. A minimum darabszámot úgyis a Shopify
       tartja számon, a Naplók kollekcióra szűkítve — övé a végső szó.

       A becslés csak arra kell, hogy ne kérdezgessünk feleslegesen: napló az,
       aminek a kosársorában a product_type "Customizer", és nincs benne a
       füzetek azonosítói között. Lekérdezve a boltból: mind a 100 napló és
       mind a 11 füzet "Customizer" (a Teeinblue teszi rá mindkettőre), a 24
       kiegészítőnek pedig üres a típusa. Ha a becslés mégis téved, a Shopify
       akkor is helyesen dönt — legfeljebb egy fölösleges kérés az ára.

       A kosárfiókban és a termékoldalon látszó darabszám NEM ebből jön, hanem
       Liquidből, a kosár tételein végigmenve: ott nincs 50-es korlát, mert nem
       a kollekciót lapozzuk, hanem a kosarat. */
    const naploLepcso = (() => {
        const elem = document.getElementById('brinuti-naplo-lepcso-adat');
        if (!elem) return [];
        try {
            return JSON.parse(elem.textContent).lepcso || [];
        } catch (hiba) {
            console.error('A napló-lépcső adatblokkja nem olvasható:', hiba);
            return [];
        }
    })();

    function hanyNaploLehetAKosarban(kosar) {
        const fuzetIdk = fuzetLepcso.fuzet_termek_idk || [];
        return (kosar.items || []).reduce(function (db, sor) {
            if (sor.product_type !== 'Customizer') return db;
            if (fuzetIdk.indexOf(sor.product_id) !== -1) return db;
            return db + sor.quantity;
        }, 0);
    }

    /* A legerősebb napló-fok, ami a becsült darabszám mellett szóba jöhet. */
    function melyikNaploFok(db) {
        let talalat = null;
        naploLepcso.forEach(function (fok) {
            if (db >= fok.db) talalat = fok;
        });
        return talalat;
    }

    function naploKodE(kod) {
        return naploLepcso.some(function (fok) { return fok.kod === kod; });
    }

    function sajatLepcsosKodE(kod) {
        return fuzetKodE(kod) || naploKodE(kod);
    }

    /* Rátesszük a kosárra azt a kódot, amelyik a legtöbbet éri.

       A kosárra egyszerre EGY kód tehető, és hárman is kérik a helyet: a
       füzetlépcső, a naplólépcső és a csomag-kupon. Ezért nem tippelünk: sorra
       felrakjuk az esélyeseket, a Shopify által számolt total_discount alapján
       megnézzük, melyik ér többet, és a nyertes marad fent. Így a vásárló sosem
       jár rosszabbul attól, hogy több kedvezmény is létezik — de vegyes
       kosárnál csak az egyiket kapja meg, mert a Shopify többet nem enged.

       A napló-fokokon LEFELÉ lépkedünk, és az elsőnél megállunk, amelyik
       tényleg ad kedvezményt. Azért nem elég a legerősebbet megpróbálni: két
       napló + egy tok esetén a becsült darabszám 3, a NAPLO3DB viszont nem
       érvényes (csak két napló van), a NAPLO2DB pedig igen.

       Visszatérés: true, ha nyúltunk a kosárhoz (ilyenkor újra le kell kérni).

       A kódok saját minimum darabszáma a biztonsági háló: ha a vásárló kivesz
       egy tételt, a Shopify magától érvénytelenné teszi a kódot. */
    async function igazitsdAMennyisegiKupont(kosar) {
        const fuzetFok = melyikFuzetFok(hanyFuzetVanAKosarban(kosar));
        const naploBecsles = hanyNaploLehetAKosarban(kosar);
        const naploFok = melyikNaploFok(naploBecsles);

        const osszesKod = (kosar.discount_codes || []).map(function (k) { return k.code; });
        const ervenyes = (kosar.discount_codes || []).filter(function (k) { return k.applicable; });
        let mostiKod = ervenyes.length ? ervenyes[0].code : '';
        let csomagKod = (mostiKod === CSOMAG_KUPON || mostiKod === FUZET_KUPON) ? mostiKod : '';

        /* ÁRVA CSOMAG-KUPON (2026-09-23).

           A csomag kódjához eddig szándékosan nem nyúltunk: "a saját minimuma
           úgyis megvédi". Ez kevés. A CSOMAG20 szabálya annyi, hogy legyen 3
           darab a Naplók és a Csomag kiegészítők kollekciókból — azt nem köti
           ki, hogy legyen köztük napló.

           Amit lemértem élesben: szettet vettem (napló + tok + toll, jogos
           20%), kivettem a naplót — a kód applicable: false lett, de RAJTA
           MARADT a kosáron. Utána a tollat 1-ről 3-ra emeltem: 3 toll + 1 tok
           = 15 370 Ft-ra a Shopify újra érvényesnek találta a kódot, és adott
           −3 074 Ft-ot, holott ekkor már egyetlen csomag sem volt a kosárban.
           Vagyis a kód a munkamenet végéig lappangva ott ül, és bármikor
           visszaüt.

           Az őr a lehető legszűkebb: a CSOMAG20 csak akkor maradhat, ha van a
           kosárban legalább egy napló, a FUZET20 pedig csak akkor, ha van
           legalább egy füzet. Szett mindig naplóval jár, füzetcsomag mindig
           füzettel, tehát jogos kosarat ez nem érint. A kód rátétele amúgy is
           a tételek hozzáadása UTÁN fut (lásd teddRaACsomagKupont hívását),
           így nincs olyan pillanat, amikor a napló még nem lenne bent.

           Takarítás után nullázzuk a mérés emlékét is, különben a lenyomat
           alapján visszafordulnánk, és a jogos lépcsős kód nem kerülne fel. */
        let nyultunkAzArvahoz = false;
        if ((osszesKod.indexOf(CSOMAG_KUPON) !== -1 && naploBecsles === 0) ||
            (osszesKod.indexOf(FUZET_KUPON) !== -1 &&
             (fuzetLepcso.fuzet_termek_idk || []).length > 0 &&
             hanyFuzetVanAKosarban(kosar) === 0)) {
            await teddRaAKupont('');
            mostiKod = '';
            csomagKod = '';
            nyultunkAzArvahoz = true;
            try { sessionStorage.removeItem('brinuti-kupon-meres'); } catch (e) { }
        }

        if (!fuzetFok && !naploFok) {
            /* Egyik lépcső sem jöhet szóba: a bent maradt lépcsős kódot
               levesszük, hogy ne lógjon ott érvénytelenül a fizetésnél.

               Az ÖSSZES kód között keresünk, nem csak az érvényesek között:
               a Shopify a küszöb alá csökkent kosárnál applicable: false-ra
               teszi a kódot, de rajta hagyja. Ha csak az érvényeseket néznénk,
               pont ez az eset esne ki a szűrőn, és a kód ottragadna. Lemérve
               5 → 2 → 1 füzet sorrendben.

               A csomag-kódhoz nem nyúlunk: az nem a miénk, és a saját minimuma
               úgyis megvédi. */
            if (!nyultunkAzArvahoz && osszesKod.some(sajatLepcsosKodE)) {
                await teddRaAKupont('');
                return true;
            }
            return nyultunkAzArvahoz;
        }

        /* EGYSZER MÉRÜNK EGY KOSÁRÁLLAPOTRA (PDF 62–63. pont, 2026-09-19).
           A mérés sorra felrakja a kódokat; ha közben a téma vagy egy app
           újrarajzolja a fiókot, egy köztes kód összegét írja ki (lemérve:
           −1 785 Ft látszott, miközben a CSOMAG20 −6 438 Ft-ja volt fent).
           Ha a kosár tételei ugyanazok, mint a legutóbbi mérésnél, és a
           nyertes kód van fent, nem mérünk újra. */
        const lenyomat = (kosar.items || []).map(function (s) { return s.variant_id + ':' + s.quantity; }).sort().join(',');
        let mentett = null;
        try { mentett = JSON.parse(sessionStorage.getItem('brinuti-kupon-meres') || 'null'); } catch (e) {}
        if (mentett && mentett.lenyomat === lenyomat && mentett.kod === mostiKod) return false;
        const jegyezdMeg = function (kod) {
            try { sessionStorage.setItem('brinuti-kupon-meres', JSON.stringify({ lenyomat: lenyomat, kod: kod })); } catch (e) {}
        };

        /* Nincs mit mérni: egyetlen esélyes van, és épp az van fent. */
        if (!csomagKod && !naploFok && fuzetFok && mostiKod === fuzetFok.kod) return nyultunkAzArvahoz;
        if (!csomagKod && !fuzetFok && naploFok && mostiKod === naploFok.kod) return nyultunkAzArvahoz;

        let utolsoKod = mostiKod;
        let legjobbKod = '';
        let legjobbErtek = 0;

        const merd = async function (kod) {
            const valasz = await teddRaAKupont(kod);
            if (!valasz) return 0;
            utolsoKod = kod;
            const ertek = valasz.total_discount || 0;
            if (ertek > legjobbErtek) {
                legjobbErtek = ertek;
                legjobbKod = kod;
            }
            return ertek;
        };

        if (naploFok) {
            for (let i = naploLepcso.length - 1; i >= 0; i--) {
                if (naploLepcso[i].db > naploBecsles) continue;
                if (await merd(naploLepcso[i].kod) > 0) break;
            }
        }
        if (fuzetFok) await merd(fuzetFok.kod);
        if (csomagKod) await merd(csomagKod);

        jegyezdMeg(legjobbKod);
        if (!legjobbKod) {
            if (utolsoKod !== '') {
                await teddRaAKupont('');
                return true;
            }
            return nyultunkAzArvahoz;
        }
        if (utolsoKod !== legjobbKod) await teddRaAKupont(legjobbKod);
        return true;
    }

    async function kerdLeAKosarat() {
        try {
            const valasz = await originalFetch('/cart.js', { cache: 'no-store' });
            if (!valasz.ok) return null;
            const kosar = await valasz.json();
            /* Innentől tudjuk a darabszámot; az üres-kosár őr ebből dolgozik. */
            if (kosar && typeof kosar.item_count === 'number') ismertKosarDb = kosar.item_count;
            return kosar;
        } catch (hiba) {
            console.error('Nem sikerült lekérni a kosarat a frissítéshez:', hiba);
            return null;
        }
    }

    /* A kiegészítő-lapozó gyorsnézet ablaka (brinuti-hasonlo-boritok.liquid)
       `X-Brinuti-Upsell` fejléccel tesz kosárba, hogy a fenti burkoló ne
       fűzzön hozzá csomagtételeket — ezért a felület frissítését és a fiók
       megnyitását neki magának kell kérnie. Csak ez a két függvény kerül ki
       globálisba, más nem. (2. elemző PDF, mobil 5. pont.) */
    window.brinutiKosarFrissites = function () { return frissitsdAKosarFeluletet(); };
    window.brinutiNyisdKosarat = function () { return nyisdMegAKosarFiokot(); };

    // Hoisting miatt a fenti pageshow-figyelő is elérheti.
    function brinutiKosarFrissitesVisszalepeskor() {
        const futtasd = () => {
            frissitsdAKosarFeluletet().then(() => updateFreeShippingBar()).catch(() => {});
        };
        if (customElements.get('cart-drawer-component')) futtasd();
        else customElements.whenDefined('cart-drawer-component').then(futtasd);
    }

    /* Egyedi változtatás (2026-10-29): a módosított borítós napló és a hozzá tartozó
       „Egyedi változtatás a borítón” tétel összetartozik (azonos _brinuti_egyedi_azon).
       Árva külön tételt (a napló kikerült) kivesszük, a hiányzót (a hozzáadás elakadt)
       pótoljuk, hogy a vevő sem fizessen módosítás nélkül, sem kapjon módosítást fizetés nélkül.
       IGAZ-zal tér vissza, ha a kosárhoz nyúlt. Minden kosárváltozás után lefut (a napló
       „Törlés” gombja is ide vezet), a fiók újrarajzolásakor is. Amíg a külön tétel
       hozzáadása folyamatban van (a napló épp bekerült), a hiányzót NEM pótolja. */
    async function egyeztetdAzEgyedit(kosar) {
        try {
            const EGYEDI = 'egyedi-valtoztatas-a-boriton';
            const sorok = (kosar && kosar.items) || [];
            const naplok = {}, kiegek = {};
            sorok.forEach(function (t) {
                const az = (t.properties || {})._brinuti_egyedi_azon;
                if (!az) return;
                if (t.handle === EGYEDI) kiegek[az] = t; else naplok[az] = t;
            });
            let valtozott = false;
            for (const az of Object.keys(kiegek)) {
                if (naplok[az]) continue;
                await originalFetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ id: kiegek[az].key, quantity: 0 }) });
                valtozott = true;
            }
            const folyamatban = !!(window.brinutiEgyedi && window.brinutiEgyedi.folyamatban && window.brinutiEgyedi.folyamatban());
            for (const az of Object.keys(naplok)) {
                if (kiegek[az] || folyamatban) continue;
                const termek = await originalFetch('/products/' + EGYEDI + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
                const varians = termek && termek.variants && termek.variants[0];
                if (!varians) continue;
                await originalFetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ items: [{ id: varians.id, quantity: 1, properties: { 'Egyedi változtatás': 'A kért egyedi változtatás a borítón', '_brinuti_egyedi_azon': az } }] }) });
                valtozott = true;
            }
            return valtozott;
        } catch (hiba) { console.error('Egyedi változtatás egyeztetés:', hiba); return false; }
    }

    async function frissitsdAKosarFeluletet() {
        let kosar = await kerdLeAKosarat();
        if (!kosar) return;

        /* Egyedi változtatás: lásd egyeztetdAzEgyedit. */
        if (await egyeztetdAzEgyedit(kosar)) { const uj = await kerdLeAKosarat(); if (uj) kosar = uj; }

        /* A lépcsős kupont még az újrarenderelés ELŐTT kell rátenni, különben
           a fiók a kedvezmény nélküli összeget írná ki, és csak a következő
           változásnál állna helyre. */
        const nyultunkHozza = await igazitsdAMennyisegiKupont(kosar);
        if (nyultunkHozza) {
            const frissKosar = await kerdLeAKosarat();
            if (frissKosar) kosar = frissKosar;
        }

        const fiok = document.querySelector('cart-drawer-component');
        const voltAutoOpen = !!fiok && fiok.hasAttribute('auto-open');
        if (voltAutoOpen) fiok.removeAttribute('auto-open');

        try {
            // A detail.data kötelezően objektum: a fiók kezelője pont nélkül
            // olvassa (event.detail.data.sections), tehát nélküle hibát dobna.
            // A source NEM lehet 'product-form-component': arra a cart-icon
            // hozzáadná a számot a jelenlegihez. Így beállítja, ezért a teljes
            // darabszámot küldjük, nem a most hozzáadott egyet.
            document.dispatchEvent(new CustomEvent('cart:update', {
                bubbles: true,
                detail: {
                    resource: kosar,
                    sourceId: 'brinuti-upsell',
                    data: { source: 'brinuti-upsell', itemCount: kosar.item_count }
                }
            }));
        } finally {
            if (voltAutoOpen) fiok.setAttribute('auto-open', '');
        }

        /* Ha közben nyitva van a köztes oldal, annak a számlálói is a most
           lekért kosárból íródjanak — különben a szettel bement tok és toll
           „KOSÁRBA / 0"-val áll ott. */
        await frissitsdAKoztesSzamlalokat(kosar);
    }

    /* ---- Köztes oldal a kosárfiók és a pénztár között (2026-09-18) ----

       A tulaj kérése: az upsell ne minden kosárba tétel után ugorjon fel,
       hanem CSAK EGYSZER, amikor a vásárló a kosárfiókból a pénztár felé
       indul. Ez lett a köztes oldal.

       Menete:
         1. A fiók pénztár gombjára kattintva (elfogó fázisban) megállítjuk a
            küldést, és lekérjük a sections/brinuti-koztes-oldal szekciót.
            Szekció-rendereléssel, mert így a friss kosárból számol, és
            bármelyik oldalon működik.
         2. Ha van mit ajánlani, a fiók becsukódik, és a köztes oldal jön be.
            Ha nincs (üres a szekció), vagy a lekérés elbukik, megy tovább a
            pénztárba — a vásárlót semmi nem tarthatja fel.
         3. 2026-09-19 óta minden pénztár-kattintásnál feljön (a tulaj
            kérése). A sessionStorage-jelzőt még felírjuk, de a gomb már nem
            nézi.

       A pénztárba a /checkout címre küldünk, nem a fiók űrlapját küldjük el
       újra: a köztes oldalon közben változhatott a kosár, és a fiók tartalmát
       a téma addigra újrarajzolhatta — az eredeti gomb már nem is létezne. */
    const KOZTES_LATTA = 'brinuti_koztes_latta';
    const KOZTES_SZEKCIO = 'brinuti-koztes-oldal';

    function koztesMarVolt() {
        try {
            return sessionStorage.getItem(KOZTES_LATTA) === '1';
        } catch (hiba) {
            return false;
        }
    }

    function jegyezdFelAKoztest() {
        try {
            sessionStorage.setItem(KOZTES_LATTA, '1');
        } catch (hiba) {
            /* privát ablakban nincs tárhely — ilyenkor minden pénztárnál
               újra feljönne, ami kisebb baj, mint hogy el se jöjjön */
        }
    }

    function menjAPenztarba() {
        const gyoker = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        window.location.href = gyoker + 'checkout';
    }

    function csukdBeAKoztest() {
        const modal = document.querySelector('#BrinutiUpsellModal');
        if (modal) {
            modal.classList.remove('is-active');
            modal.setAttribute('aria-hidden', 'true');
        }
        document.body.classList.remove('brinuti-popup-active');
    }

    async function nyisdMegAKoztest(gomb) {
        const modal = document.querySelector('#BrinutiUpsellModal');
        if (!modal) return false;

        const eredetiFelirat = gomb ? gomb.innerHTML : '';
        if (gomb) {
            gomb.disabled = true;
            gomb.setAttribute('aria-busy', 'true');
        }

        let html = '';
        try {
            const gyoker = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
            const valasz = await originalFetch(gyoker + '?section_id=' + KOZTES_SZEKCIO, { credentials: 'same-origin' });
            if (valasz.ok) html = await valasz.text();
        } catch (hiba) {
            console.warn('[brinuti] a köztes oldal nem töltődött be:', hiba);
        }

        if (gomb) {
            gomb.disabled = false;
            gomb.removeAttribute('aria-busy');
            gomb.innerHTML = eredetiFelirat;
        }

        const doc = new DOMParser().parseFromString(html, 'text/html');
        const tartalom = doc.querySelector('.brinuti-koztes-szekcio');
        if (!tartalom || !tartalom.querySelector('[data-bko]')) return false;

        modal.innerHTML = tartalom.outerHTML;
        jegyezdFelAKoztest();

        // Előbb a fiók csukódjon be (a téma saját útján, hogy a görgetészár
        // lejöjjön), csak utána jöjjön be az ablak.
        csukdBeAKosarFiokot();
        setTimeout(() => {
            olddFelABennragadtGorgeteszarat();
            modal.classList.add('is-active');
            modal.setAttribute('aria-hidden', 'false');
            document.body.classList.add('brinuti-popup-active');
            modal.scrollTop = 0;
            const cim = modal.querySelector('.bko-cim');
            if (cim) {
                cim.setAttribute('tabindex', '-1');
                cim.focus({ preventScroll: true });
            }
        }, 60);
        return true;
    }

    // A fiók pénztár gombja. Elfogó fázis: a téma és az appok kezelői előtt.
    document.addEventListener('click', async function (esemeny) {
        const gomb = esemeny.target.closest && esemeny.target.closest('button[name="checkout"]');
        if (!gomb || !gomb.closest('cart-drawer-component')) return;
        // 2026-09-19, a tulaj kérése: MINDEN pénztár-kattintásnál feljön a
        // köztes oldal, nem csak munkamenetenként egyszer. A jelzőt
        // (koztesMarVolt) ezért itt már nem nézzük.

        esemeny.preventDefault();
        esemeny.stopPropagation();

        const megnyilt = await nyisdMegAKoztest(gomb);
        if (!megnyilt) {
            jegyezdFelAKoztest();
            menjAPenztarba();
        }
    }, true);

    /* A köztes oldal számai egy friss kosárból: sáv, „Még X Ft!" sorok.
       Az updateFreeShippingBar() hívja minden kosárváltozásnál. */
    function frissitsdAKoztesOldalt(kosarFt) {
        const gyoker = document.querySelector('#BrinutiUpsellModal [data-bko]');
        if (!gyoker) return;

        const kuszobFt = Number(gyoker.dataset.kuszob || '2000000') / 100;
        const hianyzik = kuszobFt - kosarFt;

        const ertek = gyoker.querySelector('[data-bko-ertek]');
        if (ertek) ertek.textContent = formatFt(kosarFt);

        const sav = gyoker.querySelector('[data-bko-sav]');
        const uzenet = gyoker.querySelector('[data-bko-uzenet]');
        const csik = gyoker.querySelector('[data-bko-csik]');
        const emoji = '<span class="bko-sav__emoji" aria-hidden="true">🎉</span> ';
        if (hianyzik <= 0) {
            if (sav) sav.classList.add('bko-sav--kesz');
            if (uzenet) uzenet.innerHTML = emoji + 'Gratulálunk! Elérted az <strong>ingyenes szállítást!</strong>';
            if (csik) csik.style.width = '100%';
        } else {
            if (sav) sav.classList.remove('bko-sav--kesz');
            if (uzenet) uzenet.innerHTML = emoji + 'Még <strong>' + formatFt(hianyzik) + '</strong> az <strong>ingyenes szállításig!</strong>';
            if (csik) csik.style.width = Math.max(5, Math.min(100, (kosarFt / kuszobFt) * 100)) + '%';
        }

        gyoker.querySelectorAll('[data-bko-szallitas]').forEach(function (sor) {
            // 2026-09-19: ha a kosár már elérte a küszöböt, a sor nem kell.
            sor.hidden = hianyzik <= 0;
            const meg = hianyzik - Number(sor.dataset.ar || '0') / 100;
            if (meg <= 0) {
                sor.textContent = 'Ezzel eléred az ingyenes szállítást';
                sor.classList.add('is-megvan');
            } else {
                sor.textContent = 'Ezzel még nem éred el, hiányzik ' + formatFt(meg);
                sor.classList.remove('is-megvan');
            }
        });
    }

    /* A KÖZTES OLDAL SZÁMLÁLÓI A VALÓDI KOSÁRBÓL (2026-09-23).

       A lista darabszámait a Liquid írja ki az ablak megnyitásakor, utána
       csak az a sor frissült, amin épp kattintottak. A szett gombja viszont
       a tokot ÉS a tollat is berakja, és mindkettő szerepel a lenti listában
       is: ott „KOSÁRBA / 0" maradt, mintha nem lennének a kosárban. Aki így
       még egyszer rájuk nyomott, duplán kapta őket.

       Ezért minden kosárváltozás után az egész listát a friss kosárból
       írjuk. Amelyik soron épp fut egy kattintás (data-dolgozik), azt
       kihagyjuk: annak a saját ága úgyis a friss kosárból zár. */
    async function frissitsdAKoztesSzamlalokat(kosar) {
        const gyoker = document.querySelector('#BrinutiUpsellModal [data-bko]');
        if (!gyoker) return;
        const friss = kosar || await kerdLeAKosarat();
        if (!friss || !Array.isArray(friss.items)) return;

        const mennyi = {};
        friss.items.forEach(function (sor) {
            mennyi[sor.variant_id] = (mennyi[sor.variant_id] || 0) + sor.quantity;
        });

        gyoker.querySelectorAll('[data-bko-muvelet]').forEach(function (muvelet) {
            if (muvelet.dataset.dolgozik === '1') return;
            const dbElem = muvelet.querySelector('[data-bko-db]');
            const gomb = muvelet.querySelector('[data-bko-kosarba]');
            const szamlalo = muvelet.querySelector('.bko-szamlalo');
            if (!dbElem || !gomb || !szamlalo) return;
            const db = mennyi[Number(muvelet.dataset.variant)] || 0;
            dbElem.textContent = db;
            gomb.hidden = db > 0;
            szamlalo.hidden = db === 0;
        });
    }

    async function koztesKosarba(tetelek) {
        const valasz = await originalFetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest', 'X-Brinuti-Upsell': 'true' },
            body: JSON.stringify({ items: tetelek })
        });
        if (!valasz.ok) throw new Error('A kosárba tétel nem sikerült (' + valasz.status + ')');
    }

    /* A szett ára a kiválasztott tokkal és tollal. Fillérben számol, mint a
       Liquid, és ugyanúgy lefelé kerekít a 80%-nál. */
    function szamoldASzettet(szett) {
        const naplo = Number(szett.dataset.naploAr || '0');
        const regi = naplo + Number(szett.dataset.tokAr || '0') + Number(szett.dataset.tollAr || '0');
        const uj = Math.floor(regi * 80 / 100);
        const regiElem = szett.querySelector('[data-bko-regi]');
        const ujElem = szett.querySelector('[data-bko-uj]');
        const kulElem = szett.querySelector('[data-bko-kulonbseg]');
        if (regiElem) regiElem.textContent = formatFt(regi / 100);
        if (ujElem) ujElem.textContent = formatFt(uj / 100);
        if (kulElem) kulElem.textContent = '+' + formatFt((uj - naplo) / 100);
    }

    document.addEventListener('click', async function (esemeny) {
        const cel = esemeny.target;
        if (!cel.closest || !cel.closest('#BrinutiUpsellModal')) return;

        // Tovább a pénztárhoz
        if (cel.closest('[data-bko-penztar]')) {
            esemeny.preventDefault();
            menjAPenztarba();
            return;
        }

        // Választék ki-be
        const valaszto = cel.closest('[data-bko-valaszto]');
        if (valaszto) {
            const szett = valaszto.closest('[data-bko-szett]');
            const panel = szett && szett.querySelector('.bko-szett__valasztek');
            if (!szett || !panel) return;
            const nyitva = !szett.classList.contains('is-nyitva');
            szett.classList.toggle('is-nyitva', nyitva);
            panel.hidden = !nyitva;
            valaszto.setAttribute('aria-expanded', nyitva ? 'true' : 'false');
            const felirat = valaszto.querySelector('[data-bko-valaszto-felirat]');
            if (felirat) felirat.textContent = nyitva ? 'Választék elrejtése' : 'Kiválasztom a tok és a toll színét';
            // 2026-09-19, a tulaj kérése: nyitáskor odagörgetünk, hogy
            // egyből látszódjanak a tokok és a tollak.
            if (nyitva) {
                requestAnimationFrame(function () {
                    panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
                });
            }
            return;
        }

        // Tok vagy tollszín választása
        const opcio = cel.closest('[data-bko-opcio]');
        if (opcio) {
            const csoport = opcio.closest('[data-bko-csoport]');
            const szett = opcio.closest('[data-bko-szett]');
            if (!csoport || !szett) return;
            const mi = csoport.dataset.bkoCsoport; // 'tok' vagy 'toll'
            csoport.querySelectorAll('[data-bko-opcio]').forEach(function (masik) {
                masik.classList.toggle('is-aktiv', masik === opcio);
                masik.setAttribute('aria-pressed', masik === opcio ? 'true' : 'false');
            });
            szett.dataset[mi] = opcio.dataset.variant;
            szett.dataset[mi + 'Ar'] = opcio.dataset.ar;
            const nev = szett.querySelector('[data-bko-valasztott="' + mi + '"]');
            if (nev) nev.textContent = opcio.dataset.nev;
            const kep = szett.querySelector('[data-bko-kep="' + mi + '"] img');
            if (kep && opcio.dataset.kep) {
                kep.removeAttribute('srcset');
                kep.src = opcio.dataset.kep;
            }
            szamoldASzettet(szett);
            return;
        }

        // Szett a kosárba: tok + toll, és rá a csomag-kupon (a napló már bent van)
        const szettGomb = cel.closest('[data-bko-szett-gomb]');
        if (szettGomb) {
            const szett = szettGomb.closest('[data-bko-szett]');
            if (!szett || szettGomb.disabled) return;
            const gombok = szett.querySelectorAll('[data-bko-szett-gomb]');
            const eredeti = Array.from(gombok).map(function (g) { return g.innerHTML; });
            gombok.forEach(function (g) { g.disabled = true; g.textContent = 'Hozzáadás…'; });
            try {
                await koztesKosarba([
                    { id: Number(szett.dataset.tok), quantity: 1 },
                    { id: Number(szett.dataset.toll), quantity: 1 }
                ]);
                // CSOMAG20 és nem melyikCsomagKupon(): az a sablonból dönt, és
                // egy füzet termékoldalán FUZET20-at adna a naplós szettre.
                await teddRaAKupont(CSOMAG_KUPON);
                await frissitsdAKosarFeluletet();
                updateFreeShippingBar();
                gombok.forEach(function (g) {
                    g.textContent = '✓ A szett a kosárban';
                    g.classList.add('is-kesz');
                });
            } catch (hiba) {
                console.warn('[brinuti] a szett hozzáadása nem sikerült:', hiba);
                gombok.forEach(function (g, i) { g.innerHTML = eredeti[i]; g.disabled = false; });
            }
            return;
        }

        /* Egy kiegészítő a kosárba — 2026-09-19, a tulaj kérése: a KOSÁRBA
           gomb kattintás után számlálóvá (− db +) változik, amivel
           tetszőleges darabot tehet be vagy vehet ki. 0-nál visszajön a
           KOSÁRBA gomb. */
        const muvelet = cel.closest('[data-bko-muvelet]');
        const kosarba = cel.closest('[data-bko-kosarba]');
        const plusz = cel.closest('[data-bko-plusz]');
        const minusz = cel.closest('[data-bko-minusz]');
        if (muvelet && (kosarba || plusz || minusz)) {
            if (muvelet.dataset.dolgozik === '1') return;
            muvelet.dataset.dolgozik = '1';

            const variantId = Number(muvelet.dataset.variant);
            const gomb = muvelet.querySelector('[data-bko-kosarba]');
            const szamlalo = muvelet.querySelector('.bko-szamlalo');
            const dbElem = muvelet.querySelector('[data-bko-db]');
            const regiDb = Number(dbElem.textContent) || 0;
            const ujDb = minusz ? Math.max(0, regiDb - 1) : regiDb + 1;

            const mutasd = function (db) {
                dbElem.textContent = db;
                gomb.hidden = db > 0;
                szamlalo.hidden = db === 0;
            };

            // Azonnal mutatjuk az új számot, hiba esetén visszaállítjuk.
            mutasd(ujDb);
            szamlalo.classList.add('is-dolgozik');
            if (kosarba) gomb.disabled = true;
            try {
                if (minusz) {
                    const kosar = await kerdLeAKosarat();
                    const sor = kosar && kosar.items.find(function (t) { return t.variant_id === variantId; });
                    if (sor) {
                        // A burkolt fetch-csel, hogy a kupon és az
                        // ajándékdoboz igazítása is lefusson.
                        const valasz = await window.fetch('/cart/change.js', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
                            body: JSON.stringify({ id: sor.key, quantity: Math.max(0, sor.quantity - 1) })
                        });
                        if (!valasz.ok) throw new Error('A kivétel nem sikerült (' + valasz.status + ')');
                    }
                } else {
                    await koztesKosarba([{ id: variantId, quantity: 1 }]);
                }
                await frissitsdAKosarFeluletet();
                updateFreeShippingBar();
                // A kijelzett szám mindig a valódi kosárból jön, hogy gyors
                // kattintgatásnál se csússzon el.
                const friss = await kerdLeAKosarat();
                if (friss) {
                    mutasd(friss.items
                        .filter(function (t) { return t.variant_id === variantId; })
                        .reduce(function (s, t) { return s + t.quantity; }, 0));
                }
            } catch (hiba) {
                console.warn('[brinuti] a kiegészítő mennyisége nem változott:', hiba);
                mutasd(regiDb);
            } finally {
                szamlalo.classList.remove('is-dolgozik');
                gomb.disabled = false;
                delete muvelet.dataset.dolgozik;
            }
            return;
        }
    });

    function showQuickview(product) {
        const quickviewModal = document.querySelector('dialog#ProductQuickviewModal');
        
        if (!quickviewModal) {
            console.error('Nem található a dialog#ProductQuickviewModal!');
            return;
        }

        if (quickviewModal.parentNode !== document.body) {
            document.body.appendChild(quickviewModal);
        }

        try {
            quickviewModal.querySelector('#QuickviewTitle').textContent = product.title;
            quickviewModal.querySelector('#QuickviewPrice').textContent = formatFt(product.price / 100);

            const descriptionContainer = quickviewModal.querySelector('#QuickviewDescription');
            if (product.description) {
                const rawText = product.description.replace(/<[^>]*>?/gm, '\n');
                const highlightsHTML = rawText.split('\n').map(p => p.trim()).filter(p => p !== '').map(p => `<li>${p}</li>`).join('');
                descriptionContainer.innerHTML = `<ul>${highlightsHTML}</ul>`;
            } else {
                descriptionContainer.innerHTML = '';
            }

            const addBtn = quickviewModal.querySelector('#QuickviewAddBtn');
            if (product.variants && product.variants[0]) {
                addBtn.setAttribute('data-variant-id', product.variants[0].id);
                addBtn.textContent = 'Kosárba';
                addBtn.disabled = false;
            } else {
                addBtn.disabled = true;
                addBtn.textContent = 'Nem elérhető';
            }

            const imageList = quickviewModal.querySelector('#QuickviewImageList');
            imageList.innerHTML = ''; 
            if (quickviewSplide) { quickviewSplide.destroy(); quickviewSplide = null; }

            if (product.images && product.images.length > 0) {
                product.images.forEach(imageUrl => {
                    const li = document.createElement('li');
                    li.classList.add('splide__slide');
                    li.innerHTML = `<img src="${imageUrl}" alt="${product.title}">`;
                    imageList.appendChild(li);
                });
                
                // A képek már a listában vannak, a Splide csak diavetítővé
                // alakítja őket. Ezért nyugodtan megvárhatjuk a betöltését:
                // amíg megjön, a látogató a képeket már látja.
                const kepekSzama = product.images.length;
                splideBetoltes().then(function (van) {
                    if (!van) return;
                    const galleryEl = quickviewModal.querySelector('#QuickviewGallery');
                    if (!galleryEl) return;
                    // Közben a látogató zárhatta a modált vagy másik terméket
                    // nyithatott — ilyenkor a lista már máshogy néz ki, és a
                    // régi példányt a fenti destroy() úgyis eltakarította.
                    if (quickviewSplide) return;
                    quickviewSplide = new Splide(galleryEl, { type: 'slide', perPage: 1, gap: 0, arrows: kepekSzama > 1, pagination: kepekSzama > 1 }).mount();
                });
            }

            // A fókusz a panelre kerüljön, ne a bezáró ×-re: megnyitáskor a
            // böngésző alapból az első gombra teszi, és egyes böngészők
            // ilyenkor kirajzolják köré a fókuszjelölést. Billentyűzettel a
            // Tab ugyanúgy végigmegy a gombokon, ott marad a jelölés.
            quickviewModal.setAttribute('tabindex', '-1');

            if (typeof quickviewModal.showModal === 'function') {
                quickviewModal.showModal();
                quickviewModal.focus();
            } else {
                quickviewModal.setAttribute('open', '');
            }
            document.documentElement.style.overflow = 'hidden';
            
            quickviewModal.addEventListener('click', function(event) {
                if (event.target === quickviewModal) closeQuickview();
            }, { once: true });

        } catch (err) {
            console.error('Hiba a QuickView renderelésekor:', err);
        }
    }

    function closeQuickview() {
        const quickviewModal = document.querySelector('dialog#ProductQuickviewModal');
        if (quickviewModal) {
            if (typeof quickviewModal.close === 'function' && quickviewModal.hasAttribute('open')) {
                quickviewModal.close();
            } else {
                quickviewModal.removeAttribute('open');
            }
            document.documentElement.style.overflow = '';
        }
    }

    document.addEventListener('click', async (e) => {
        if (e.target.closest('[data-close-upsell]')) {
            csukdBeAKoztest();
            // Ha valami mégis bennhagyta a görgetészárat, itt vesszük le.
            // Muszáj a fiók nyitása ELŐTT: a téma a nyitáskori scrollY-t
            // jegyzi meg, és záráskor oda görget vissza.
            olddFelABennragadtGorgeteszarat();

            // A "Tovább a kosárhoz" gomb ezen az ágon jön be, csak visz egy
            // data-open-cart-drawer jelzést is. A setTimeout nem babona:
            // előbb hadd tűnjön el ez az ablak, mert a téma fiókja saját
            // görgetészárat tesz a body-ra, és a kettő összeakad.
            if (e.target.closest('[data-open-cart-drawer]')) {
                setTimeout(nyisdMegAKosarFiokot, 0);
            }
            return;
        }

        if (e.target.closest('[data-close-quickview]')) {
            closeQuickview();
            return;
        }

        const quickviewTrigger = e.target.closest('.product-quickview-open');
        if (quickviewTrigger) {
            e.preventDefault();
            const productHandle = quickviewTrigger.getAttribute('data-product-handle');
            if (!productHandle) return;

            const originalText = quickviewTrigger.textContent;
            if (quickviewTrigger.textContent.trim()) quickviewTrigger.textContent = 'Töltés...';
            quickviewTrigger.style.opacity = '0.5';

            const rootUrl = window.Shopify?.routes?.root || '/';
            const fetchUrl = rootUrl.endsWith('/') ? `${rootUrl}products/${productHandle}.js` : `${rootUrl}/products/${productHandle}.js`;

            fetch(fetchUrl)
                .then(response => {
                    if (!response.ok) throw new Error('Hiba a betöltéskor');
                    return response.json();
                })
                .then(product => {
                    showQuickview(product);
                })
                .catch(err => {
                    console.error('QuickView betöltési hiba:', err);
                    if (quickviewTrigger.textContent.trim()) quickviewTrigger.textContent = 'Hiba';
                })
                .finally(() => {
                    setTimeout(() => {
                        if (quickviewTrigger.textContent.trim()) quickviewTrigger.textContent = originalText;
                        quickviewTrigger.style.opacity = '1';
                    }, 1000);
                });
            return;
        }

        // --- ÚJ: PAPIER STÍLUSÚ KOSÁR LOGIKA AZ UPSELL ABLAKBAN ---
        
        // 1. Alap Kosárba gomb megnyomása (Upsell ablakban)
        const upsellBtn = e.target.closest('.btn-upsell-add');
        if (upsellBtn) {
            e.preventDefault();
            const variantId = upsellBtn.getAttribute('data-variant-id');
            if (!variantId) return;

            upsellBtn.textContent = 'Hozzáadás...';
            upsellBtn.disabled = true;

            try {
                await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest', 'X-Brinuti-Upsell': 'true' },
                    body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
                });
                
                if (typeof updateFreeShippingBar === 'function') updateFreeShippingBar();
                
                // UX Átmenet: Elrejtjük a gombot, megmutatjuk a mennyiségválasztót és a zöld bannert
                const actionArea = upsellBtn.closest('.upsell-action-area');
                const card = upsellBtn.closest('.upsell-card');
                
                upsellBtn.style.display = 'none';
                upsellBtn.textContent = 'Kosárba';
                upsellBtn.disabled = false;
                
                const qtyContainer = actionArea.querySelector('.upsell-qty-container');
                if(qtyContainer) {
                    qtyContainer.style.display = 'flex';
                    qtyContainer.querySelector('.upsell-qty-input').value = 1;
                }
                
                const banner = card.querySelector('.upsell-added-banner');
                if(banner) {
                    banner.style.display = 'block';
                    banner.querySelector('.upsell-added-text').innerText = '✓ 1 a kosárban';
                }

                await frissitsdAKosarFeluletet();

            } catch (err) {
                upsellBtn.textContent = 'Hiba történt';
                setTimeout(() => { upsellBtn.textContent = 'Kosárba'; upsellBtn.disabled = false; }, 2000);
            }
            return;
        }

        // 2. Módosított QuickView gomb logika (csak a felugró ablakban)
        const quickviewAddBtn = e.target.closest('.btn-quickview-add');
        if (quickviewAddBtn) {
            e.preventDefault();
            const variantId = quickviewAddBtn.getAttribute('data-variant-id');
            if (!variantId) return;

            const originalText = quickviewAddBtn.textContent;
            quickviewAddBtn.textContent = 'Hozzáadás...';
            quickviewAddBtn.disabled = true;

            try {
                await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest', 'X-Brinuti-Upsell': 'true' },
                    body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
                });
                
                quickviewAddBtn.textContent = 'Hozzáadva ✓';
                quickviewAddBtn.style.backgroundColor = '#4CAF50'; 
                quickviewAddBtn.style.color = '#fff';
                quickviewAddBtn.style.borderColor = '#4CAF50';
                quickviewAddBtn.disabled = false;
                
                if (typeof updateFreeShippingBar === 'function') updateFreeShippingBar();
                
                // Mivel az upsell kártyán megváltozott a gomb, ott is frissítjük a nézetet a háttérben!
                const linkedUpsellBtn = document.querySelector(`.btn-upsell-add[data-variant-id="${variantId}"]`);
                if (linkedUpsellBtn) {
                    const actionArea = linkedUpsellBtn.closest('.upsell-action-area');
                    const card = linkedUpsellBtn.closest('.upsell-card');
                    linkedUpsellBtn.style.display = 'none';
                    const qtyContainer = actionArea.querySelector('.upsell-qty-container');
                    if(qtyContainer) { qtyContainer.style.display = 'flex'; qtyContainer.querySelector('.upsell-qty-input').value = 1; }
                    const banner = card.querySelector('.upsell-added-banner');
                    if(banner) { banner.style.display = 'block'; banner.querySelector('.upsell-added-text').innerText = '✓ 1 a kosárban'; }
                }

                await frissitsdAKosarFeluletet();

                setTimeout(() => { closeQuickview(); }, 1500);
                
            } catch (err) {
                quickviewAddBtn.textContent = 'Hiba történt';
                setTimeout(() => { quickviewAddBtn.textContent = originalText; quickviewAddBtn.disabled = false; }, 2000);
            }
            return;
        }

        // 3. Plusz gomb (+) kattintás
        const plusBtn = e.target.closest('.upsell-qty-plus');
        if (plusBtn) {
            e.preventDefault();
            const variantId = plusBtn.getAttribute('data-variant-id');
            const container = plusBtn.closest('.upsell-qty-container');
            const input = container.querySelector('.upsell-qty-input');
            const card = plusBtn.closest('.upsell-card');

            const elozoErtek = parseInt(input.value) || 1;
            let newVal = elozoErtek + 1;
            input.value = newVal;
            card.querySelector('.upsell-added-text').innerText = `✓ ${newVal} a kosárban`;

            /* A számláló ELŐRE mutatja az új darabszámot, hogy ne legyen
               várakozás. Ha a kosárra írás mégis elbukik, vissza kell állítani,
               különben a vásárló olyan darabszámot lát, ami nincs a kosárban.

               2026-09-23: eddig sem ok-ellenőrzés, sem catch nem volt a láncon.
               Sűrű kattintgatás után a Shopify 429-cel válaszolt, a kosár nem
               változott, a kártyán viszont ott maradt a megnövelt szám — a
               böngésző naplójában pedig egy elkapatlan „Failed to fetch". */
            const allitsdVisszaASzamlalot = function () {
                input.value = elozoErtek;
                const szoveg = card.querySelector('.upsell-added-text');
                if (szoveg) szoveg.innerText = `✓ ${elozoErtek} a kosárban`;
            };

            // Hozzáadás a kosárhoz a háttérben
            fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest', 'X-Brinuti-Upsell': 'true' },
                body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
            }).then(function (valasz) {
                if (!valasz.ok) throw new Error('kosárba írás: ' + valasz.status);
                if (typeof updateFreeShippingBar === 'function') updateFreeShippingBar();
                return frissitsdAKosarFeluletet();
            }).catch(function (hiba) {
                console.error('Nem sikerült a darabszám növelése:', hiba);
                allitsdVisszaASzamlalot();
            });
            
            return;
        }

        // 4. Mínusz gomb (-) kattintás
        const minusBtn = e.target.closest('.upsell-qty-minus');
        if (minusBtn) {
            e.preventDefault();
            const variantId = minusBtn.getAttribute('data-variant-id');
            const actionArea = minusBtn.closest('.upsell-action-area');
            const container = minusBtn.closest('.upsell-qty-container');
            const input = container.querySelector('.upsell-qty-input');
            const card = minusBtn.closest('.upsell-card');

            const elozoErtek = parseInt(input.value) || 1;
            let newVal = elozoErtek - 1;
            const addGomb = actionArea.querySelector('.btn-upsell-add');
            const banner = card.querySelector('.upsell-added-banner');

            if (newVal <= 0) {
                // Ha nullára viszi, eltüntetjük a számolót és visszahozzuk a "Kosárba" gombot
                container.style.display = 'none';
                if (addGomb) addGomb.style.display = 'block';
                if (banner) banner.style.display = 'none';
                input.value = 1; // reseteljük a hátteret
            } else {
                input.value = newVal;
                card.querySelector('.upsell-added-text').innerText = `✓ ${newVal} a kosárban`;
            }

            /* Ugyanaz a helyreállítás, mint a plusz gombnál: a kártya már a
               csökkentett állapotot mutatja, ezért ha a kosárra írás elbukik,
               vissza kell tenni a számlálót. A nullára vitt kártyánál a
               "Kosárba" gombot is vissza kell rejteni (2026-09-23). */
            const allitsdVisszaASzamlalot = function () {
                input.value = elozoErtek;
                container.style.display = 'flex';
                if (addGomb) addGomb.style.display = 'none';
                if (banner) {
                    banner.style.display = 'block';
                    const szoveg = banner.querySelector('.upsell-added-text');
                    if (szoveg) szoveg.innerText = `✓ ${elozoErtek} a kosárban`;
                }
            };

            // Eltávolítás a kosárból (lekérdezzük a kosarat, megkeressük a sort, csökkentjük 1-el)
            fetch('/cart.js')
                .then(function (res) {
                    /* Ok-ellenőrzés nélkül a 429-es válasz HTML törzsén hasalt el
                       a res.json(), és a hiba elkapatlan maradt. */
                    if (!res.ok) throw new Error('kosár lekérése: ' + res.status);
                    return res.json();
                })
                .then(function (cart) {
                    const item = cart.items.find(i => i.variant_id == variantId);
                    if (!item) return null;
                    return fetch('/cart/change.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest', 'X-Brinuti-Upsell': 'true' },
                        body: JSON.stringify({ id: variantId.toString(), quantity: item.quantity - 1 })
                    }).then(function (valasz) {
                        if (!valasz.ok) throw new Error('kosár módosítása: ' + valasz.status);
                        return valasz;
                    });
                })
                .then(function () {
                    if (typeof updateFreeShippingBar === 'function') updateFreeShippingBar();
                    return frissitsdAKosarFeluletet();
                })
                .catch(function (hiba) {
                    console.error('Nem sikerült a darabszám csökkentése:', hiba);
                    allitsdVisszaASzamlalot();
                });
                
            return;
        }
    });

    document.addEventListener('change', (e) => {
        if (e.target.id === 'BundleCheckbox') {
            const bundleDetails = document.getElementById('BundleDetailsContainer');

            // A kiegészítők doboza (ajándékdoboz) csomag mellett is látszik,
            // és a bepipált tételek megmaradnak: a kettő nem zárja ki egymást.
            if (e.target.checked) {
                if (bundleDetails) bundleDetails.style.display = 'block';
            } else {
                if (bundleDetails) bundleDetails.style.display = 'none';
            }
        }
    });

    let cartImages = [];
    let currentImageIndex = 0;

    /* „Pont így fog kinézni, élőben is” + valódi Google-értékelés a kép
       alatt (2026-10-16, a tulaj kérése): a vásárló attól tart, hogy a kész
       napló nem ilyen lesz. A mondatok 5 csillagos Google-értékelésekből
       vannak (Trustindex), csak a helyesírásukat igazítottuk. Egyszerre
       EGY látszik, a vásárló lapozza (nyilakkal vagy húzással) — magától
       nem vált, mert az ugráltatta az ablakot. A doboz magassága fix (két
       sor), így lapozáskor semmi nem mozdul el. */
    const ZOOM_VELEMENYEK = [
        { szoveg: 'Pontosan olyat kaptam, amilyet készítettem a honlapon.', nev: 'Szilvia N.' },
        { szoveg: 'Teljesen úgy néz ki, mint a képen.', nev: 'Beatrix M.' },
        { szoveg: 'Nagyon szép, olyan, mint a tervezetben.', nev: 'Istvánné A.' },
        { szoveg: 'Tényleg olyan, amilyen a képeken.', nev: 'Zsuzsa N.' },
        { szoveg: 'Azt kaptuk, amit előzetesben kaptunk.', nev: 'Bence Cs.' },
        { szoveg: 'Azt kaptam, amit rendeltem.', nev: 'Gabriella B.' },
        { szoveg: 'Pont olyan, amilyenre gondoltam.', nev: 'Edit H.' }
    ];
    let zoomVelemenyIdx = 0;
    function zoomVelemenyRajzol() {
        const hely = document.getElementById('ZoomVelemeny');
        if (!hely) return;
        const n = ZOOM_VELEMENYEK.length;
        zoomVelemenyIdx = ((zoomVelemenyIdx % n) + n) % n;
        const v = ZOOM_VELEMENYEK[zoomVelemenyIdx];
        hely.querySelector('[data-vel-szoveg]').textContent = '„' + v.szoveg + '”';
        hely.querySelector('[data-vel-nev]').textContent = v.nev + ' · Google-értékelés · ' + (zoomVelemenyIdx + 1) + '/' + n;
    }
    function zoomVelemenyKeszit() {
        const hely = document.getElementById('ZoomVelemeny');
        if (!hely || hely.__kesz) return;
        hely.__kesz = true;
        hely.innerHTML =
            '<button type="button" class="brinuti-zoom-velemeny__lep" data-vel-lep="-1" aria-label="Előző értékelés">&#8249;</button>' +
            '<div class="brinuti-zoom-velemeny__test">' +
            '<span class="brinuti-zoom-velemeny__csillag" role="img" aria-label="5 csillag">★★★★★</span>' +
            '<blockquote data-vel-szoveg></blockquote>' +
            '<figcaption data-vel-nev></figcaption></div>' +
            '<button type="button" class="brinuti-zoom-velemeny__lep" data-vel-lep="1" aria-label="Következő értékelés">&#8250;</button>';
        hely.addEventListener('click', (e) => {
            const g = e.target.closest('[data-vel-lep]');
            if (!g) return;
            zoomVelemenyIdx += Number(g.getAttribute('data-vel-lep'));
            zoomVelemenyRajzol();
        });
        // Telefonon vízszintes húzással is lapozható.
        let x0 = null, y0 = null;
        hely.addEventListener('touchstart', (e) => { const t = e.touches[0]; x0 = t.clientX; y0 = t.clientY; }, { passive: true });
        hely.addEventListener('touchend', (e) => {
            if (x0 === null) return;
            const t = e.changedTouches[0], dx = t.clientX - x0, dy = t.clientY - y0;
            x0 = null;
            if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { zoomVelemenyIdx += dx < 0 ? 1 : -1; zoomVelemenyRajzol(); }
        }, { passive: true });
        zoomVelemenyRajzol();
    }

    function createZoomGalleryModal() {
        if (document.getElementById('CartImageZoomModal')) return;
        const modalHtml = `
            <dialog id="CartImageZoomModal" style="padding:0; margin:0; border:none; width:100vw; height:100vh; max-width:100vw; max-height:100vh; background: #faf9f6; z-index: 2147483647;">
                <div style="width: 100%; height: 100%; display: flex; flex-direction: column; justify-content: center; align-items: center; position: relative;">
                    <button id="CloseZoomModal" aria-label="Bezárás" style="position: absolute; top: 6px; right: 8px; font-size: 26px; cursor: pointer; color: #000; background: none; border: none; padding: 6px 8px; line-height: 1; z-index: 10;">&times;</button>
                    <p id="ZoomFejlec" class="brinuti-zoom-fejlec">Pont így fog kinézni, élőben is<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="12" y1="4" x2="12" y2="20"/><polyline points="5 13 12 20 19 13"/></svg></p>
                    <div style="position: relative; width: 100%; display: flex; justify-content: center; align-items: center;">
                        <button id="PrevZoom" style="position: absolute; left: 20px; background: none; border: none; font-size: 50px; cursor: pointer; color: #000; padding: 20px;">&#8249;</button>
                        <img id="ZoomedImage" src="" alt="Preview" style="max-width: 85%; max-height: 80vh; object-fit: contain; box-shadow: 0 10px 40px rgba(0,0,0,0.08); border-radius: 4px;">
                        <div id="ZoomElo" style="display:none; position: relative; width: min(85vw, 80vh); height: min(85vw, 80vh); box-shadow: 0 10px 40px rgba(0,0,0,0.08); border-radius: 4px; overflow: hidden;"></div>
                        <button id="NextZoom" style="position: absolute; right: 20px; background: none; border: none; font-size: 50px; cursor: pointer; color: #000; padding: 20px;">&#8250;</button>
                    </div>
                    <figure id="ZoomVelemeny" class="brinuti-zoom-velemeny" aria-live="polite"></figure>
                    <div id="ZoomCounter" hidden></div>
                    <div id="ZoomAdat" class="brinuti-zoom-adat" hidden></div>
                    <button type="button" id="ZoomVissza" class="brinuti-zoom-vissza">Vissza a kosárba</button>
                </div>
            </dialog>
        `;
        document.body.insertAdjacentHTML('beforeend', modalHtml);
        document.getElementById('CloseZoomModal').addEventListener('click', () => document.getElementById('CartImageZoomModal').close());
        /* 2026-10-16 (a tulaj kérése): jól látható „Vissza a kosárba” gomb. Eddig
           a félig átlátszó háttéren a mögötte lévő fiók „Tovább a pénztárhoz”
           gombja halványan átlátszott, de nem lehetett megnyomni. Ha a vásárló
           belívet vagy szalagot váltott, a gomb „Változtatások mentése” lesz:
           megvárja, amíg a mentés a kosársorra kiér, és csak utána zár. */
        document.getElementById('ZoomVissza').addEventListener('click', zoomVisszaKattint);
        document.getElementById('CartImageZoomModal').addEventListener('close', () => { zoomValtozott = false; zoomGombFelirat(); });
        zoomVelemenyKeszit();
        document.getElementById('PrevZoom').addEventListener('click', () => navigateZoom(-1));
        document.getElementById('NextZoom').addEventListener('click', () => navigateZoom(1));
    }

    function updateZoomContent() {
        if (cartImages.length === 0) return;
        const imgElement = document.getElementById('ZoomedImage');
        const eloKeret = document.getElementById('ZoomElo');
        const bejegyzes = cartImages[currentImageIndex];
        const kepCime = typeof bejegyzes === 'string' ? bejegyzes : (bejegyzes.kep || '');
        const tervAzon = typeof bejegyzes === 'string' ? '' : (bejegyzes.azon || '');
        const buAzon = typeof bejegyzes === 'string' ? '' : (bejegyzes.bu || '');

        /* Az előnézeti keret alapból négyzet; az ajándékutalvány előlapja A5
           fekvő (a 210×297-es ív alsó fele, 1055×745), ezért ott másik a mérete. */
        if (eloKeret) {
            eloKeret.style.width = 'min(85vw, 80vh)';
            eloKeret.style.height = 'min(85vw, 80vh)';
            eloKeret.style.aspectRatio = '';
        }
        if (eloKeret && buAzon && window.BrinutiUtalvanyNagy) {
            eloKeret.style.width = 'min(88vw, 880px, calc(78vh * 1055 / 745))';
            eloKeret.style.height = 'auto';
            eloKeret.style.aspectRatio = '1055 / 745';
            eloKeret.style.display = 'block';
            if (window.BrinutiUtalvanyNagy(eloKeret, buAzon)) {
                imgElement.style.display = 'none';
                zoomAdatsor(bejegyzes);
                document.getElementById('PrevZoom').style.visibility = 'hidden';
                document.getElementById('NextZoom').style.visibility = 'hidden';
                return;
            }
            eloKeret.style.width = 'min(85vw, 80vh)';
            eloKeret.style.height = 'min(85vw, 80vh)';
            eloKeret.style.aspectRatio = '';
            eloKeret.style.display = 'none';
        }

        /* Ha a vásárló terve a kosárba tételkor elmentődött (lásd a fájl végén
           a kosárbeli élő előnézetet), akkor NEM a Teeinblue kész képét
           mutatjuk: azon rajta van a nyilas magyarázó réteg. A mentett terv a
           2. mockup látványa, a vásárló szövegével, fotójával, színeivel. */
        const terv = tervAzon && window.brinutiElonezet && window.brinutiElonezet.olvasd(tervAzon);
        const burok = terv && window.brinutiElonezet.keszitsBurkot(terv);
        if (eloKeret && burok) {
            eloKeret.innerHTML = '';
            eloKeret.appendChild(burok);
            eloKeret.style.display = 'block';
            imgElement.style.display = 'none';
            window.brinutiElonezet.meretezd(eloKeret);
            zoomAdatsor(bejegyzes);
            document.getElementById('PrevZoom').style.visibility = 'hidden';
            document.getElementById('NextZoom').style.visibility = 'hidden';
            return;
        }
        if (eloKeret) { eloKeret.style.display = 'none'; eloKeret.innerHTML = ''; }
        imgElement.style.display = '';

        let highResUrl = kepCime
            .replace(/_[0-9]+x[0-9]+(\.[a-zA-Z0-9]+)/g, '$1')
            .replace(/_crop_[a-z]+(\.[a-zA-Z0-9]+)/g, '$1');
            
        try {
            let urlObj = new URL(highResUrl, window.location.origin);
            urlObj.searchParams.set('width', '1600'); 
            urlObj.searchParams.delete('crop');       
            imgElement.src = urlObj.toString();
        } catch (e) {
            imgElement.src = highResUrl;
        }

        zoomAdatsor(bejegyzes);
        document.getElementById('PrevZoom').style.visibility = 'hidden';
        document.getElementById('NextZoom').style.visibility = 'hidden';
    }

    /* Belív és szalag a kosár-előnézet alatt (2026-10-15, a tulaj kérése).
       A kosársor tulajdonságaiból olvassuk; a kulcs kampányonként más
       („Napló típusa” / „Válaszd ki a napló típusát!”), ezért a kulcs
       szavára illesztünk. Mindkettő ITT HELYBEN módosítható: a gyártás a
       Shopify-rendelés tulajdonságaiból dolgozik (a tulaj megerősítette),
       ezért a választás egyszerűen a kosársor tulajdonságát írja át
       (/cart/change.js), a többi tulajdonság változatlan marad. Az értékek
       pontosan a Teeinblue opcióinak szövegei, ahogy a rendelésekben is
       szerepelnek. */
    const ZOOM_TINTA = '#2c2c2c';
    const zoomLap = (belso) => `<svg viewBox="0 0 30 40" width="18" height="24" aria-hidden="true" focusable="false"><rect x="1" y="1" width="28" height="38" rx="2.5" fill="#fff" stroke="${ZOOM_TINTA}" stroke-width="1.3"/>${belso}</svg>`;
    const zoomVonal = (y) => `<line x1="5" x2="25" y1="${y}" y2="${y}" stroke="${ZOOM_TINTA}" stroke-width=".9"/>`;
    const ZOOM_BELIV = [
        { minta: /önismereti/i, nev: 'Önismereti', le: 'Napi kérdések', kepek: ['beliv-onismereti-10', 'beliv-onismereti-11'], ertek: 'BRINUTI - önismereti', ikon: zoomLap(`<path d="M15 11.5c-1.6-2.3-5-1.2-4.3 1.2.5 1.6 4.3 4 4.3 4s3.8-2.4 4.3-4c.7-2.4-2.7-3.5-4.3-1.2z" fill="none" stroke="${ZOOM_TINTA}" stroke-width="1"/>${zoomVonal(22)}${zoomVonal(27)}${zoomVonal(32)}`) },
        { minta: /határidő/i, nev: 'Határidőnapló', le: '2 oldalon 7 nap', kepek: ['beliv-hataridonaplo-10', 'beliv-hataridonaplo-11'], ertek: 'határidőnapló (2027)', ikon: zoomLap(`<line x1="5" x2="25" y1="8" y2="8" stroke="${ZOOM_TINTA}" stroke-width="1.2"/>${[13, 18, 23, 28, 33].map(zoomVonal).join('')}<line x1="11" x2="11" y1="10" y2="36" stroke="${ZOOM_TINTA}" stroke-width=".9"/>`) },
        { minta: /időpont/i, nev: 'Időpontbeosztó', le: 'Órás, 2 oldalon 7 nap', kepek: ['beliv-idopontbeoszto-10', 'beliv-idopontbeoszto-11'], ertek: 'Időpontbeosztó (2027)', ikon: zoomLap([9, 13, 17, 21, 25, 29, 33].map(y => `<line x1="5" x2="8" y1="${y}" y2="${y}" stroke="${ZOOM_TINTA}" stroke-width="1.2"/><line x1="10" x2="25" y1="${y}" y2="${y}" stroke="${ZOOM_TINTA}" stroke-width=".6"/>`).join('')) },
        { minta: /pontrácsos|pontozott/i, nev: 'Pontrácsos', le: 'Rajzhoz is', kepek: ['beliv-pontracsos-03', 'beliv-pontracsos-04'], ertek: 'pontrácsos', ikon: zoomLap([8, 13, 18, 23, 28, 33].map(y => [6, 10.5, 15, 19.5, 24].map(x => `<circle cx="${x}" cy="${y}" r=".9" fill="${ZOOM_TINTA}"/>`).join('')).join('')) },
        { minta: /vonalas/i, nev: 'Vonalas', le: 'Klasszikus', kepek: ['beliv-vonalas-03', 'beliv-vonalas-04'], ertek: 'vonalas', ikon: zoomLap([9, 14, 19, 24, 29, 34].map(zoomVonal).join('')) },
        { minta: /^\s*(üres|sima)\b/i, nev: 'Sima', le: 'Üres lapok', kepek: ['beliv-sima-03', 'beliv-sima-04'], ertek: 'üres', ikon: zoomLap('') }
    ];
    const ZOOM_SZALAG = [['kék', '#a3d1eb'], ['szürke', '#a9a6aa'], ['barna', '#af8367'], ['piros', '#e1081a'], ['bézs', '#d9a87f'], ['fekete', '#17151a'], ['rózsaszín', '#f6c4d9']];
    const zoomEsc = (t) => String(t).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
    const zoomNagy = (t) => { t = String(t || '').trim(); return t.charAt(0).toUpperCase() + t.slice(1); };
    let zoomAktiv = null;      // a megnyitott kosársor bejegyzése
    let zoomNyitott = '';      // melyik választó van kinyitva ('beliv' / 'szalag')
    let zoomLapozott = '';     // melyik belívbe lapoz bele (a lista alatt két oldala látszik)
    let zoomValtozott = false; // váltott-e belívet / szalagot ebben a megnyitásban
    let zoomMentes = null;     // a folyamatban lévő mentés (Promise)
    function zoomGombFelirat(szoveg) {
        const g = document.getElementById('ZoomVissza');
        if (!g) return;
        g.textContent = szoveg || (zoomValtozott ? 'Változtatások mentése' : 'Vissza a kosárba');
        g.disabled = !!szoveg;
    }
    async function zoomVisszaKattint() {
        const dialog = document.getElementById('CartImageZoomModal');
        if (zoomMentes) {
            zoomGombFelirat('Mentés…');
            const jo = await zoomMentes;
            zoomGombFelirat();
            if (!jo) return; // a hibaüzenet a dobozban látszik, az ablak nyitva marad
        }
        if (dialog && dialog.open) dialog.close();
    }
    /* A belív-oldalak a téma assetjei között vannak; a címüket ennek a
       szkriptnek a saját címéből képezzük (ugyanaz a mappa). */
    function zoomAssetCim(nev, szel) {
        const sajat = document.querySelector('script[src*="/brinuti-cro.js"]');
        const alap = sajat ? sajat.src.split('/brinuti-cro.js')[0] + '/' : '/assets/';
        return alap + nev + '.jpg?width=' + (szel || 400);
    }

    /* Belelapozáskor a kis oldalra koppintva az oldal nagyban nyílik meg
       (a tulaj kérése), ott egy újabb koppintás tovább nagyít. A nagy nézet
       a dialóguson BELÜL van, különben a dialógus fedné. */
    let zoomNagyLista = [];
    let zoomNagyIndex = 0;
    function zoomNagyNyit(lista, index) {
        const dialog = document.getElementById('CartImageZoomModal');
        if (!dialog) return;
        let nagy = document.getElementById('ZoomNagyLap');
        if (!nagy) {
            nagy = document.createElement('div');
            nagy.id = 'ZoomNagyLap';
            nagy.className = 'brinuti-nagylap';
            nagy.innerHTML =
                '<div class="brinuti-nagylap__keret" data-nagylap-keret><img alt="" data-nagylap-kep></div>' +
                '<button type="button" class="brinuti-nagylap__zar" data-nagylap-zar aria-label="Bezárás">&times;</button>' +
                '<button type="button" class="brinuti-nagylap__nyil brinuti-nagylap__nyil--bal" data-nagylap-lep="-1" aria-label="Előző oldal">&#8249;</button>' +
                '<button type="button" class="brinuti-nagylap__nyil brinuti-nagylap__nyil--jobb" data-nagylap-lep="1" aria-label="Következő oldal">&#8250;</button>' +
                '<p class="brinuti-nagylap__sugo">Koppints a lapra a nagyításhoz</p>';
            dialog.appendChild(nagy);
            nagy.addEventListener('click', (e) => {
                if (e.target.closest('[data-nagylap-zar]')) { zoomNagyZar(); return; }
                const lep = e.target.closest('[data-nagylap-lep]');
                if (lep) { zoomNagyIndex = (zoomNagyIndex + Number(lep.getAttribute('data-nagylap-lep')) + zoomNagyLista.length) % zoomNagyLista.length; zoomNagyRajzol(); return; }
                if (e.target.closest('[data-nagylap-kep]')) nagy.classList.toggle('is-nagyitva');
            });
            // Az Escape előbb csak a nagy nézetet zárja, a dialógust nem.
            dialog.addEventListener('cancel', (e) => {
                if (!nagy.hidden) { e.preventDefault(); zoomNagyZar(); }
            });
        }
        zoomNagyLista = lista;
        zoomNagyIndex = index;
        nagy.hidden = false;
        zoomNagyRajzol();
    }
    function zoomNagyRajzol() {
        const nagy = document.getElementById('ZoomNagyLap');
        if (!nagy) return;
        nagy.classList.remove('is-nagyitva');
        nagy.querySelector('[data-nagylap-kep]').src = zoomNagyLista[zoomNagyIndex] || '';
        nagy.querySelectorAll('[data-nagylap-lep]').forEach(g => { g.hidden = zoomNagyLista.length < 2; });
        const keret = nagy.querySelector('[data-nagylap-keret]');
        keret.scrollTop = 0; keret.scrollLeft = 0;
    }
    function zoomNagyZar() {
        const nagy = document.getElementById('ZoomNagyLap');
        if (nagy) { nagy.hidden = true; nagy.classList.remove('is-nagyitva'); }
    }

    function zoomTulajdonsagok(bejegyzes) {
        let tul = {};
        try { tul = JSON.parse((bejegyzes && bejegyzes.props) || '{}') || {}; } catch (e) { tul = {}; }
        // A Liquid `properties | json` [kulcs, érték] párok listáját adja.
        if (Array.isArray(tul)) tul = tul.reduce((o, p) => { if (Array.isArray(p)) o[p[0]] = p[1]; return o; }, {});
        let belivKulcs = '', szalagKulcs = '';
        Object.keys(tul).forEach(k => {
            if (k.charAt(0) === '_') return;
            if (!belivKulcs && /típus|belív|belső/i.test(k)) belivKulcs = k;
            if (!szalagKulcs && /szalag/i.test(k)) szalagKulcs = k;
        });
        return { tul, belivKulcs, szalagKulcs };
    }

    function zoomAdatsor(bejegyzes) {
        const hely = document.getElementById('ZoomAdat');
        if (!hely) return;
        if (bejegyzes !== zoomAktiv) { zoomNyitott = ''; zoomLapozott = ''; zoomNagyZar(); }
        zoomAktiv = bejegyzes || null;
        const { tul, belivKulcs, szalagKulcs } = zoomTulajdonsagok(bejegyzes);
        // A nagy képen a sor szalagszíne látszik (assets/brinuti-szalag-mockup.js);
        // váltáskor azonnal, a mentés megvárása nélkül.
        const eloKeret = document.getElementById('ZoomElo');
        if (eloKeret) {
            if (szalagKulcs && tul[szalagKulcs]) eloKeret.setAttribute('data-brinuti-szalag', String(tul[szalagKulcs]));
            else eloKeret.removeAttribute('data-brinuti-szalag');
        }
        const szerk = !!(bejegyzes && bejegyzes.kulcs);
        const sorok = [];
        if (belivKulcs) {
            const ertek = String(tul[belivKulcs] || '');
            const b = ZOOM_BELIV.find(x => x.minta.test(ertek));
            /* Csak a napló belívét lehet itt cserélni (a füzeteké más
               választék lehet), és csak ha a mostani értéket is ismerjük. */
            const belivSzerk = /napló/i.test(belivKulcs) && !!b;
            sorok.push(`<div class="brinuti-zoom-adat__sor"><span class="brinuti-zoom-adat__cimke">Ilyen lapok lesznek benne:</span>${b ? b.ikon : ''}<b>${zoomEsc(b ? b.nev : ertek)}</b>` +
                (szerk && belivSzerk ? `<button type="button" class="brinuti-zoom-adat__mod" data-zoom-nyit="beliv" aria-expanded="${zoomNyitott === 'beliv'}">${zoomNyitott === 'beliv' ? 'Kész' : 'Módosítom'}</button>` : '') + '</div>');
            if (szerk && belivSzerk && zoomNyitott === 'beliv') {
                /* Ugyanaz a lista, mint a termékoldal választópaneljén:
                   ikon, név, rövid leírás és „Belelapozok”. */
                sorok.push('<ul class="brinuti-zoom-adat__valaszto brinuti-zoom-adat__lista">' + ZOOM_BELIV.map(x =>
                    `<li class="brinuti-zoom-adat__elem${x === b ? ' is-akt' : ''}">` +
                    `<button type="button" class="brinuti-zoom-adat__lap" data-zoom-beliv="${zoomEsc(x.ertek)}" aria-pressed="${x === b}">${x.ikon}<span class="brinuti-zoom-adat__lapszoveg"><b>${zoomEsc(x.nev)}</b><small>${zoomEsc(x.le)}</small></span></button>` +
                    `<button type="button" class="brinuti-zoom-adat__lapoz" data-zoom-lapoz="${zoomEsc(x.ertek)}" aria-expanded="${zoomLapozott === x.ertek}">${zoomLapozott === x.ertek ? 'Bezárom' : 'Belelapozok'}</button>` +
                    (zoomLapozott === x.ertek ? `<div class="brinuti-zoom-adat__oldalak">${x.kepek.map((k, i) => `<button type="button" class="brinuti-zoom-adat__oldal" data-zoom-oldal="${i}" aria-label="${zoomEsc(x.nev)}: ${i + 1}. minta oldal nagyban"><img src="${zoomAssetCim(k)}" alt="" loading="lazy"></button>`).join('')}<button type="button" class="brinuti-zoom-adat__nagyit" data-zoom-oldal="0"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/><line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/></svg>Nagyítás</button></div>` : '') +
                    '</li>').join('') + '</ul>');
            }
        }
        if (szalagKulcs) {
            const nev = String(tul[szalagKulcs] || '').trim().toLowerCase();
            const sz = ZOOM_SZALAG.find(x => x[0] === nev);
            sorok.push(`<div class="brinuti-zoom-adat__sor"><span class="brinuti-zoom-adat__cimke">Szalag színe:</span>${sz ? `<span class="brinuti-zoom-adat__szalag" style="background:${sz[1]}"></span>` : ''}<b>${zoomEsc(zoomNagy(nev))}</b>` +
                (szerk ? `<button type="button" class="brinuti-zoom-adat__mod" data-zoom-nyit="szalag" aria-expanded="${zoomNyitott === 'szalag'}">${zoomNyitott === 'szalag' ? 'Kész' : 'Módosítom'}</button>` : '') + '</div>');
            if (szerk && zoomNyitott === 'szalag') {
                sorok.push('<div class="brinuti-zoom-adat__valaszto brinuti-zoom-adat__valaszto--szalag" role="radiogroup" aria-label="Szalag színe">' + ZOOM_SZALAG.map(x =>
                    `<button type="button" class="brinuti-zoom-adat__szin${x[0] === nev ? ' is-akt' : ''}" role="radio" aria-checked="${x[0] === nev}" aria-label="${zoomNagy(x[0])}" title="${zoomNagy(x[0])}" data-zoom-szalag="${x[0]}"><span class="brinuti-zoom-adat__szalag" style="background:${x[1]}"></span></button>`).join('') + '</div>');
            }
        }
        hely.innerHTML = sorok.join('') + '<p class="brinuti-zoom-adat__hiba" data-zoom-hiba hidden></p>';
        hely.hidden = !sorok.length;
        if (!hely.__zoomKotve) {
            hely.__zoomKotve = true;
            hely.addEventListener('click', zoomKattint);
        }
    }

    async function zoomKattint(e) {
        const nyit = e.target.closest('[data-zoom-nyit]');
        if (nyit) {
            const mit = nyit.getAttribute('data-zoom-nyit');
            zoomNyitott = zoomNyitott === mit ? '' : mit;
            zoomLapozott = '';
            zoomAdatsor(zoomAktiv);
            return;
        }
        const oldal = e.target.closest('[data-zoom-oldal]');
        if (oldal) {
            const b = ZOOM_BELIV.find(x => x.ertek === zoomLapozott);
            if (b) zoomNagyNyit(b.kepek.map(k => zoomAssetCim(k, 1600)), Number(oldal.getAttribute('data-zoom-oldal')) || 0);
            return;
        }
        const lapoz = e.target.closest('[data-zoom-lapoz]');
        if (lapoz) {
            const mit = lapoz.getAttribute('data-zoom-lapoz');
            zoomLapozott = zoomLapozott === mit ? '' : mit;
            zoomAdatsor(zoomAktiv);
            const uj = document.querySelector('#ZoomAdat .brinuti-zoom-adat__oldalak');
            if (uj) uj.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
            try { if (window.clarity && zoomLapozott) window.clarity('event', 'kosar_beliv_belelapoz'); } catch (x) {}
            return;
        }
        const belivGomb = e.target.closest('[data-zoom-beliv]');
        const szalagGomb = e.target.closest('[data-zoom-szalag]');
        if (!belivGomb && !szalagGomb) return;
        const bejegyzes = zoomAktiv;
        if (!bejegyzes || !bejegyzes.kulcs) return;
        const { tul, belivKulcs, szalagKulcs } = zoomTulajdonsagok(bejegyzes);
        const kulcs = belivGomb ? belivKulcs : szalagKulcs;
        const ertek = belivGomb ? belivGomb.getAttribute('data-zoom-beliv') : szalagGomb.getAttribute('data-zoom-szalag');
        if (!kulcs || String(tul[kulcs] || '') === ertek) { zoomNyitott = ''; zoomAdatsor(bejegyzes); return; }
        const hely = document.getElementById('ZoomAdat');
        hely.classList.add('is-dolgozik');
        const regiProps = bejegyzes.props;
        // Azonnal mutatjuk az új értéket; hiba esetén visszaállítjuk.
        const azonnali = Object.assign({}, tul); azonnali[kulcs] = ertek;
        bejegyzes.props = JSON.stringify(azonnali);
        zoomNyitott = '';
        zoomLapozott = '';
        zoomAdatsor(bejegyzes);
        zoomValtozott = true;
        zoomGombFelirat();
        let mentesVege;
        const mentes = zoomMentes = new Promise(r => { mentesVege = r; });
        let sikerult = false;
        try {
            const sor = await zoomIrdASorra(tul._customization_id, bejegyzes.kulcs, kulcs, ertek);
            bejegyzes.props = JSON.stringify(sor.properties || azonnali);
            bejegyzes.kulcs = sor.key;
            zoomAdatsor(bejegyzes);
            try { if (window.clarity) window.clarity('event', belivGomb ? 'kosar_beliv_modositas' : 'kosar_szalag_modositas'); } catch (x) {}
            sikerult = true;
            // Új szalagszín: a levél- és a pénztárkép is újra elkészül.
            if (szalagGomb && window.brinutiLevelkepUjra) window.brinutiLevelkepUjra(tul._customization_id, ertek);
            await frissitsdAKosarFeluletet();
        } catch (hiba) {
            console.warn('[brinuti] a belív / szalag nem változott:', hiba);
            bejegyzes.props = regiProps;
            zoomAdatsor(bejegyzes);
            const h = document.querySelector('#ZoomAdat [data-zoom-hiba]');
            if (h) { h.textContent = 'Nem sikerült menteni, próbáld újra.'; h.hidden = false; }
        } finally {
            hely.classList.remove('is-dolgozik');
            if (zoomMentes === mentes) zoomMentes = null;
            mentesVege(sikerult);
        }
    }

    /* A kosársor egy tulajdonságának átírása, ellenőrzéssel.
       Ugyanarra a sorra más is ír (a levélbe szánt előnézet címe, a pénztári
       kép másolata) — ezek a saját, pár száz ms-mal korábbi olvasásukkal írnak
       vissza, és így a vásárló választását felülírhatták (mérve 2026-10-15:
       a pirosra állított szalag visszaugrott bézsre). Ezért írás után
       visszaolvassuk a kosarat, és ha az érték nem maradt meg, újra beírjuk;
       csak két egymás utáni jó olvasás után tekintjük késznek. A sort a terv
       azonosítója alapján keressük (a kulcs minden írásnál változik). */
    async function zoomIrdASorra(azon, regiKulcs, kulcs, ertek) {
        const varj = (ms) => new Promise(r => setTimeout(r, ms));
        let jokSzama = 0;
        for (let kor = 0; kor < 7; kor++) {
            const kosar = await kerdLeAKosarat();
            const tetelek = (kosar && kosar.items) || [];
            const sor = (azon && tetelek.find(t => t.properties && t.properties._customization_id === azon)) ||
                tetelek.find(t => t.key === regiKulcs);
            if (!sor) throw new Error('nincs meg a kosársor');
            if (String((sor.properties || {})[kulcs] || '') === ertek) {
                if (++jokSzama >= 2) return sor;
            } else {
                jokSzama = 0;
                const ujTul = Object.assign({}, sor.properties || {});
                ujTul[kulcs] = ertek;
                // A fejléc jelzi a pillanatkép-mentőnek (lent), hogy ez NEM
                // terv-mentés: különben a lapon épp látható (termékoldali,
                // eredeti) tervet írná rá a szerkesztett terv helyére.
                const valasz = await window.fetch('/cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest', 'X-Brinuti-Tulajdonsag': 'true' },
                    body: JSON.stringify({ id: sor.key, quantity: sor.quantity, properties: ujTul })
                });
                // 400/404: közben más írt a sorra (elavult kulcs) — friss olvasással újra.
                if (!valasz.ok && valasz.status !== 400 && valasz.status !== 404 && valasz.status !== 422) {
                    throw new Error('HTTP ' + valasz.status);
                }
            }
            await varj(kor === 0 ? 500 : 1100);
        }
        throw new Error('az érték nem maradt meg');
    }

    /* ÚJRASZERKESZTÉS: a szerkesztő a kosársor MOSTANI szalagját és belívét
       mutassa (2026-10-15). Ha a vásárló a kosár-előnézetben átállította
       őket, az csak a kosársoron él; a Teeinblue a szerkesztőbe a saját,
       régebbi mentését tölti, és mentéskor azzal írta vissza a sort. Ezért
       amikor a szerkesztő megnyílik, a két mezőt a kosársor értékére
       állítjuk — a Teeinblue saját bemenetein át, ahogy a vásárló tenné. Ha
       a vásárló maga nyúl a két mezőhöz, onnantól nem avatkozunk bele. */
    let sajatSzerkesztoKattintas = 0;
    function szerkesztoMezoi(ablak) {
        const mezok = { beliv: null, szalag: null };
        ablak.querySelectorAll('.tee-field').forEach(f => {
            const sel = f.querySelector('select');
            if (sel && Array.prototype.some.call(sel.options, o => /önismereti|vonalas|pontrácsos/i.test(o.text))) mezok.beliv = f;
            else if (/szalag/i.test((f.querySelector('.tee-field__heading') || {}).textContent || '') && f.querySelector('input[type="radio"]')) mezok.szalag = f;
        });
        return mezok;
    }
    function allitsdASzerkesztot(ablak, tul, erintett) {
        const { beliv, szalag } = szerkesztoMezoi(ablak);
        let kesz = true;
        const belivErtek = Object.keys(tul).filter(k => k.charAt(0) !== '_' && /típus|belív|belső/i.test(k)).map(k => String(tul[k] || '').trim())[0];
        const szalagErtek = Object.keys(tul).filter(k => k.charAt(0) !== '_' && /szalag/i.test(k)).map(k => String(tul[k] || '').trim().toLowerCase())[0];
        if (beliv && belivErtek && !erintett.beliv) {
            const sel = beliv.querySelector('select');
            const opcio = Array.prototype.find.call(sel.options, o => o.text.trim().toLowerCase() === belivErtek.toLowerCase());
            if (opcio && sel.value !== opcio.value) {
                sel.value = opcio.value;
                sel.dispatchEvent(new Event('input', { bubbles: true }));
                sel.dispatchEvent(new Event('change', { bubbles: true }));
                kesz = false;
            }
        }
        if (szalag && szalagErtek && !erintett.szalag) {
            const cimke = Array.prototype.find.call(szalag.querySelectorAll('label'), l => {
                const sz = l.querySelector('.tee-clipart-label__text, .sr-only');
                return sz && sz.textContent.trim().toLowerCase() === szalagErtek;
            });
            const be = cimke && (szalag.querySelector('#' + CSS.escape(cimke.getAttribute('for') || '')) || cimke.parentNode.querySelector('input'));
            // A címkére küldött kattintásból a böngésző „valódi” kattintást
            // csinál a rádiógombon — ezt ne vegyük a vásárló érintésének.
            if (cimke && be && !be.checked) { sajatSzerkesztoKattintas = Date.now(); try { be.focus({ preventScroll: true }); } catch (x) {} cimke.click(); kesz = false; }
        }
        return kesz;
    }
    document.addEventListener('click', (e) => {
        const gomb = e.target.closest && e.target.closest('.tee-edit-customization .tee-edit-button, .tee-edit-customization [class*="tee-edit-button"]');
        // A kosár újrarajzolása után a téma helyőrző gombot mutat, ami a
        // valódit PROGRAMBÓL nyomja meg (varjAGombra) — ezért nem csak a
        // vásárló saját kattintását figyeljük. A helyőrzőn nincs azonosító:
        // azt kihagyjuk, a valódi gomb kattintása úgyis megérkezik.
        if (!gomb || gomb.closest('.brinuti-tee-helyorzo')) return;
        const doboz = gomb.closest('.tee-edit-customization');
        const azon = doboz && doboz.getAttribute('data-customization-id');
        if (!azon) return;
        if (Date.now() - (window.__brinutiSzerkNyitas || 0) < 1500) return;
        window.__brinutiSzerkNyitas = Date.now();
        const erintett = { beliv: false, szalag: false };
        const figyelo = (ev) => {
            if (!ev.isTrusted || !ev.target.closest) return;
            if (Date.now() - sajatSzerkesztoKattintas < 300) return;
            const ablak = ev.target.closest('.tee-edit-popup');
            if (!ablak) return;
            const { beliv, szalag } = szerkesztoMezoi(ablak);
            if (beliv && beliv.contains(ev.target)) erintett.beliv = true;
            if (szalag && szalag.contains(ev.target)) erintett.szalag = true;
        };
        document.addEventListener('change', figyelo, true);
        document.addEventListener('click', figyelo, true);
        kerdLeAKosarat().then((kosar) => {
            const sor = ((kosar && kosar.items) || []).find(t => t.properties && t.properties._customization_id === azon);
            if (!sor) return;
            const tul = sor.properties;
            let probak = 0, jok = 0;
            (function nezd() {
                const ablak = document.querySelector('.tee-edit-popup');
                const kesz = ablak && szerkesztoMezoi(ablak).beliv ? allitsdASzerkesztot(ablak, tul, erintett) : false;
                jok = kesz ? jok + 1 : 0;
                // A Teeinblue a mentett tervét kicsit később is visszatöltheti:
                // három egymás utáni rendben lévő kör után engedjük el.
                if (jok >= 3 || ++probak > 40) {
                    setTimeout(() => {
                        document.removeEventListener('change', figyelo, true);
                        document.removeEventListener('click', figyelo, true);
                    }, 60000);
                    return;
                }
                setTimeout(nezd, 400);
            })();
        });
    }, true);

    /* MINTAVÁLASZTÁS UTÁN A KÉP ÉS A VÁLASZTÓ LÁTSZÓDJON (2026-10-16, a tulaj
       kérése). A kosárból nyitott szerkesztőben mintát váltva az ablak a
       tulaj telefonján lejjebb ugrott, a szalagszínhez. Chromiumban nem
       jött elő, ezért az okát nem találgatjuk: a mintára koppintás után az
       ablak tartalmát úgy állítjuk, hogy felül az előnézeti kép, alatta a
       mintaválasztó is látsszon. Ha a vásárló közben maga görget, nem
       avatkozunk bele. */
    function mintaUtanIgazit(ablak) {
        const mezo = ablak.querySelector('.tee-field--template:not(.sr-only)');
        const kep = ablak.querySelector('.tee-gallery');
        const test = mezo && mezo.closest('.tee-dialog-body');
        if (!mezo || !kep || !test || test.scrollHeight <= test.clientHeight) return;
        const t0 = test.getBoundingClientRect().top - test.scrollTop;
        const kepTeteje = kep.getBoundingClientRect().top - t0;
        const mezoAlja = mezo.getBoundingClientRect().bottom - t0;
        let cel = kepTeteje - 8;
        // Ha a kép és a választó együtt nem fér ki, a választó alja legyen lent.
        if (mezoAlja - cel > test.clientHeight) cel = mezoAlja - test.clientHeight + 8;
        cel = Math.max(0, Math.round(cel));
        if (Math.abs(test.scrollTop - cel) > 4) test.scrollTo({ top: cel, behavior: 'smooth' });
    }
    document.addEventListener('click', (e) => {
        if (!e.isTrusted || !e.target.closest) return;
        const ablak = e.target.closest('.tee-edit-popup');
        if (!ablak || !e.target.closest('.tee-field--template')) return;
        let sajat = true;
        const megszakit = () => { sajat = false; };
        ['touchmove', 'wheel'].forEach(t => ablak.addEventListener(t, megszakit, { passive: true, once: true }));
        // A Teeinblue a mezőket újrarajzolja; utána, és a kép betöltése után is.
        [350, 1200].forEach(ms => setTimeout(() => {
            const most = document.querySelector('.tee-edit-popup');
            if (sajat && most) mintaUtanIgazit(most);
        }, ms));
    }, true);

    /* SZÍNVÁLTÁSKOR NE VESSZEN EL A BEÍRT SZÖVEG (2026-10-15).
       A kosárból nyitott Teeinblue-szerkesztőben színt (vagy mintát) váltva a
       szövegmezők kiürültek — mérve akkor, ha a szerkesztőt a termékoldalon
       nyitották meg (ott két Teeinblue-űrlap él egyszerre). Ezért a választó
       megnyomása ELŐTT megjegyezzük a szövegeket, és ha az újrarajzolás után
       egy mező üres vagy más lett, visszaírjuk — a mező saját beállítóján át,
       hogy a Teeinblue (Vue) is tudomást vegyen róla. Ha a vásárló közben
       maga gépel a mezőbe, azt nem bántjuk. */
    function szerkesztoSzovegMezoi(ablak) {
        return Array.prototype.filter.call(ablak.querySelectorAll('.tee-field'), f =>
            f.offsetParent !== null && f.querySelector('textarea, input[type="text"]'));
    }
    function szovegMezoKulcsa(f, i) {
        const h = f.querySelector('.tee-field__heading');
        const cim = h ? h.textContent.replace(/[\s*]+/g, ' ').trim() : '';
        return (cim || 'mezo') + '#' + i;
    }
    function irdBeAMezobe(be, ertek) {
        const proto = be.tagName === 'TEXTAREA' ? HTMLTextAreaElement.prototype : HTMLInputElement.prototype;
        const beallito = Object.getOwnPropertyDescriptor(proto, 'value').set;
        beallito.call(be, ertek);
        be.dispatchEvent(new Event('input', { bubbles: true }));
        be.dispatchEvent(new Event('change', { bubbles: true }));
    }
    /* A vásárló által BEGÉPELT szövegek folyamatosan, mezőnként (cím +
       sorszám szerint). Nem a választó megnyomásakor mentünk: a Teeinblue
       már a lenyomásra (pointerdown) újrarajzolja a mezőket, a kattintás
       idején a régi szöveg már nincs meg (mérve 2026-10-15). */
    let beirtSzovegek = {};
    let szovegOrIdozito = null;
    let szovegOrLeallit = null;
    document.addEventListener('input', (e) => {
        if (!e.isTrusted || !e.target.closest) return;
        const ablak = e.target.closest('.tee-edit-popup');
        const f = e.target.closest('.tee-field');
        if (!ablak || !f) return;
        const i = szerkesztoSzovegMezoi(ablak).indexOf(f);
        if (i >= 0) beirtSzovegek[szovegMezoKulcsa(f, i)] = e.target.value;
    }, true);
    // A szerkesztő megnyitásakor a mezőkben álló (mentett) szöveg az alap.
    function jegyezdFelASzovegeket(ablak) {
        szerkesztoSzovegMezoi(ablak).forEach((f, i) => {
            const be = f.querySelector('textarea, input[type="text"]');
            const k = szovegMezoKulcsa(f, i);
            if (be && be.value && !(k in beirtSzovegek)) beirtSzovegek[k] = be.value;
        });
    }
    // A szerkesztő mostani szalagja és belíve, a kosársor tulajdonságainak
    // alakjában (allitsdASzerkesztot ezt érti). A kihagyott mezőt nem nézzük.
    function mostaniValasztas(ablak, kihagy) {
        const { beliv, szalag } = szerkesztoMezoi(ablak);
        const tul = {};
        if (beliv && beliv !== kihagy) {
            const sel = beliv.querySelector('select');
            const o = sel && sel.selectedOptions[0];
            if (o && o.text.trim()) tul['Napló típusa'] = o.text.trim();
        }
        if (szalag && szalag !== kihagy) {
            const be = szalag.querySelector('input[type="radio"]:checked');
            const cimke = be && (szalag.querySelector('label[for="' + CSS.escape(be.id) + '"]') || be.closest('label'));
            const sz = cimke && cimke.querySelector('.tee-clipart-label__text, .sr-only');
            if (sz && sz.textContent.trim()) tul['Szalag színe'] = sz.textContent.trim();
        }
        return tul;
    }
    document.addEventListener('pointerdown', (e) => {
        if (!e.target.closest) return;
        const ablak = e.target.closest('.tee-edit-popup');
        if (!ablak) return;
        const mezo = e.target.closest('.tee-field');
        // Csak a választókra (szín, minta, szimbólum…), a szövegmezőkre nem.
        if (!mezo || mezo.querySelector('textarea, input[type="text"]')) return;
        jegyezdFelASzovegeket(ablak);
        const mentett = Object.assign({}, beirtSzovegek);
        // A színváltás a szalagot és a belívet is a minta alapjára állította
        // vissza (mérve 2026-10-15) — ezeket is megjegyezzük, kivéve azt a
        // mezőt, amelyiket a vásárló épp most nyom meg.
        const valasztott = mostaniValasztas(ablak, mezo);
        if (!Object.keys(mentett).length && !Object.keys(valasztott).length) return;
        const gepelt = {};
        const erintett = { beliv: false, szalag: false };
        const gepelesFigyelo = (ev) => {
            if (!ev.isTrusted || !ev.target.closest || !ev.target.closest('.tee-edit-popup')) return;
            const f = ev.target.closest('.tee-field');
            const ab = ev.target.closest('.tee-edit-popup');
            const i = szerkesztoSzovegMezoi(ab).indexOf(f);
            if (i >= 0) gepelt[szovegMezoKulcsa(f, i)] = true;
        };
        const valasztoFigyelo = (ev) => {
            if (!ev.isTrusted || !ev.target.closest) return;
            if (Date.now() - sajatSzerkesztoKattintas < 300) return;
            const ab = ev.target.closest('.tee-edit-popup');
            if (!ab) return;
            const m = szerkesztoMezoi(ab);
            if (m.beliv && m.beliv.contains(ev.target)) erintett.beliv = true;
            if (m.szalag && m.szalag.contains(ev.target)) erintett.szalag = true;
        };
        // Az előző (még futó) őr figyelőit levesszük, mielőtt újat indítunk.
        if (szovegOrLeallit) szovegOrLeallit();
        szovegOrLeallit = () => {
            clearInterval(szovegOrIdozito);
            document.removeEventListener('keydown', gepelesFigyelo, true);
            document.removeEventListener('change', valasztoFigyelo, true);
            document.removeEventListener('pointerdown', valasztoFigyelo, true);
            szovegOrLeallit = null;
        };
        document.addEventListener('keydown', gepelesFigyelo, true);
        document.addEventListener('change', valasztoFigyelo, true);
        document.addEventListener('pointerdown', valasztoFigyelo, true);
        let korok = 0;
        szovegOrIdozito = setInterval(() => {
            const ab = document.querySelector('.tee-edit-popup');
            if (ab) {
                szerkesztoSzovegMezoi(ab).forEach((f, i) => {
                    const k = szovegMezoKulcsa(f, i);
                    const be = f.querySelector('textarea, input[type="text"]');
                    if (be && (k in mentett) && !gepelt[k] && be.value !== mentett[k]) {
                        irdBeAMezobe(be, mentett[k]);
                    }
                });
                if (Object.keys(valasztott).length) allitsdASzerkesztot(ab, valasztott, erintett);
            }
            if ((++korok > 30 || !ab) && szovegOrLeallit) szovegOrLeallit();
        }, 200);
    }, true);
    // Új szerkesztő megnyitásakor tiszta lappal indulunk.
    document.addEventListener('click', (e) => {
        if (e.target.closest && e.target.closest('.tee-edit-customization')) beirtSzovegek = {};
    }, true);

    function navigateZoom(direction) {
        currentImageIndex += direction;
        if (currentImageIndex >= cartImages.length) currentImageIndex = 0;
        if (currentImageIndex < 0) currentImageIndex = cartImages.length - 1;
        updateZoomContent();
    }

    document.addEventListener('click', (e) => {
        const cartContainer = e.target.closest('cart-drawer, #CartDrawer, .cart-drawer, form[action="/cart"]');
        if (!cartContainer) return;

        const clickableElement = e.target.closest('a, button, .cart-item__preview, .addon-details-link, [role="button"]');
        if (!clickableElement) return;

        const text = (clickableElement.textContent || '').toLowerCase().trim();
        const isPreviewButton = clickableElement.classList.contains('cart-item__preview') || clickableElement.classList.contains('addon-details-link') || text.includes('előnézet') || text.includes('preview');

        if (isPreviewButton) {
            e.preventDefault(); e.stopPropagation();
            /* Teeinblue-tételnél a vásárló aktuális, szerkesztett terve kell,
               nem a termék alapképe. A tervkép címe a sor tulajdonságai között
               van (_customization_image), szerkesztés után az újé. Ilyenkor a
               lapozható sor a kosár tételeinek tervképeiből áll (tervkép híján
               a sor saját képéből). */
            const tervkepe = (gomb) => {
                const nyers = (gomb && gomb.getAttribute('data-props') || '').replace(/\\/g, '');
                const talalat = nyers.match(/https?:\/\/cdn\.teeinblue\.com\/customizations\/[^"'\s]+?\.(?:jpe?g|png|webp)/i);
                return talalat ? talalat[0] : '';
            };
            /* A terv azonosítója: ebből tudja az updateZoomContent, hogy van-e
               mentett, nyilas réteg nélküli előnézet ehhez a sorhoz. */
            const tervAzonosito = (gomb) => {
                const sor = gomb && gomb.closest('.cart-item, cart-drawer-item, tr');
                const keret = sor && sor.querySelector('[data-brinuti-elo]');
                if (keret) return keret.getAttribute('data-brinuti-elo');
                const nyers = (gomb && gomb.getAttribute('data-props') || '').replace(/\\/g, '');
                const talalat = nyers.match(/customizations\/([0-9a-f-]{8,})\./i);
                return talalat ? talalat[1] : '';
            };
            /* Az ajándékutalvány soránál a mentett kártya azonosítója (lásd a fájl
               végén): az előnézet ebből rajzolja a ráírt szöveget. */
            const utalvanyAzonosito = (sor) => {
                const k = sor && sor.querySelector('[data-bu-elo]');
                return k ? (k.getAttribute('data-bu-elo') || '') : '';
            };
            if (tervkepe(clickableElement)) {
                cartImages = [];
                currentImageIndex = 0;
                /* 2026-10-15 (a tulaj kérése): csak a megnyitott tétel képe
                   látszik, lapozás és „1 / 1” nélkül; alatta a belív és a
                   szalag színe. */
                [clickableElement].forEach(gomb => {
                    const sor = gomb.closest('.cart-item, cart-drawer-item, tr');
                    const sorKepe = sor && sor.querySelector('img');
                    /* 2026-10-21 (a tulaj kérése): SOHA nem a Teeinblue kész képe
                       (azon rajta van a nyilas réteg). Tartalékként a vásárló saját
                       levélképe, annak híján a sor 2. mockupja jön. */
                    const levelkep = ((gomb.getAttribute('data-props') || '').replace(/\\/g, '').match(/"_brinuti_elonezet"\s*[,:]\s*"(https?:[^"]+)"/) || [])[1] || '';
                    const kep = levelkep || (sorKepe ? sorKepe.src : '');
                    if (!kep) return;
                    cartImages.push({ kep: kep, azon: tervAzonosito(gomb), bu: utalvanyAzonosito(sor), props: gomb.getAttribute('data-props') || '', kulcs: (sor && sor.getAttribute('data-key')) || '' });
                });
                createZoomGalleryModal(); updateZoomContent(); document.getElementById('CartImageZoomModal').showModal();
                return;
            }
            cartImages = Array.from(cartContainer.querySelectorAll('img')).filter(img => img.src && !img.src.includes('icon') && !img.src.includes('logo') && !img.src.includes('svg')).map(img => ({ kep: img.src, azon: '', bu: utalvanyAzonosito(img.closest('.cart-item, cart-drawer-item, tr')) }));
            const currentItem = clickableElement.closest('.cart-item, cart-drawer-item, tr');
            /* Csak a megnyitott tétel képe (lásd fent). */
            const sajatKep = currentItem && currentItem.querySelector('img');
            if (sajatKep && sajatKep.src) cartImages = cartImages.filter(e => e.kep === sajatKep.src).slice(0, 1);
            /* A belív / szalag sorhoz (zoomAdatsor) ennél az útnál is kell a
               sor tulajdonsága és kulcsa. */
            if (cartImages.length === 1 && clickableElement.hasAttribute('data-props')) {
                cartImages[0].props = clickableElement.getAttribute('data-props') || '';
                cartImages[0].kulcs = (currentItem && currentItem.getAttribute('data-key')) || '';
            }
            if (currentItem) {
                const img = currentItem.querySelector('img');
                if (img) {
                    const hol = cartImages.findIndex(e => e.kep === img.src);
                    currentImageIndex = Math.max(0, hol);
                }
            }
            if (cartImages.length === 0) return;
            createZoomGalleryModal(); updateZoomContent(); document.getElementById('CartImageZoomModal').showModal();
        }
    }, true);

    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
            document.documentElement.style.overflow = '';
            // Nyitott gyorsnézet fölött az Escape csak azt csukja be.
            if (!document.querySelector('dialog#ProductQuickviewModal[open]')) csukdBeAKoztest();
            document.body.classList.remove('brinuti-popup-active');
            // Az Escape a natív <dialog>-okat magától becsukja, a téma záró
            // útja viszont ilyenkor is lefut, tehát a zárnak le kell jönnie.
            // Ha mégsem, itt seperjük fel. A késleltetés azért kell, hogy a
            // téma saját animációja előbb végigérjen.
            setTimeout(olddFelABennragadtGorgeteszarat, 400);
        }
    });
})();

/* KOSÁRBA TÉTEL UTÁN A FIÓK AZ ÚJ TÉTELHEZ GÖRGET (PDF 64. pont, 2026-09-19).
   Eddig a tétellista ott maradt, ahol a vásárló hagyta, így gyakran csak egy
   tétel „Előnézet | Törlés" sora látszott. Bármelyik úton kerül be új sor
   (Teeinblue, szett, ajánló „+", ajándékdoboz), a fiók újrarajzolása után
   az első új sorhoz görgetünk — az új tételek a lista tetejére kerülnek. */
(function () {
    const SOR = '.cart-items__table-row[data-key]';
    let ismert = null;
    let idozito = null;

    function kulcsok(fiok) {
        return new Set([...fiok.querySelectorAll(SOR)].map(function (s) { return s.dataset.key; }));
    }

    function ellenorizd() {
        const fiok = document.querySelector('cart-drawer-component');
        if (!fiok) return;
        const most = kulcsok(fiok);
        if (ismert === null) { ismert = most; return; }
        let uj = null;
        fiok.querySelectorAll(SOR).forEach(function (s) {
            if (!uj && !ismert.has(s.dataset.key)) uj = s;
        });
        ismert = most;
        if (!uj) return;
        const lista = fiok.querySelector('.cart-drawer__items');
        if (!lista) return;
        const cel = uj.getBoundingClientRect().top - lista.getBoundingClientRect().top + lista.scrollTop - 8;
        lista.scrollTo({ top: Math.max(0, cel), behavior: 'smooth' });
    }

    function indulj() {
        const fiok = document.querySelector('cart-drawer-component');
        if (!fiok) return;
        ellenorizd();
        new MutationObserver(function () {
            clearTimeout(idozito);
            idozito = setTimeout(ellenorizd, 150);
        }).observe(fiok, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', indulj);
    else indulj();
})();

/* ===================================================================
   A KOSÁR KIS KÉPE A VÁSÁRLÓ SAJÁT TERVÉT MUTATJA (6. kör, 76. pont)

   A Teeinblue tételenként EGYETLEN kész képet renderel a szerverén
   (_customization_image = cdn.teeinblue.com/customizations/<id>.jpg), és
   az mindig az első mockup — azon viszont rajta van a nyilas, „1. Válassz
   mintát!” magyarázó réteg, ezért a kosárba nem való. A 2. mockup (a tiszta
   naplófotó) csak statikus képként létezik, a vásárló szerkesztése nélkül.

   Megoldás: a termékoldalon a Teeinblue rétegekből rakja össze az élő
   előnézetet. Kosárba tételkor erről a rétegsorról készítünk egy önálló
   pillanatképet (a nyilas réteget levágva — így pont a 2. mockup látványa
   marad, de a vásárló nevével, fotójával, színeivel), és localStorage-ba
   tesszük a customization azonosítója alá. A kosárfiók és a kosároldal
   ebből rajzolja ki a kis képet. Ugyanezt a másolási technikát használja a
   szett doboz élő előnézete is (snippets/brinuti-szett-doboz.liquid).

   Ha nincs mentett pillanatkép (más eszközön nyitja meg a kosarat, törölt
   böngészőadat), marad a Liquid-oldali tartalék: a termék 2. mockupja.
   =================================================================== */
(function () {
    'use strict';

    var ELOTAG = 'brinuti-elo:';
    var MAX_TERV = 40;           // ennyi legutóbbi tervet tartunk meg
    var szamlalo = 0;            // az SVG-azonosítók egyedivé tételéhez

    /* ---------- a 2. mockup mértana ---------- */
    /* A pillanatkép a galéria első diájáról készül, ami a kampány 0.
       mockupja. Tíz dizájnon ez egy 7 fokkal megdöntött, kicsinyített
       borító, amit egy teljes képernyős magyarázó réteg egészít ki — a
       réteg levétele után a napló ferdén, félrecsúszva maradna. Ezért a
       rétegeket a kampány 1. mockupjának mértanára igazítjuk: ott
       mindenhol ugyanaz a borító áll, egyenesen, teljes méretben,
       magyarázat nélkül. Ez az a kép, amit a vásárló a 2. mockupon lát. */

    var kampanyok = {};          // termékazonosító -> {keret:{w,h}, terv, kepek}
    var kampanyKeresek = {};     // termékazonosító -> fut-e már a lekérés

    function fajlnev(cim) {
        return String(cim || '').split('?')[0].split('/').pop();
    }

    // A Teeinblue minden megnyitott tervhez lekéri a saját kampányát:
    // a termékoldalon a lap termékéét, a kosárból indított szerkesztéskor a
    // szerkesztett tételét. Ugyanazokat a címeket kérjük mi is, így a
    // böngésző gyorsítótárából jönnek, és biztosan a lapon futó változatot
    // kapjuk (a cím verziójelzőt is tartalmaz).
    function kampanyCimek() {
        var talalatok = [];
        try {
            performance.getEntriesByType('resource').forEach(function (bejegyzes) {
                var egyezes = bejegyzes.name.match(/\/api\/merchant\/campaigns\/(\d+)\.json/);
                if (egyezes) talalatok.push({ azon: egyezes[1], cim: bejegyzes.name });
            });
        } catch (e) { }
        return talalatok;
    }

    function lapTermeke() {
        var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
        if (meta && meta.product && meta.product.id) return String(meta.product.id);
        var oszt = String(document.body.className).match(/teeinblue-product-(\d+)/);
        return oszt ? oszt[1] : '';
    }

    function dolgozdFelAKampanyt(adat) {
        var termek = adat && adat.campaign_products && adat.campaign_products[0];
        var mockupok = termek && termek.campaign_mockups;
        if (!mockupok || mockupok.length < 2) return null;
        mockupok = mockupok.slice().sort(function (a, b) { return a.position - b.position; });
        var masodik = mockupok[1];
        if (!masodik || !masodik.width) return null;
        var mertan = { keret: { w: masodik.width, h: masodik.height }, terv: null, kepek: {} };
        (masodik.layers || []).forEach(function (reteg) {
            // A 2. mockupon kikapcsolt réteg a kosárba és a levélbe sem kell.
            // Két dizájnon (game-on-fuzet-a5, the-day-journal) a nyilas
            // magyarázat itt is szerepel, csak kikapcsolva — ha a mértanát
            // eltennénk, nem törlődne, hanem rákerülne a képre.
            if (reteg.visible === false) return;
            var hely = {
                left: reteg.left, top: reteg.top,
                width: reteg.width, height: reteg.height,
                rotate: reteg.rotate || 0
            };
            if (reteg.printarea_id !== undefined) mertan.terv = hely;
            else mertan.kepek[fajlnev(reteg.url)] = hely;
        });
        return mertan.terv ? mertan : null;
    }

    function kerdezdLeAKampanyokat() {
        kampanyCimek().forEach(function (talalat) {
            if (kampanyKeresek[talalat.azon]) return;
            kampanyKeresek[talalat.azon] = true;
            fetch(talalat.cim, { credentials: 'omit' })
                .then(function (valasz) { return valasz.ok ? valasz.json() : null; })
                .then(function (adat) { kampanyok[talalat.azon] = dolgozdFelAKampanyt(adat); })
                .catch(function () {
                    // Szándékosan NEM próbálkozunk újra: a figyelő félmásodpercenként
                    // visszanéz, és egy hibázó lekérés újraindítása kérésözönt zúdítana
                    // a Teeinblue-ra. Kampány nélkül a régi szabály lép életbe.
                    kampanyok[talalat.azon] = null;
                });
        });
    }

    var kampanyOra = null;
    function figyeldAKampanyokat(meddig) {
        kerdezdLeAKampanyokat();
        clearInterval(kampanyOra);
        var hatra = Math.ceil(meddig / 500);
        kampanyOra = setInterval(function () {
            kerdezdLeAKampanyokat();
            if (--hatra <= 0) clearInterval(kampanyOra);
        }, 500);
    }

    /* Melyik mockupból készüljön a pillanatkép? Kosárból indított
       szerkesztéskor a Teeinblue a saját ablakában nyitja meg a tervet,
       miközben a lapon ott van a termékoldal saját mockupja is. Ilyenkor az
       ablakban lévő a szerkesztett tétel — enélkül annak a terméknek a
       terve kerülne a sorra, amelyiknek a lapján éppen állunk. */
    function valasszMockupot() {
        var jeloltek = Array.prototype.slice.call(
            document.querySelectorAll('.tee-gallery .tee-slide .tee-mockup'));
        if (!jeloltek.length) return null;
        /* 2026-10-29 (hibanapló #36): fotós borítónál a felugró ablak (.vm--modal) bezárása után is ott marad egy 0 méretű
           mockup (viewBox „0 0 0 0”); ezt nem szabad kiválasztani, különben „nincs méret” lesz a vége (nincs levélkép,
           nincs egyedi változtatás). Csak érvényes méretű rajzot fogadunk el. */
        function ervenyesRajz(elem) {
            var sv = elem.querySelector('svg.tee-printarea-artwork');
            var v = sv && (sv.getAttribute('viewBox') || '').split(/[\s,]+/).map(Number);
            return !!(v && v[2] > 0 && v[3] > 0);
        }
        var ablakban = jeloltek.filter(function (elem) {
            return elem.closest && elem.closest('.vm--modal, .editor-gallery-wrapper') && elem.offsetParent && ervenyesRajz(elem);
        });
        if (ablakban.length) return ablakban[ablakban.length - 1];
        /* Mindig az ELŐLAP (2026-10-16): ha a vevő a galériában épp a
           hátlapot (3. dia) nézte a kosárba tételkor, eddig a hátlap került a
           kosárba és a levélbe. A 2. dia a tiszta előlap, az 1. a nyilas
           előlap (a magyarázó réteg úgyis lekerül) — ezek közül a már
           felépült elsőt vesszük. */
        var elolap = null;
        [1, 0].some(function (sorszam) {
            return jeloltek.some(function (elem) {
                var dia = elem.closest && elem.closest('.tee-slide');
                if (!dia || !dia.parentNode) return false;
                var diak = Array.prototype.filter.call(dia.parentNode.children, function (d) {
                    return d.classList.contains('tee-slide');
                });
                if (diak.indexOf(dia) !== sorszam) return false;
                if (!(parseFloat(elem.style.width) || elem.offsetWidth)) return false;
                if (!elem.querySelector('.tee-printarea--printarea')) return false;
                elolap = elem;
                return true;
            });
        });
        if (elolap) return elolap;
        var latszo = jeloltek.filter(function (elem) { return elem.offsetParent; });
        return latszo[0] || jeloltek[0];
    }

    /* A mockup LÁTSZÓ háttérképeinek fájlnevei. A Teeinblue a kampány
       minden rétegét kirajzolja, a kikapcsoltakat display:none-nal — a
       Reverie naplón például hat képréteg van a lapon, de csak három
       látszik. Ha a kikapcsoltakat is beszámítanánk, az alábbi illesztés
       pont a tíz arcbeillesztős dizájnon bukna el, vagyis azokon, ahol a
       2. mockup mértanára a legnagyobb szükség van. */
    function mockupKepei(mockup) {
        var nevek = [];
        Array.prototype.forEach.call(
            mockup.querySelectorAll('.tee-printarea--image'), function (reteg) {
                if (reteg.style.display === 'none') return;
                var kep = reteg.querySelector('img');
                // A szalagszín-csere (brinuti-szalag-mockup.js) az eredeti címet őrzi.
                var nev = kep ? fajlnev(kep.getAttribute('data-bsm-eredeti') || kep.getAttribute('src')) : '';
                if (nev) nevek.push(nev);
            });
        return nevek;
    }

    // Illik-e ez a mértan ehhez a mockuphoz? A naplók és a füzetek más-más
    // borítóképet használnak, és a mértanuk is más — a képfájlok nevéből
    // tehát a TERMÉKFAJTA kiderül (a konkrét dizájn nem: a 108 kampány
    // mindössze 10 képfájlon osztozik). Teljes egyezést nem várhatunk: a
    // galériában az 1. mockup látszik, amin tíz dizájnon ott a magyarázó
    // réteg is — azt a 2. mockup nem ismeri.
    function illikE(mertan, nevek) {
        if (!mertan) return false;
        var talalat = 0;
        for (var i = 0; i < nevek.length; i++) if (mertan.kepek[nevek[i]]) talalat++;
        return talalat > 0 && talalat * 2 >= nevek.length;
    }

    /* A mockuphoz tartozó kampány mértana. A szerkesztőablakét a legutóbb
       lekért kampány adja (azt a Teeinblue az ablak megnyitásakor kéri le),
       a termékoldalét pedig a lap terméke. Ezt a feltevést a mockup saját
       képfájljaival ellenőrizzük is: ha nem illik rá, a lekért kampányok
       közül keressük meg azt, amelyik igen. Ez nem a dizájnt azonosítja,
       csak a termékfajtát — biztonsági háló arra, hogy a rétegek soha ne
       essenek ki egy oda nem illő mértan miatt. */
    function mertanAMockuphoz(mockup) {
        var azon;
        if (mockup.closest && mockup.closest('.vm--modal, .editor-gallery-wrapper')) {
            var cimek = kampanyCimek();
            azon = cimek.length ? cimek[cimek.length - 1].azon : '';
        } else {
            azon = lapTermeke();
        }
        var nevek = mockupKepei(mockup);
        var tipp = azon && kampanyok[azon];
        if (illikE(tipp, nevek)) return tipp;
        var talalt = null;
        Object.keys(kampanyok).forEach(function (kulcs) {
            if (!talalt && illikE(kampanyok[kulcs], nevek)) talalt = kampanyok[kulcs];
        });
        return talalt;
    }

    /* A pillanatkép rétegeit a 2. mockup mértanára teszi. Igazat ad vissza,
       ha sikerült — ilyenkor a magyarázó rétegek is lekerültek, mert azok a
       2. mockupon nincsenek rajta. */
    function igazitsdAMasodikMockupra(masolat, szelesseg, mertan) {
        if (!mertan) return false;
        var arany = szelesseg / mertan.keret.w;
        if (!arany || !isFinite(arany)) return false;
        var megvanATerv = false;
        Array.prototype.slice.call(masolat.children).forEach(function (reteg) {
            if (reteg.classList.contains('tee-mockup-image')) return;   // üres keret
            // Amit a lapon kikapcsolt a választás — a többi szín borítója,
            // a lapozásra hívó fül —, az a kosárba és a levélbe sem kell.
            // Enélkül a lentebbi display:block bekapcsolná őket.
            if (reteg.style.display === 'none') { reteg.remove(); return; }
            var terves = reteg.classList.contains('tee-printarea--printarea');
            var hely = null;
            if (terves) {
                hely = mertan.terv;
            } else if (reteg.classList.contains('tee-printarea--image')) {
                var kep = reteg.querySelector('img');
                hely = kep ? mertan.kepek[fajlnev(kep.getAttribute('src'))] : null;
            } else {
                return;
            }
            // Ami a 2. mockupon nincs rajta — magyarázó réteg, rejtett
            // háttér —, az a kosárból és a levélből is kimarad.
            if (!hely) { reteg.remove(); return; }
            var regiSzelesseg = parseFloat(reteg.style.width) || 0;
            reteg.style.display = 'block';
            reteg.style.left = (hely.left * arany) + 'px';
            reteg.style.top = (hely.top * arany) + 'px';
            reteg.style.width = (hely.width * arany) + 'px';
            reteg.style.height = (hely.height * arany) + 'px';
            reteg.style.transform = 'rotate(' + hely.rotate + 'deg)';
            if (!terves) return;
            // A terv dobozán belül a Teeinblue külön, képpontban megadott
            // rekeszt használ (tee-printarea-allocator) — maga a rajz ekkora
            // lesz. A réteg átméretezése ezt nem viszi magával, ezért a belső
            // méreteket ugyanazzal a szorzóval igazítjuk.
            if (regiSzelesseg > 0) {
                var szorzo = (hely.width * arany) / regiSzelesseg;
                Array.prototype.forEach.call(reteg.querySelectorAll('*'), function (belso) {
                    ['left', 'top', 'width', 'height'].forEach(function (nev) {
                        var ertek = belso.style && belso.style[nev];
                        if (!ertek || ertek.indexOf('px') < 0) return;
                        var szam = parseFloat(ertek);
                        if (isNaN(szam)) return;
                        belso.style[nev] = (szam * szorzo) + 'px';
                    });
                });
            }
            megvanATerv = true;
        });
        return megvanATerv;
    }

    /* ---------- a böngészőben készült képrétegek ---------- */
    /* A Teeinblue néhány réteget a böngészőben rajzol meg (a dátumos
       naplóknál a dátum grafikáját, feltöltés közben a fotót), és blob:
       hivatkozással teszi a tervbe. Egy blob csak azon a lapon él, ahol
       készült, ezért a kosárba és a levélbe így nem vihetnénk át. Előre
       átalakítjuk hát beágyazott képpé: a vászon nem szennyeződik, mert a
       blob a saját oldalunké. Az átalakítás lassú (a kép betöltésére kell
       várni), ezért folyamatosan, a háttérben végezzük — mentéskor már
       kéznél van. */

    var blobKepek = {};          // blob: cím -> beágyazott cím ('' = még dolgozunk)

    function blobCime(elem) {
        return elem.getAttribute('href') || elem.getAttribute('xlink:href') || elem.getAttribute('src') || '';
    }

    function alakitsdAtABlobokat() {
        Array.prototype.forEach.call(
            document.querySelectorAll('image, img[src^="blob:"]'), function (elem) {
                var cim = blobCime(elem);
                if (cim.indexOf('blob:') !== 0 || blobKepek[cim] !== undefined) return;
                blobKepek[cim] = '';
                var kep = new Image();
                kep.onload = function () {
                    try {
                        var vaszon = document.createElement('canvas');
                        vaszon.width = kep.naturalWidth;
                        vaszon.height = kep.naturalHeight;
                        vaszon.getContext('2d').drawImage(kep, 0, 0);
                        /* GYORSÍTÁS (2026-10-02): a PNG-tömörítés egy feltöltött
                           fotónál telefonon akár fél másodperc a fő szálon —
                           ezalatt a konfigurátor nem reagált. A toBlob a
                           böngésző háttérszálán tömörít, az eredmény ugyanaz a
                           PNG adat-URL. Ahol nincs toBlob, marad a régi út. */
                        if (vaszon.toBlob && window.FileReader) {
                            vaszon.toBlob(function (b) {
                                if (!b) return;
                                var olvaso = new FileReader();
                                olvaso.onload = function () { blobKepek[cim] = olvaso.result; };
                                olvaso.readAsDataURL(b);
                            }, 'image/png');
                        } else {
                            blobKepek[cim] = vaszon.toDataURL('image/png');
                        }
                    } catch (e) { }
                };
                kep.src = cim;
            });
    }

    function cserelddABlobokat(masolat) {
        Array.prototype.forEach.call(
            masolat.querySelectorAll('image, img'), function (elem) {
                ['href', 'xlink:href', 'src'].forEach(function (nev) {
                    var cim = elem.getAttribute(nev);
                    if (!cim || cim.indexOf('blob:') !== 0) return;
                    if (blobKepek[cim]) elem.setAttribute(nev, blobKepek[cim]);
                });
            });
    }

    /* ---------- pillanatkép készítése a termékoldalon ---------- */

    function keszitsPillanatkepet() {
        var mockup = valasszMockupot();
        if (!mockup) return null;
        var szelesseg = parseFloat(mockup.style.width) || mockup.offsetWidth;
        var magassag = parseFloat(mockup.style.height) || mockup.offsetHeight;
        if (!szelesseg || !magassag) return null;

        var masolat = mockup.cloneNode(true);
        // A galériában a szalag a választott színű lehet (brinuti-szalag-
        // mockup.js); a pillanatkép — kosár, levél, pénztár — az eredeti
        // alapképből készül, ahogy eddig.
        Array.prototype.forEach.call(masolat.querySelectorAll('img[data-bsm-eredeti]'), function (kep) {
            kep.setAttribute('src', kep.getAttribute('data-bsm-eredeti'));
            kep.removeAttribute('data-bsm-eredeti');
        });
        var retegek = Array.prototype.slice.call(masolat.children);
        var borito = -1;
        retegek.forEach(function (reteg, i) {
            if (reteg.classList.contains('tee-printarea--printarea')) borito = i;
        });
        if (borito < 0) return null;

        // Elsőként a 2. mockup mértanára igazítunk: ott a napló egyenesen,
        // teljes méretben áll, magyarázó réteg nélkül. Ha a kampány adatai
        // még nem érkeztek meg, marad a régi szabály: a borító fölötti első
        // képréteg az árnyék, ami utána jön, az a nyilas magyarázat.
        if (!igazitsdAMasodikMockupra(masolat, szelesseg, mertanAMockuphoz(mockup))) {
            var kepekFelette = 0;
            retegek.slice(borito + 1).forEach(function (reteg) {
                if (!reteg.classList.contains('tee-printarea--image')) return;
                kepekFelette++;
                if (kepekFelette > 1) reteg.remove();
            });
        }

        // A borító <use>-zal hivatkozik a lap egy rejtett SVG-jére. A kosárban
        // (más oldalon) az a hivatkozás már nem élne, ezért a tervet beemeljük
        // a másolatba: a <use> helyére maga az SVG kerül, a <use> méreteivel.
        Array.prototype.forEach.call(masolat.querySelectorAll('use'), function (hivatkozas) {
            var azon = (hivatkozas.getAttribute('href') || hivatkozas.getAttribute('xlink:href') || '').replace('#', '');
            var forras = azon && document.getElementById(azon);
            if (!forras) return;
            var terv = forras.cloneNode(true);
            terv.removeAttribute('id');
            ['x', 'y', 'width', 'height'].forEach(function (nev) {
                if (hivatkozas.hasAttribute(nev)) terv.setAttribute(nev, hivatkozas.getAttribute(nev));
            });
            hivatkozas.parentNode.replaceChild(terv, hivatkozas);
        });

        // A Teeinblue minden felirathoz két segédpéldányt is beletesz
        // (méréshez); a termékoldalon ezeket a saját stíluslapja rejti el.
        // A kosárban és a levélben az a stíluslap nincs ott, ezért a
        // segédpéldányok kirajzolódnának a valódi felirat mellé.
        Array.prototype.forEach.call(masolat.querySelectorAll('.tee-layer-text--invisible'), function (elem) {
            elem.remove();
        });

        cserelddABlobokat(masolat);

        var html = masolat.outerHTML;
        if (html.indexOf('tee-printarea-artwork') < 0) return null;
        // A feltöltött fotó a Teeinblue CDN-jére kerül. Ha kivételesen még
        // böngészőn belüli (blob:) kép lenne benne, azt másik oldalon már nem
        // lehetne megjeleníteni — ilyenkor inkább a tartalék kép maradjon.
        if (html.indexOf('blob:') >= 0) return null;

        // A feliratok betűtípusát a Teeinblue a Google Fontsról tölti; a
        // kosárban ugyanezt kérjük le, különben más betűvel jelenne meg.
        var betuk = [];
        (html.match(/font-family="[^"]*"/g) || []).forEach(function (talalat) {
            talalat.replace(/font-family="/, '').replace(/"$/, '').split(',').forEach(function (nev) {
                nev = nev.replace(/&quot;/g, '').replace(/['"]/g, '').trim();
                if (nev && betuk.indexOf(nev) < 0) betuk.push(nev);
            });
        });

        return { w: szelesseg, h: magassag, m: html, f: betuk, t: Date.now() };
    }

    /* EGYEDI VÁLTOZTATÁS (2026-10-29, a tulaj kérése; snippets/brinuti-egyedi-
       valtoztatas.liquid). A lapon épp látható borító TELJES tervét egyetlen
       lapos képpé rajzolja (ugyanaz a rétegbeágyazó és ellenőrző út, mint a
       levélképnél), az AI-módosítás kiinduló képéhez. Visszaadja a képet és a
       méretét; az előlap kivágása a hívó dolga. */
    window.brinutiLaposTerv = function () {
        var mockup = valasszMockupot();
        var svg = mockup && mockup.querySelector('svg.tee-printarea-artwork');
        var vb = svg ? (svg.getAttribute('viewBox') || '').split(/[\s,]+/).map(Number) : [];
        var tartalek = !(vb.length >= 4 && vb[2] > 0 && vb[3] > 0);
        var masolat;
        if (tartalek) {
            /* 2026-10-30 (hibanapló #36, a gyökérok): a fotós borítók oldalán a Teeinblue a látható galériát időnként
               NEM építi fel (a diákon örökre a töltés-ikon marad, a rejtett másolat rajza „0 0 0 0” méretű; az éles oldalon
               is mérve, terhelés alatt a betöltések 30–70 %-ában). A rejtett FORRÁS-RAJZ (svg.tee-mockup-artwork, a teljes
               nyomtatási terület, saját érvényes viewBox-szal) ilyenkor is teljes, ezért a lapos tervet közvetlenül belőle
               készítjük: a normál ágban a <use> pont ezt (0,0 – teljes szélesség × magasság) helyezi a rajzra, a maszkot
               pedig úgyis levesszük, vagyis ugyanazt a képet kapjuk. */
            var hiv = svg && svg.querySelector('use');
            var azon = hiv ? (hiv.getAttribute('href') || hiv.getAttribute('xlink:href') || '').replace('#', '') : '';
            var forras = (azon && document.getElementById(azon)) || document.querySelector('svg.tee-mockup-artwork');
            var fvb = forras ? (forras.getAttribute('viewBox') || '').split(/[\s,]+/).map(Number) : [];
            if (!(fvb.length >= 4 && fvb[2] > 0 && fvb[3] > 0)) {
                return Promise.reject(new Error(svg ? 'nincs méret' : 'nincs terv'));
            }
            vb = fvb;
            masolat = forras.cloneNode(true);
            masolat.removeAttribute('id');
            Array.prototype.forEach.call(masolat.querySelectorAll('image[data-bev]'), function (e) { e.parentNode.removeChild(e); });
        } else {
            /* A borító <use>-zal hivatkozik a lap rejtett SVG-jére (a pillanatképnél
               ugyanígy emeljük be), és a rárakott egyedi előlapot sem vesszük át. */
            masolat = svg.cloneNode(true);
            Array.prototype.forEach.call(masolat.querySelectorAll('image[data-bev]'), function (e) { e.parentNode.removeChild(e); });
            Array.prototype.forEach.call(masolat.querySelectorAll('use'), function (hivatkozas) {
                var azon = (hivatkozas.getAttribute('href') || hivatkozas.getAttribute('xlink:href') || '').replace('#', '');
                var forras = azon && document.getElementById(azon);
                if (!forras) return;
                var terv = forras.cloneNode(true);
                terv.removeAttribute('id');
                ['x', 'y', 'width', 'height'].forEach(function (nev) {
                    if (hivatkozas.hasAttribute(nev)) terv.setAttribute(nev, hivatkozas.getAttribute(nev));
                });
                hivatkozas.parentNode.replaceChild(terv, hivatkozas);
            });
        }
        var sz = 2400, mg = Math.round(sz * vb[3] / vb[2]);
        Array.prototype.forEach.call(masolat.querySelectorAll('.tee-layer-text--invisible'), function (e) { e.parentNode.removeChild(e); });
        /* A mockup maszkja (a könyv sziluettje) a levágott, nyomtatott részt is
           elrejti; az AI-nak a TELJES nyomtatott előlap kell, ezért levesszük. */
        Array.prototype.forEach.call(masolat.querySelectorAll('g.tee-printarea-masked'), function (e) { e.removeAttribute('mask'); });
        svg = masolat;
        var betuk = [];
        (svg.outerHTML.match(/font-family="[^"]*"/g) || []).forEach(function (talalat) {
            talalat.replace(/font-family="/, '').replace(/"$/, '').split(',').forEach(function (nev) {
                nev = nev.replace(/&quot;/g, '').replace(/['"]/g, '').trim();
                if (nev && betuk.indexOf(nev) < 0) betuk.push(nev);
            });
        });
        return betukStilusa(betuk).then(function (stilus) {
            return tervKeppeEllenorizve(svg, sz, mg, stilus);
        }).then(function (kep) { return { kep: kep, sz: sz, mg: mg, tartalek: tartalek }; });
    };

    /* ---------- tárolás ---------- */

    function olvasd(azon) {
        try {
            var sor = localStorage.getItem(ELOTAG + azon);
            return sor ? JSON.parse(sor) : null;
        } catch (e) { return null; }
    }

    function takaritsd(mennyit) {
        try {
            var kulcsok = [];
            for (var i = 0; i < localStorage.length; i++) {
                var k = localStorage.key(i);
                if (k && k.indexOf(ELOTAG) === 0) {
                    var adat = null;
                    try { adat = JSON.parse(localStorage.getItem(k)); } catch (e) { adat = null; }
                    kulcsok.push({ k: k, t: (adat && adat.t) || 0 });
                }
            }
            if (kulcsok.length <= mennyit) return;
            kulcsok.sort(function (a, b) { return b.t - a.t; });
            kulcsok.slice(mennyit).forEach(function (e) { localStorage.removeItem(e.k); });
        } catch (e) { /* a tárolás tiltva van — marad a tartalék kép */ }
    }

    function mentsd(azon, adat) {
        try {
            localStorage.setItem(ELOTAG + azon, JSON.stringify(adat));
            takaritsd(MAX_TERV);
        } catch (e) {
            // Megtelt a tároló: hagyunk csak néhány legfrissebb tervet, és
            // egyszer újrapróbáljuk. Ha így sem megy, marad a tartalék kép.
            takaritsd(5);
            try { localStorage.setItem(ELOTAG + azon, JSON.stringify(adat)); } catch (e2) { /* nem baj */ }
        }
    }

    /* =====================================================================
       A LEVÉLBE IS A VÁSÁRLÓ SAJÁT TERVE KERÜLJÖN (2026-09-21)

       A kosárban a fenti pillanatképből él az előnézet, de az csak a
       böngészőben létezik — levélbe nem tehető. A Teeinblue szerverén pedig
       egyetlen kész kép van (_customization_image), és azon rajta van a
       nyilas magyarázó réteg.

       Ezért ugyanabból a pillanatképből itt egy VALÓDI képfájlt is
       legyártunk: a rétegeket vászonra rajzoljuk, a tervet SVG-ként (a
       betűtípust base64-ben beágyazva), és a kész JPEG-et feltöltjük a
       Teeinblue fotótárába. A nyilvános címe rejtett tulajdonságként a
       kosársorra kerül (_brinuti_elonezet), onnan a rendelésre, onnan pedig
       a visszaigazoló és a többi levélbe.

       Semmi nem áll meg tőle: a kosárba tétel azonnal megtörténik, a kép a
       háttérben készül el. Ha bármi elakad (CORS, tárhely, hálózat), a
       levélben marad a Liquid-oldali tartalék kép — a vásárló ebből semmit
       nem lát.

       A sor kulcsa a tulajdonság felírásakor megváltozik; ez itt biztonságos,
       mert a téma a mennyiséget a sor INDEXÉVEL módosítja (component-cart-
       items.js: `line`), nem a kulcsával.
       ===================================================================== */

    var BOLT = (window.Shopify && window.Shopify.shop) || 'nebnfj-ug.myshopify.com';
    var FELTOLTO = 'https://photo-api.teeinblue.com/api/merchant/shopify/upload-url?shop=' + BOLT;
    /* A feltöltés a Teeinblue európai tárolójába megy. A cdn.teeinblue.com egy
       másik vödörre mutat, onnan ez a fájl 403-at adna, ezért a tároló saját
       címét használjuk. */
    var TAROLO = 'https://s3.eu-central-2.wasabisys.com/teeinblue-cdn-we/';
    var R2_ATJATSZO = 'https://brinuti-egyedi-borito.ferraj.workers.dev/relay/r2?u=';   // a Worker /relay/r2 útvonala (2026-11-03)
    var HOSSZABB_OLDAL = 1200;   // a kész kép hosszabbik oldala képpontban
    var LEGKISEBB_FAJL = 10000;  // a feltöltő ennél kisebbet nem fogad el

    function adatUrl(blob) {
        return new Promise(function (kesz, hiba) {
            var olvaso = new FileReader();
            olvaso.onload = function () { kesz(olvaso.result); };
            olvaso.onerror = function () { hiba(new Error('olvasás')); };
            olvaso.readAsDataURL(blob);
        });
    }

    function toltsdBeAKepet(cim, kulso) {
        return new Promise(function (kesz, hiba) {
            var kep = new Image();
            if (kulso) kep.crossOrigin = 'anonymous';
            kep.onload = function () { kesz(kep); };
            kep.onerror = function () { hiba(new Error('kép nem töltődött be')); };
            kep.src = cim;
        });
    }

    /* ---------- a betűtípus beágyazása ----------
       A tervet külön képként rajzoljuk ki, az pedig nem látja a lap
       betűtípusait, ezért a betűfájlt bele kell írni magába az SVG-be. */

    var betuTar = {};

    function betuCss(nev) {
        var pluszos = nev.replace(/ /g, '+');
        var cim = '';
        Array.prototype.forEach.call(document.querySelectorAll('link[rel="stylesheet"]'), function (link) {
            if (cim || !link.href) return;
            if (link.href.indexOf('fonts.googleapis.com') < 0) return;
            if (link.href.indexOf(pluszos) < 0) return;
            cim = link.href;
        });
        if (!cim) cim = 'https://fonts.googleapis.com/css?family=' + pluszos;
        return fetch(cim).then(function (valasz) {
            if (!valasz.ok) throw new Error('betű: ' + valasz.status);
            return valasz.text();
        }).then(function (css) {
            /* A Google több változatot ad (latin, cirill, görög…). Csak a
               latin és a latin bővített kell — a hosszú ő és ű abban van —,
               különben a beágyazott betűfájlok fölöslegesen nagyok lennének. */
            var blokkok = (css.match(/@font-face\s*\{[^}]*\}/g) || []).filter(function (blokk) {
                var tartomany = blokk.match(/unicode-range:([^;}]*)/);
                if (!tartomany) return true;
                return /U\+0000|U\+0100|U\+0-/i.test(tartomany[1]);
            }).slice(0, 4);
            return Promise.all(blokkok.map(function (blokk) {
                var talalat = blokk.match(/url\((https:[^)]+?)\)/);
                if (!talalat) return '';
                return fetch(talalat[1]).then(function (v) { return v.blob(); })
                    .then(adatUrl)
                    .then(function (be) { return blokk.replace(talalat[1], be); })
                    .catch(function () { return ''; });
            })).then(function (keszek) { return keszek.filter(Boolean).join('\n'); });
        });
    }

    /* EGYÉNI BETŰTÍPUS (2026-10-26). Ha a terv szövege egyéni betűvel készül
       (pl. az Own Your Crown „Craftylover”-e), a Teeinblue azt nem a Google
       Fontsról, hanem a saját CDN-éről tölti, és a laphoz @font-face szabályt
       ad. A Google-lekérés ezt nem találja, így a kosár- és levélkép sima
       talpatlan betűvel készült: az szélesebb, ezért a szöveg kilógott a
       dobozból, a 0,6-os sortávval pedig a sorok egymásra csúsztak.
       Ilyenkor a lap saját @font-face szabályából ágyazzuk be a betűfájlt. */
    function sajatBetuCss(nev) {
        var talalatok = [];
        Array.prototype.forEach.call(document.styleSheets, function (lap) {
            var szabalyok;
            try { szabalyok = lap.cssRules; } catch (e) { return; }   // idegen eredetű lap: nem olvasható
            Array.prototype.forEach.call(szabalyok || [], function (szabaly) {
                if (szabaly.type !== 5) return;                       // csak a @font-face
                var csalad = (szabaly.style.getPropertyValue('font-family') || '').replace(/["']/g, '').trim();
                if (csalad !== nev) return;
                var forras = (szabaly.style.getPropertyValue('src') || '').match(/url\(["']?(https?:[^"')]+)["']?\)/);
                if (!forras) return;
                if (talalatok.some(function (t) { return t.url === forras[1]; })) return;
                talalatok.push({
                    url: forras[1],
                    suly: szabaly.style.getPropertyValue('font-weight') || 'normal',
                    stilus: szabaly.style.getPropertyValue('font-style') || 'normal'
                });
            });
        });
        return Promise.all(talalatok.slice(0, 4).map(function (t) {
            var formatum = /\.woff2(\?|$)/i.test(t.url) ? 'woff2' : /\.woff(\?|$)/i.test(t.url) ? 'woff'
                : /\.ttf(\?|$)/i.test(t.url) ? 'truetype' : /\.otf(\?|$)/i.test(t.url) ? 'opentype' : '';
            return fetch(t.url, { mode: 'cors' }).then(function (valasz) {
                if (!valasz.ok) throw new Error('betű: ' + valasz.status);
                return valasz.blob();
            }).then(adatUrl).then(function (be) {
                return '@font-face{font-family:"' + nev + '";src:url(' + be + ')' +
                    (formatum ? ' format("' + formatum + '")' : '') +
                    ';font-weight:' + t.suly + ';font-style:' + t.stilus + ';}';
            }).catch(function () { return ''; });
        })).then(function (keszek) { return keszek.filter(Boolean).join('\n'); });
    }

    function betukStilusa(betuk) {
        var keresek = (betuk || []).filter(function (nev) {
            return !/^(serif|sans-serif|monospace|cursive|fantasy|system-ui|inherit)$/i.test(nev);
        }).map(function (nev) {
            /* Előbb a Google Fonts (a megszokott út), és csak ha az nem adott
               betűt, jön a lap saját @font-face szabálya. */
            if (!betuTar[nev]) {
                betuTar[nev] = betuCss(nev).catch(function () { return ''; }).then(function (css) {
                    return css || sajatBetuCss(nev);
                }).catch(function () { return ''; });
            }
            return betuTar[nev];
        });
        return Promise.all(keresek).then(function (darabok) { return darabok.filter(Boolean).join('\n'); });
    }

    /* ---------- a terv SVG-jéből önálló kép ---------- */

    /* 2026-10-25 (#1588, bézs My Art Nouveau Cat: a levélkép TELJESEN FEHÉR volt).
       A rétegképek letöltése hálózati hibán vagy terheléskorláton elbukhat
       (a Teeinblue képtára ilyenkor 502-t ad). Eddig a rajzoló ezt csendben
       átlépte, és az üres vásznat is feltöltötte. Mostantól minden letöltést
       egyszer újrapróbálunk, a hibás válasz (nem 2xx) hibának számít, és
       üres képet soha nem töltünk fel (lásd üresE). */
    function ujraProbal(feladat) {
        return feladat().catch(function () {
            return new Promise(function (kesz) { setTimeout(kesz, 700); }).then(feladat);
        });
    }

    function tervKeppe(svg, szelesseg, magassag, stilus) {
        var masolat = svg.cloneNode(true);
        var kepek = Array.prototype.slice.call(masolat.querySelectorAll('image'));
        return Promise.all(kepek.map(function (elem) {
            var forras = elem.getAttribute('href') || elem.getAttribute('xlink:href') || '';
            if (!forras || forras.indexOf('data:') === 0) return null;
            return ujraProbal(function () {
                return fetch(forras, { mode: 'cors' }).then(function (v) {
                    if (!v.ok) throw new Error('rétegkép: ' + v.status);
                    return v.blob();
                }).then(function (b) {
                    /* 2026-10-29: a 200-as, de nem képet tartalmazó válasz
                       (pl. hibaoldal) az SVG-ben hangtalanul üres réteg lenne. */
                    if (b.type && !/^image\//i.test(b.type) && !/octet-stream/i.test(b.type)) throw new Error('rétegkép: nem kép');
                    // hibás képtartalom: az SVG-ben ez is csak üres réteg lenne
                    if (!window.createImageBitmap || /svg/i.test(b.type)) return b;
                    return createImageBitmap(b).then(function (bm) {
                        if (bm && bm.close) bm.close();
                        return b;
                    }, function () { throw new Error('rétegkép: hibás kép'); });
                });
            })
                .then(adatUrl)
                .then(function (be) {
                    elem.setAttribute('href', be);
                    elem.removeAttribute('xlink:href');
                });
        })).then(function () {
            masolat.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
            masolat.setAttribute('xmlns:xlink', 'http://www.w3.org/1999/xlink');
            masolat.setAttribute('width', szelesseg);
            masolat.setAttribute('height', magassag);
            if (stilus) {
                var st = document.createElementNS('http://www.w3.org/2000/svg', 'style');
                st.textContent = stilus;
                masolat.insertBefore(st, masolat.firstChild);
            }
            var szoveg = new XMLSerializer().serializeToString(masolat);
            var cim = URL.createObjectURL(new Blob([szoveg], { type: 'image/svg+xml;charset=utf-8' }));
            return toltsdBeAKepet(cim, false).then(function (kep) {
                URL.revokeObjectURL(cim);
                return kep;
            }, function (hiba) {
                URL.revokeObjectURL(cim);
                throw hiba;
            });
        });
    }

    /* 2026-10-29 (a tulaj kérése; #1649 Duchess + Reverie, #1651 Own Your
       Crown, korábban #1493, #1572, #1581): a levél- és pénztárképen a
       mockup rendben volt, de a BORÍTÓ fehér maradt — a terv rétegei nem
       rajzolódtak ki, a nyomdai PDF viszont jó volt. Az SVG-ből készült kép
       „betöltődik”, a beágyazott rétegképek viszont hangtalanul elmaradhatnak
       (hibás képtartalom, vagy a WebKit/Safari a beágyazott képek dekódolása
       előtt rajzol). Az üresE ezt nem fogja meg, mert a mockup háttere miatt a
       kép többi része színes. Ezért magát a tervet ellenőrizzük:
       1. minden rétegkép valóban dekódolható kép-e (tervKeppe);
       2. a kirajzolt terv „beállt-e”: kis idő múlva újrarajzolva ugyanaz-e
          (ha még változik, kivárjuk);
       3. van-e rajta érdemi tartalom: a pillanatkép tervének az előlap a
          ~35%-a, egy ép terv tehát legalább ennyit fed, az üres (csak a
          felirat) 0–3%-ot. A küszöb 5%.
       Ha így sem lesz jó, újra letöltjük és újrarajzoljuk (legfeljebb 3-szor),
       végül a kép NEM megy fel: a levélben a tartalék kép marad, a pótló
       később újra megpróbálja. */
    var TERV_MIN_FEDES = 0.05;
    function tervLenyomata(kep, sz, mg) {
        try {
            var c = document.createElement('canvas');
            c.width = 64; c.height = Math.max(1, Math.round(64 * mg / Math.max(1, sz)));
            var k = c.getContext('2d');
            k.drawImage(kep, 0, 0, c.width, c.height);
            var d = k.getImageData(0, 0, c.width, c.height).data, fedo = 0;
            for (var i = 3; i < d.length; i += 4) if (d[i] > 32) fedo++;
            return { fedes: fedo / (c.width * c.height), adat: d };
        } catch (e) { return null; }   // ha nem mérhető, nem akadályozunk
    }
    function elter(a, b) {
        if (!a || !b || a.adat.length !== b.adat.length) return 0;
        var osszeg = 0;
        for (var i = 0; i < a.adat.length; i++) osszeg += Math.abs(a.adat[i] - b.adat[i]);
        return osszeg / a.adat.length;
    }
    function varj(ms) { return new Promise(function (kesz) { setTimeout(kesz, ms); }); }
    function tervKeppeEllenorizve(elem, sz, mg, stilus) {
        function beallt(kep, elozo, n) {
            return varj(300).then(function () {
                var most = tervLenyomata(kep, sz, mg);
                if (!most || elter(elozo, most) < 1 || n >= 4) return most;
                return beallt(kep, most, n + 1);   // még változik: kivárjuk
            });
        }
        function kor(i) {
            return tervKeppe(elem, sz, mg, stilus).then(function (kep) {
                var dekod = (kep.decode ? kep.decode() : Promise.resolve()).catch(function () { });
                return dekod.then(function () { return beallt(kep, tervLenyomata(kep, sz, mg), 0); }).then(function (meres) {
                    if (meres && meres.fedes < TERV_MIN_FEDES) throw new Error('ures borito');
                    return kep;
                });
            }).catch(function (baj) {
                if (i >= 2) throw baj;
                return varj(i ? 1500 : 600).then(function () { return kor(i + 1); });
            });
        }
        return kor(0);
    }

    /* ---------- a pillanatképből valódi képfájl ---------- */

    /* Üres-e a vászon? A kép fehér alapon indul, és a mockup háttere meg a
       borító színezi be. Lemérve a 2026-10-10 és 10-25 közti 221 valódi
       levélképen a nem fehér képpontok aránya legalább 0,65 volt; az
       egyetlen üres képé 0,00. A küszöb 0,05, bőven a kettő között. */
    function uresE(vaszon) {
        try {
            var kicsi = document.createElement('canvas');
            kicsi.width = 48; kicsi.height = 48;
            var k = kicsi.getContext('2d');
            k.drawImage(vaszon, 0, 0, 48, 48);
            var adat = k.getImageData(0, 0, 48, 48).data;
            var szines = 0;
            for (var i = 0; i < adat.length; i += 4) {
                if (adat[i] < 250 || adat[i + 1] < 250 || adat[i + 2] < 250) szines++;
            }
            return szines / (48 * 48) < 0.05;
        } catch (e) { return false; }   // ha nem mérhető, nem akadályozunk
    }

    function rajzoldKeppe(adat, szalag) {
        if (!adat || !adat.m) return Promise.reject(new Error('nincs terv'));

        var doboz = document.createElement('div');
        doboz.setAttribute('aria-hidden', 'true');
        doboz.style.cssText = 'position:fixed;left:-99999px;top:0;opacity:0;pointer-events:none;z-index:-1;width:' +
            adat.w + 'px;height:' + adat.h + 'px;';
        // A sor szalagszíne a képen is (assets/brinuti-szalag-mockup.js).
        doboz.innerHTML = (szalag && window.brinutiSzalag) ? window.brinutiSzalag.htmlbe(adat.m, szalag) : adat.m;
        var mockup = doboz.firstElementChild;
        if (!mockup) return Promise.reject(new Error('nincs mockup'));
        mockup.style.left = '0px';
        mockup.style.top = '0px';
        mockup.style.transform = 'none';
        document.body.appendChild(doboz);

        function takarits() { if (doboz.parentNode) doboz.parentNode.removeChild(doboz); }

        var nagyitas = Math.max(1, HOSSZABB_OLDAL / Math.max(adat.w, adat.h));
        var vaszon = document.createElement('canvas');
        vaszon.width = Math.round(adat.w * nagyitas);
        vaszon.height = Math.round(adat.h * nagyitas);
        var rajz = vaszon.getContext('2d');
        // A levelek világos háttéren jelennek meg, a JPEG pedig nem tud
        // átlátszóságot — ezért fehérrel indulunk.
        rajz.fillStyle = '#ffffff';
        rajz.fillRect(0, 0, vaszon.width, vaszon.height);
        rajz.scale(nagyitas, nagyitas);

        var alap = mockup.getBoundingClientRect();
        // Dokumentumsorrendben: pont a rétegek egymásra rakásának sorrendje.
        var retegek = Array.prototype.slice.call(mockup.querySelectorAll('img, svg.tee-printarea-artwork'));
        if (!retegek.length) { takarits(); return Promise.reject(new Error('nincs réteg')); }
        var meglettATerv = false;

        return betukStilusa(adat.f).then(function (stilus) {
            return retegek.reduce(function (sor, elem) {
                return sor.then(function () {
                    var hely = elem.getBoundingClientRect();
                    var sz = hely.width, mg = hely.height;
                    if (sz < 1 || mg < 1) return null;
                    var x = hely.left - alap.left, y = hely.top - alap.top;
                    // Maga a terv kötelező: enélkül üres borító menne ki a
                    // levélben, ami rosszabb, mint a tartalék kép. A mockup
                    // többi rétege (árnyék, háttér) nélkül viszont még
                    // használható a kép.
                    var aTerv = elem.tagName.toLowerCase() !== 'img';
                    var igeret = aTerv
                        ? tervKeppeEllenorizve(elem, sz, mg, stilus)
                        : ujraProbal(function () { return toltsdBeAKepet(elem.currentSrc || elem.src, true); });
                    return igeret.then(function (kep) {
                        rajz.drawImage(kep, x, y, sz, mg);
                        if (aTerv) meglettATerv = true;
                    }, function (baj) {
                        if (aTerv) throw baj;
                    });
                });
            }, Promise.resolve());
        }).then(function () {
            takarits();
            if (!meglettATerv) throw new Error('a terv nem került rá a képre');
            if (uresE(vaszon)) throw new Error('ures kep');
            return new Promise(function (kesz, hiba) {
                vaszon.toBlob(function (blob) {
                    if (blob) kesz({ blob: blob, w: vaszon.width, h: vaszon.height });
                    else hiba(new Error('nem lett kép'));
                }, 'image/jpeg', 0.92);
            });
        }, function (baj) { takarits(); throw baj; });
    }

    /* ---------- feltöltés a Teeinblue fotótárába ---------- */

    function toltsdFel(kep) {
        var nev = 'brinuti-elonezet-' + Date.now().toString(36) + '.jpg';
        return fetch(FELTOLTO, {
            method: 'POST',
            headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
            body: JSON.stringify({
                filename: nev,
                filesize: kep.blob.size,
                mimetype: 'image/jpeg',
                strategy: 'any',
                width: kep.w,
                height: kep.h
            })
        }).then(function (valasz) {
            if (!valasz.ok) throw new Error('feltöltési cím: ' + valasz.status);
            return valasz.json();
        }).then(function (valasz) {
            /* 2026-11-03: a Teeinblue feltöltő szolgáltatása november 2. óta
               Cloudflare R2 címet ad (…r2.cloudflarestorage.com), és az R2
               tárolón nincs CORS-szabály: a böngésző PUT-ja minden böngészőben
               elbukik („Failed to fetch” / „Load failed” / „NetworkError”), így
               a levélkép nem készült el (a rendelések ~95%-án hiányzott a
               _brinuti_elonezet). Ilyenkor a képet a saját Workerünk teszi fel
               az aláírt címre (csak a Teeinblue R2 feltöltési címét fogadja el),
               a nyilvános cím pedig a Teeinblue R2 CDN-je. */
            if (/^https:\/\/[0-9a-f]{32}\.r2\.cloudflarestorage\.com\//.test(String(valasz.signed_url || ''))) {
                return fetch(R2_ATJATSZO + encodeURIComponent(valasz.signed_url), {
                    method: 'POST',
                    headers: { 'Content-Type': 'image/jpeg' },
                    body: kep.blob
                }).then(function (v) {
                    if (!v.ok) throw new Error('feltöltés (átjátszó): ' + v.status);
                    return v.json();
                }).then(function (j) {
                    if (!j || !j.ok || !/^https:\/\/cdnx\.teeinblue\.com\/r2\/customers\/uploads\//.test(String(j.url || ''))) throw new Error('feltöltés (átjátszó): hibás válasz');
                    return j.url;
                });
            }
            return fetch(valasz.signed_url, {
                method: 'PUT',
                body: kep.blob,
                headers: {
                    'Content-Type': 'image/jpeg',
                    'Cache-Control': 'public,max-age=31536000,immutable',
                    'x-amz-acl': 'public-read'
                }
            }).then(function (v) {
                if (!v.ok) throw new Error('feltöltés: ' + v.status);
                /* A nyilvános cím az a tároló, AHOVÁ ténylegesen feltöltöttünk:
                   a Teeinblue a kérő helye szerint választ tárolót (Európából
                   az eu-central-2-t, máshonnan pl. az us-east-1-et). A fix
                   európai címmel külföldről (VPN, utazás) nem létező, 403-as
                   kép került a levélbe (lemérve 2026-10-16). */
                var feltoltott = String(valasz.signed_url || '').split('?')[0];
                if (/^https:\/\/s3\.[a-z0-9-]+\.wasabisys\.com\/teeinblue-cdn-[a-z]+\//.test(feltoltott)) return feltoltott;
                return TAROLO + String(valasz.path || '').replace(/^[a-z]+:/, '');
            });
        });
    }

    /* ---------- a cím felírása a kosársorra ---------- */

    function irdASorra(azon, cim, kor) {
        kerdLeAKosarat(function (kosar) {
            if (!kosar || !kosar.items) return;
            var cel = null;
            kosar.items.forEach(function (tetel) {
                if (tetel.properties && tetel.properties._customization_id === azon) cel = tetel;
            });
            if (!cel) return;
            var mar = cel.properties._brinuti_elonezet === cim;
            var tulajdonsagok = {};
            Object.keys(cel.properties).forEach(function (k) { tulajdonsagok[k] = cel.properties[k]; });
            tulajdonsagok._brinuti_elonezet = cim;
            /* Szerkesztés után a Teeinblue a régi sor pénztárképét is átmásolja
               (2026-10-16): ha az nem ehhez a tervhez tartozik, levesszük — a
               pénztárkép-szkript az új levélképből újat készít. */
            if (tulajdonsagok._brinuti_kep && String(tulajdonsagok._brinuti_kep).indexOf(azon) < 0) {
                delete tulajdonsagok._brinuti_kep;
                mar = false;
            }
            /* XMLHttpRequest-tel, hogy a lap három fetch-burkolója közül egyik
               se induljon el: a kosár tartalma, ára és darabszáma nem változik,
               csak egy rejtett adat kerül a sorra. */
            if (!mar) try {
                var keres = new XMLHttpRequest();
                keres.open('POST', '/cart/change.js', true);
                keres.setRequestHeader('Content-Type', 'application/json');
                keres.send(JSON.stringify({ id: cel.key, quantity: cel.quantity, properties: tulajdonsagok }));
            } catch (e) { /* marad a tartalék kép a levélben */ }
            // A Teeinblue a mentés végén maga is ír a kosárba a saját
            // adataival. Ha a mi írásunk épp elé kerül, a cím nyomtalanul
            // elvész, és a levélbe a szerkesztés előtti napló menne ki —
            // ezért egyszer visszanézünk rá, és pótoljuk.
            // 2026-10-01: egyszeri ellenőrzés helyett háromszor (3, 8 és 15 mp),
            // mert gyors, többnaplós kosárba tételnél a cím elveszhetett (#1332).
            kor = kor || 0;
            if (!cim || kor >= 3) return;
            setTimeout(function () {
                kerdLeAKosarat(function (ujra) {
                    var megvan = false;
                    ((ujra && ujra.items) || []).forEach(function (tetel) {
                        if (tetel.properties && tetel.properties._customization_id === azon &&
                            tetel.properties._brinuti_elonezet === cim) megvan = true;
                    });
                    irdASorra(azon, cim, kor + 1);   // hiányzik: pótoljuk; megvan: később újra megnézzük
                });
            }, [3000, 5000, 7000][kor]);
        });
    }

    // A kosársor szalagszíne (a kulcs kampányonként más, de a „szalag” szó benne van).
    function sorSzalagja(tul) {
        var ertek = '';
        Object.keys(tul || {}).some(function (k) {
            if (k.charAt(0) === '_' || !/szalag/i.test(k)) return false;
            ertek = String(tul[k] || '');
            return true;
        });
        return ertek;
    }

    /* Szalagváltás a kosár-előnézetben (2026-10-16): a levélkép a terv
       változatlansága mellett is újra elkészül, az új szalagszínnel — a
       pénztárkép-szkript az új levélképből magától újat kér. Sikertelen
       rajzoláskor marad a régi kép (régi szalaggal), nem vesszük le. */
    window.brinutiLevelkepUjra = function (azon, szalag) {
        var adat = olvasd(azon);
        if (!azon || !adat) return;
        keszitsdALevelKepet(azon, adat, '', null, szalag);
    };

    /* =====================================================================
       AZ EGYEDI VÁLTOZTATÁS KITÖRLÉSE A KOSÁRBÓL (2026-10-31, a tulaj kérése)

       Az „Egyedi változtatás a borítón” külön tétel és a napló módosított
       borítója összetartozik (_brinuti_egyedi_azon). Ha csak a külön tétel
       tűnne el, a módosítás fizetés nélkül a naplón maradna (a kosárképen és
       a levélképen), a nyomdai csere viszont elmaradna.

       Ezért a külön tétel „Törlés” gombja (data-egyedi-torles, lásd
       snippets/cart-products.liquid) nem a téma törlését hívja: figyelmeztet,
       és megerősítés után
         1. a naplóról leveszi a módosítást (_brinuti_egyedi_*, a levél- és
            a pénztárkép, és a böngészőben tárolt tervből a rárakott előlapot),
         2. kitörli a külön tételt,
         3. újrarajzolja a kosarat, és új levélképet készít az EREDETI borítóról.
       A kosár-egyeztetés (egyeztetdAzEgyedit) nem teszi vissza a külön tételt,
       mert a naplón már nincs egyedi azonosító. A kéréseket XMLHttpRequest-tel
       küldjük (mint az irdASorra), hogy a lap fetch-burkolói ne induljanak el.
       ===================================================================== */
    var EGYEDI_KIEGESZITO = 'egyedi-valtoztatas-a-boriton';
    var EGYEDI_LEVESZ = ['_brinuti_egyedi_kep', '_brinuti_egyedi_azon', '_brinuti_elonezet', '_brinuti_kep'];

    // A tárolt tervből leveszi a jóváhagyott, rárakott előlapot (<image data-bev>).
    function levedAzEgyediElolapot(azon) {
        var adat = olvasd(azon);
        if (!adat || !adat.m) return false;
        var sablon = document.createElement('template');
        sablon.innerHTML = adat.m;
        var rakott = sablon.content.querySelectorAll('image[data-bev]');
        if (!rakott.length) return false;
        Array.prototype.forEach.call(rakott, function (e) { e.parentNode.removeChild(e); });
        adat.m = sablon.innerHTML;
        adat.t = Date.now();
        mentsd(azon, adat);
        return true;
    }

    function kosarValtoztat(torzs, kesz) {
        try {
            var keres = new XMLHttpRequest();
            keres.open('POST', '/cart/change.js', true);
            keres.setRequestHeader('Content-Type', 'application/json');
            keres.onload = function () { kesz(keres.status >= 200 && keres.status < 300); };
            keres.onerror = function () { kesz(false); };
            keres.send(JSON.stringify(torzs));
        } catch (e) { kesz(false); }
    }

    function torolDAzEgyedit(egyediAzon, kesz) {
        kerdLeAKosarat(function (kosar) {
            var naplo = null, kieg = null;
            ((kosar && kosar.items) || []).forEach(function (t) {
                var p = t.properties || {};
                if (!egyediAzon || p._brinuti_egyedi_azon !== egyediAzon) return;
                if (t.handle === EGYEDI_KIEGESZITO) kieg = t; else naplo = t;
            });
            if (!naplo && !kieg) { kesz(false); return; }
            var tulajdonsagok = {}, terv = '';
            if (naplo) {
                terv = naplo.properties._customization_id || '';
                Object.keys(naplo.properties).forEach(function (k) {
                    if (EGYEDI_LEVESZ.indexOf(k) < 0) tulajdonsagok[k] = naplo.properties[k];
                });
            }
            function vege(sikerult) {
                // Az első rész újrarajzolja a fiókot (és lefuttatja a kosár-egyeztetést, árlépcsőt).
                if (window.brinutiKosarFrissites) { try { window.brinutiKosarFrissites(); } catch (e) { } }
                // Az eredeti borítóról új levélkép (a pénztárkép-szkript abból kér újat).
                if (sikerult && terv) setTimeout(function () { window.brinutiLevelkepUjra(terv, sorSzalagja(tulajdonsagok)); }, 600);
                kesz(sikerult);
            }
            function kiveszed() {
                if (!kieg) { vege(true); return; }
                kosarValtoztat({ id: kieg.key, quantity: 0 }, function (jo) {
                    if (jo) { vege(true); return; }
                    // A naplóról közben elfogyott az azonosító, a kosár-egyeztetés a külön tételt már kivehette: ha nincs a kosárban, kész.
                    kerdLeAKosarat(function (k2) {
                        var megvan = ((k2 && k2.items) || []).some(function (t) { return t.key === kieg.key; });
                        vege(!!k2 && !megvan);
                    });
                });
            }
            if (!naplo) { kiveszed(); return; }
            // Előbb a naplóról kerül le a módosítás, hogy a külön tételt senki ne tegye vissza.
            if (terv) {
                levedAzEgyediElolapot(terv);
                try { localStorage.removeItem(LEVELKEP_CIM + terv); } catch (e) { }
            }
            kosarValtoztat({ id: naplo.key, quantity: naplo.quantity, properties: tulajdonsagok }, function (jo) {
                if (!jo) { kesz(false); return; }
                kiveszed();
            });
        });
    }

    var egyediAblakStilus = false;
    function egyediAblak(muvelet) {
        if (!egyediAblakStilus) {
            egyediAblakStilus = true;
            var st = document.createElement('style');
            // A dobozstílus (CLAUDE.md): 1px #e6e1d6 keret, 10px sarok, #2c2c2c szöveg, #1f1f1f cím és gomb, 6px-es gombsarok.
            st.textContent =
                'dialog.bet{padding:0;border:1px solid #e6e1d6;border-radius:10px;background:#fbf9f4;color:#2c2c2c;width:min(92vw,380px);max-width:92vw;box-shadow:0 12px 40px rgb(0 0 0 / .18)}' +
                'dialog.bet::backdrop{background:rgb(31 31 31 / .45)}' +
                'dialog.bet .bet__belso{padding:22px 20px 18px}' +
                'dialog.bet .bet__cim{font-family:var(--font-heading--family);font-size:20px;line-height:1.25;color:#1f1f1f;margin:0 0 10px}' +
                'dialog.bet .bet__szoveg{font-size:15px;line-height:1.5;margin:0 0 18px;text-wrap:balance}' +
                'dialog.bet .bet__hiba{color:#9b2c2c;font-size:14px;margin:-8px 0 12px}' +
                'dialog.bet .bet__gombok{display:flex;gap:10px}' +
                'dialog.bet .bet__gomb{flex:1 1 0;min-height:46px;padding:0 10px;border:1px solid #1f1f1f;border-radius:6px;font:inherit;font-size:15px;line-height:1.2;cursor:pointer}' +
                'dialog.bet .bet__gomb--fo{background:#1f1f1f;color:#fff}' +
                'dialog.bet .bet__gomb--masik{background:transparent;color:#1f1f1f}' +
                'dialog.bet .bet__gomb[disabled]{opacity:.6;cursor:default}';
            document.head.appendChild(st);
        }
        var ablak = document.createElement('dialog');
        ablak.className = 'bet';
        ablak.setAttribute('aria-labelledby', 'betCim');
        ablak.setAttribute('aria-describedby', 'betSzoveg');
        ablak.innerHTML =
            '<div class="bet__belso">' +
            '<div class="bet__cim" id="betCim" role="heading" aria-level="2">Egyedi változtatás törlése</div>' +
            '<p class="bet__szoveg" id="betSzoveg">Ha ezt a tételt törlöd, az egyedi változtatás a naplóról is törlődik, és a napló az eredeti borítóval marad a kosárban.</p>' +
            '<div class="bet__hiba" hidden>Nem sikerült törölni, próbáld újra.</div>' +
            '<div class="bet__gombok">' +
            '<button type="button" class="bet__gomb bet__gomb--fo" data-bet="nem" autofocus>Mégsem</button>' +
            '<button type="button" class="bet__gomb bet__gomb--masik" data-bet="igen">Törlés</button>' +
            '</div></div>';
        document.body.appendChild(ablak);
        var dolgozik = false;
        function bezar() { try { ablak.close(); } catch (e) { ablak.removeAttribute('open'); } if (ablak.parentNode) ablak.parentNode.removeChild(ablak); }
        ablak.addEventListener('click', function (esemeny) {
            if (dolgozik) return;
            var gomb = esemeny.target.closest && esemeny.target.closest('[data-bet]');
            if (gomb && gomb.getAttribute('data-bet') === 'igen') {
                dolgozik = true;
                var gombok = ablak.querySelectorAll('.bet__gomb');
                Array.prototype.forEach.call(gombok, function (g) { g.disabled = true; });
                ablak.querySelector('[data-bet="igen"]').textContent = 'Törlés…';
                ablak.querySelector('.bet__hiba').hidden = true;
                muvelet(function (sikerult) {
                    if (sikerult) { bezar(); return; }
                    dolgozik = false;
                    Array.prototype.forEach.call(gombok, function (g) { g.disabled = false; });
                    ablak.querySelector('[data-bet="igen"]').textContent = 'Törlés';
                    ablak.querySelector('.bet__hiba').hidden = false;
                });
            } else if (gomb || esemeny.target === ablak) {
                bezar();   // „Mégsem” vagy a háttérre kattintás: semmi nem változik
            }
        });
        ablak.addEventListener('cancel', function (esemeny) { if (dolgozik) esemeny.preventDefault(); });
        ablak.addEventListener('close', function () { if (!dolgozik && ablak.parentNode) ablak.parentNode.removeChild(ablak); });
        if (typeof ablak.showModal === 'function') ablak.showModal(); else ablak.setAttribute('open', '');
    }

    // A külön tétel Törlés gombja: figyelmeztetés, nem azonnali törlés.
    document.addEventListener('click', function (esemeny) {
        var gomb = esemeny.target.closest && esemeny.target.closest('[data-egyedi-torles]');
        if (!gomb) return;
        esemeny.preventDefault();
        esemeny.stopImmediatePropagation();
        var egyediAzon = gomb.getAttribute('data-egyedi-torles') || '';
        egyediAblak(function (kesz) { torolDAzEgyedit(egyediAzon, kesz); });
    }, true);

    // A már feltöltött levélképek címe tervenként: ha a sorra írás elveszne,
    // a pótló újrarajzolás nélkül visszaírja.
    var LEVELKEP_CIM = 'brinuti-elo-cim:';
    function keszitsdALevelKepet(azon, adat, regiCim, vege, szalag) {
        if (!azon || !adat) { if (vege) vege(false); return; }
        rajzoldKeppe(adat, szalag).then(function (kep) {
            if (kep.blob.size < LEGKISEBB_FAJL) throw new Error('túl kicsi kép');
            return toltsdFel(kep);
        }).then(function (cim) {
            // Megvan a kép: innentől nincs mit pótolni a következő betöltésen.
            toroldAFuggot();
            try { localStorage.setItem(LEVELKEP_CIM + azon, cim); } catch (e) { }
            irdASorra(azon, cim);
            if (vege) vege(true);
        }).catch(function (hiba) {
            // A hiba szövege a pénztár-szkript hibajelzéséhez (_bk_diag) kell.
            try { sessionStorage.setItem('bl-hiba', String((hiba && hiba.message) || hiba).replace(/[^\w .:-]/g, '').slice(0, 30)); } catch (e) { }
            if (vege) vege(false);
            /* Szerkesztéskor a Teeinblue az új sorra átmásolja a RÉGI terv
               előnézetét is. Ha az újat nem sikerült elkészíteni, ez a cím a
               szerkesztés ELŐTTI naplót vinné a levélbe, vagyis nem azt, amit
               a vásárló utoljára jóváhagyott — ezért inkább levesszük, és
               marad a Teeinblue saját tartalék képe. */
            if (regiCim) irdASorra(azon, '');
        });
    }

    /* =====================================================================
       LEVÉLKÉP-PÓTLÓ (2026-10-16, a tulaj kérése: „minden vásárló minden
       levélben a saját képét kapja”).

       A rendelések ~15%-ában hiányzott a levélkép (_brinuti_elonezet), így a
       levélbe az általános termékkép került. A kép a kosárba tételkor készül
       (rajzolás + feltöltés, néhány mp) — ha a vásárló közben továbblép, a
       hálózat megakad vagy a sorra írás elvész, eddig semmi nem pótolta.
       Most a böngészőben eltett terv (localStorage) alapján pótoljuk:
       minden betöltéskor, a kosár változása után, és a pénztárba lépés előtt
       (ott legfeljebb 12 mp-ig várunk rá).
       ===================================================================== */
    var potloFut = {};
    function hianyzoLevelkepek(kosar) {
        return ((kosar && kosar.items) || []).filter(function (t) {
            var p = t.properties || {};
            return p._customization_id && !p._brinuti_elonezet;
        });
    }
    function potoldALevelkepeket(kesz) {
        kerdLeAKosarat(function (kosar) {
            var hiany = hianyzoLevelkepek(kosar);
            var javithato = 0;
            hiany.forEach(function (t) {
                var azon = t.properties._customization_id;
                if (potloFut[azon]) { javithato++; return; }
                var cim = null;
                try { cim = localStorage.getItem(LEVELKEP_CIM + azon); } catch (e) { }
                if (cim) { irdASorra(azon, cim); javithato++; return; }
                var adat = olvasd(azon);
                if (!adat) return;
                var kulcs = 'bl-potlo-' + azon, szam = 0;
                try { szam = Number(sessionStorage.getItem(kulcs) || 0); sessionStorage.setItem(kulcs, String(szam + 1)); } catch (e) { }
                if (szam >= 3) return;
                javithato++;
                potloFut[azon] = true;
                keszitsdALevelKepet(azon, adat, '', function () { delete potloFut[azon]; }, sorSzalagja(t.properties));
            });
            if (kesz) kesz(javithato);
        });
    }
    var potloOra = null;
    function potoldKesobb(ms) {
        clearTimeout(potloOra);
        potloOra = setTimeout(function () { potoldALevelkepeket(); }, ms);
    }
    // Kosárváltozás után: a rendes út (kosárba tétel → kép) kap 8 mp előnyt.
    try {
        new PerformanceObserver(function (lista) {
            lista.getEntries().forEach(function (e) {
                if (/\/cart\/(add|change|update)/.test(e.name)) potoldKesobb(8000);
            });
        }).observe({ type: 'resource', buffered: false });
    } catch (e) { }
    document.addEventListener('visibilitychange', function () { if (!document.hidden) potoldKesobb(1500); });
    potoldKesobb(4000);

    /* Pénztárba lépés előtt: ha egy naplónak még nincs levélképe, de pótolható,
       megvárjuk (legfeljebb 12 mp). A pénztárkép-szkript (brinuti-penztar-kep.js)
       a saját várakozását ezután végzi el, a levélkép címéből. */
    var penztarEngedve = 0;
    window.addEventListener('click', function (e) {
        var gomb = e.target && e.target.closest && e.target.closest('button[name="checkout"], input[name="checkout"], a[href*="/checkout"]');
        if (!gomb) return;
        if (Date.now() - penztarEngedve < 1500) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        var kezdet = Date.now();
        gomb.setAttribute('aria-busy', 'true');
        function tovabb() {
            gomb.removeAttribute('aria-busy');
            penztarEngedve = Date.now();
            gomb.click();
        }
        (function kor(elso) {
            kerdLeAKosarat(function (kosar) {
                var hiany = hianyzoLevelkepek(kosar);
                if (!hiany.length || Date.now() - kezdet > 12000) { tovabb(); return; }
                if (elso) {
                    potoldALevelkepeket(function (javithato) {
                        if (!javithato) { tovabb(); return; }
                        setTimeout(function () { kor(false); }, 1200);
                    });
                    return;
                }
                setTimeout(function () { kor(false); }, 1200);
            });
        })(true);
    }, true);

    /* ---------- kosárba tételkor elmentjük a tervet ---------- */

    // A /cart.js-t szándékosan XMLHttpRequest-tel kérjük: a fájl fentebbi
    // része becsomagolja a window.fetch-et, és a saját kérésünk feleslegesen
    // újraindítaná a kupon- és upsell-logikát.
    function kerdLeAKosarat(kesz) {
        try {
            var keres = new XMLHttpRequest();
            keres.open('GET', '/cart.js?bl=' + Date.now(), true);
            keres.onload = function () {
                var kosar = null;
                try { kosar = JSON.parse(keres.responseText); } catch (e) { kosar = null; }
                kesz(kosar);
            };
            keres.onerror = function () { kesz(null); };
            keres.send();
        } catch (e) { kesz(null); }
    }

    /* A kosárból indított szerkesztéskor a Teeinblue a saját ablakában nyitja
       meg a tervet, és ehhez lekéri a szerkesztett tétel kampányát. Erre
       várunk rá, hogy mentéskor már kéznél legyen a 2. mockup mértana. */
    document.addEventListener('click', function (esemeny) {
        var gomb = esemeny.target.closest && esemeny.target.closest('[class*="tee-edit"]');
        if (gomb) figyeldAKampanyokat(20000);
    }, true);

    /* Az alkalmazások (kupon, upsell) a lap betöltésekor maguktól is
       módosítják a kosarat. Ilyenkor a vásárló nem hagyott jóvá semmit, tehát
       nincs mit elmenteni — a saját kezű kosárba tételt és mentést viszont
       mindig megelőzi, hogy pár másodperce hozzáért a laphoz. */
    var utolsoErintes = 0;
    ['pointerdown', 'keydown'].forEach(function (nev) {
        document.addEventListener(nev, function () { utolsoErintes = Date.now(); }, true);
    });

    /* A mentés túlélése a lap újratöltésén. A pillanatképet még a kérés
       előtt elrakjuk, és ha a párosítás nem futott le (mert a Teeinblue
       közben újratöltötte a lapot), a következő betöltéskor bepótoljuk. */
    var FUGGO = 'brinuti-elo-fuggo';

    var LEGTOBB_POTLAS = 3;   // ennyi betöltésen át próbálkozunk

    function teddFelreAFuggot(pillanat, azon) {
        try {
            localStorage.setItem(FUGGO, JSON.stringify({
                p: pillanat, az: azon, t: Date.now(), k: 0
            }));
        } catch (e) { }
    }

    function toroldAFuggot() {
        try { localStorage.removeItem(FUGGO); } catch (e) { }
    }

    function potoldAFuggot() {
        var nyers = null;
        try { nyers = localStorage.getItem(FUGGO); } catch (e) { }
        if (!nyers) return;
        var adat = null;
        try { adat = JSON.parse(nyers); } catch (e) { }
        // Egy percnél régebbi pillanatkép már nem ehhez a kosárhoz tartozik.
        if (!adat || !adat.p || !adat.az || Date.now() - adat.t > 60000) {
            toroldAFuggot();
            return;
        }
        /* A rekordot NEM most dobjuk el, hanem akkor, amikor a feltöltött
           cím elindul a sor felé. A kép elkészítése több másodperc, és a
           Teeinblue a szerkesztés mentésekor újratölti a lapot: ha itt
           törölnénk, a félbemaradt munkát már semmi sem pótolná. A
           számláló viszont megvéd a végtelen körtől, ha a kép sehogy sem
           akar elkészülni. */
        var kiserlet = (adat.k || 0) + 1;
        if (kiserlet > LEGTOBB_POTLAS) {
            toroldAFuggot();
            return;
        }
        try {
            localStorage.setItem(FUGGO, JSON.stringify({
                p: adat.p, az: adat.az, t: adat.t, k: kiserlet
            }));
        } catch (e) { }
        parositsd(adat.p, adat.az);
    }

    /* A pillanatképet ahhoz a sorhoz kötjük, amelyiknek a terv-azonosítóját a
       Teeinblue elküldte a kérésben — nem az oldal címéből találgatunk. */
    function parositsd(pillanat, azon) {
        if (!pillanat || !azon) return;
        kerdLeAKosarat(function (kosar) {
            if (!kosar || !kosar.items) return;
            var cel = null;
            kosar.items.forEach(function (tetel) {
                if (tetel.properties && tetel.properties._customization_id === azon) cel = tetel;
            });
            if (!cel) return;
            mentsd(azon, pillanat);
            /* A függő rekordot itt SZÁNDÉKOSAN nem törüljük: a levélbe menő
               kép elkészítése és feltöltése még hátravan, és a Teeinblue a
               szerkesztés mentésekor újratöltheti a lapot. A törlés akkor
               jön, amikor a kész cím elindul a sor felé. */
            // A levélbe menő képfájl a háttérben készül el ugyanebből a tervből.
            keszitsdALevelKepet(azon, pillanat, cel.properties._brinuti_elonezet || '', null, sorSzalagja(cel.properties));
            // Szerkesztés után a sorban még a régi terv lehet kirajzolva.
            Array.prototype.forEach.call(document.querySelectorAll('[data-brinuti-elo="' + azon + '"] .brinuti-elonezet'), function (regi) {
                regi.parentNode.removeChild(regi);
            });
            rajzoldAKosarban();
        });
    }

    var eredetiFetch = window.fetch;

    /* Melyik tervről szól ez a kosárkérés? A Teeinblue minden sorhoz elküldi a
       terv azonosítóját is — ebből pontosan tudjuk, melyik tételé a
       pillanatkép. Amiben nincs azonosító (mennyiségváltás, sor törlése, az
       upsell- és kuponalkalmazások kérései), ahhoz nincs mit elmenteni. */
    function keresTervazonositoja(cim, beallitasok) {
        if (typeof cim !== 'string') return '';
        if (cim.indexOf('/cart/add') < 0 && cim.indexOf('/cart/change') < 0) return '';
        /* A kosár-előnézet szalag/belív váltása (zoomIrdASorra) is a teljes
           tulajdonságlistát küldi, benne a terv azonosítójával — de az nem
           terv-mentés. Pillanatképet akkor a lapon épp látható tervről
           készítettünk, ami a termékoldalon az EREDETI (alap) terv: a
           kosárban a szerkesztett terv helyére az került (a tulaj jelezte
           2026-10-16, mintaváltás után). */
        var fejlec = beallitasok && beallitasok.headers;
        if (fejlec) {
            var jel = typeof fejlec.get === 'function' ? fejlec.get('X-Brinuti-Tulajdonsag') : fejlec['X-Brinuti-Tulajdonsag'];
            if (jel) return '';
        }
        var test = beallitasok && beallitasok.body;
        if (typeof test !== 'string') return '';
        var adat = null;
        try { adat = JSON.parse(test); } catch (e) { return ''; }
        var tulajdonsagok = adat && adat.properties;
        if (!tulajdonsagok || !tulajdonsagok._customization_id) return '';
        // Csak az számít, amit a vásárló maga indított el.
        if (Date.now() - utolsoErintes > 15000) return '';
        return String(tulajdonsagok._customization_id);
    }

    // A mentés pillanatában beírt szövegek (a szerkesztőablakból, ha az
    // nyitva van, különben a termékoldali űrlapból), összehasonlításra
    // egyszerűsítve: kisbetű, szóközök nélkül.
    function egyszerusit(t) { return String(t || '').toLowerCase().replace(/\s+/g, ''); }
    function beirtSzovegekMentesKor() {
        var gyoker = document.querySelector('.tee-edit-popup') || document.querySelector('#teeFormInputs');
        if (!gyoker) return [];
        return Array.prototype.filter.call(gyoker.querySelectorAll('textarea, input[type="text"]'), function (be) {
            return be.offsetParent !== null;
        }).map(function (be) { return egyszerusit(be.value); }).filter(Boolean);
    }
    function mindenSzovegRajta(pillanat, szovegek) {
        if (!szovegek.length) return true;
        // DOMParser: a képeket nem tölti le, csak a szöveget olvassuk ki.
        var kep = egyszerusit(new DOMParser().parseFromString(pillanat.m, 'text/html').body.textContent);
        return szovegek.every(function (sz) { return kep.indexOf(sz) >= 0; });
    }

    window.fetch = function () {
        var cim = arguments[0];
        if (cim && typeof cim !== 'string') cim = cim.url || '';
        /* Egyedi változtatás (2026-10-29): a jóváhagyott módosított előlap
           címe a napló sorára kerül (a nyomdai fájl cseréjéhez). */
        if (typeof cim === 'string' && cim.indexOf('/cart/add') >= 0 && window.brinutiEgyedi && window.brinutiEgyedi.aktiv() &&
            arguments[1] && typeof arguments[1].body === 'string') {
            try {
                arguments[1] = Object.assign({}, arguments[1], { body: window.brinutiEgyedi.bovit(arguments[1].body) });
            } catch (e) { /* marad az eredeti kérés */ }
        }
        var terv = keresTervazonositoja(cim, arguments[1]);
        // A pillanatképet MÉG a kérés előtt kell elkapni: utána a Teeinblue
        // űrlapja újrarajzolódik, sőt a lapot is újratöltheti.
        var pillanat = terv ? keszitsPillanatkepet() : null;
        /* Lassú telefonon a Teeinblue a gépelés után késve rajzolja újra a
           borítót: ha a vásárló rögtön ment, a pillanatkép még a RÉGI
           szöveggel készülhet (lemérve 2026-10-16, 4× lassított CPU-n). Ezért
           a beírt szövegeket is megjegyezzük, és ha nincsenek rajta a képen,
           rövid várakozás után újra fényképezünk — de csak akkor cseréljük,
           ha az új kép már mind a beírt szöveget mutatja. */
        var beirt = terv ? beirtSzovegekMentesKor() : [];
        var hianyos = !!pillanat && !mindenSzovegRajta(pillanat, beirt);
        if (pillanat) teddFelreAFuggot(pillanat, terv);
        var valasz = eredetiFetch.apply(window, arguments);
        if (!terv) return valasz;
        Promise.resolve(valasz).then(function (v) {
            if (!v || v.ok === false) return;
            if (window.brinutiEgyedi && window.brinutiEgyedi.hozzaadva) window.brinutiEgyedi.hozzaadva(terv);
            // Ha a terv a kérés pillanatában még nem volt kész — a dátum képe
            // például a böngészőben rajzolódik meg —, adunk neki még néhány
            // másodpercet. A sikerült pillanatképet viszont csak akkor
            // cseréljük le, ha az új a beírt szövegeket már hiánytalanul
            // mutatja: a mentés utáni újrarajzolás közben félkész napló
            // kerülne rá.
            var varakozasok = [250, 1000, 1500, 2000];
            var lepes = 0;
            (function probalkozz() {
                setTimeout(function () {
                    if (!pillanat || hianyos) {
                        var uj = keszitsPillanatkepet();
                        if (uj && (!pillanat || mindenSzovegRajta(uj, beirt))) {
                            pillanat = uj;
                            hianyos = !mindenSzovegRajta(uj, beirt);
                            teddFelreAFuggot(pillanat, terv);
                        }
                    }
                    var vanMeg = ++lepes < varakozasok.length;
                    if (pillanat && (!hianyos || !vanMeg)) { parositsd(pillanat, terv); return; }
                    if (vanMeg) probalkozz();
                }, varakozasok[lepes]);
            })();
        }, function () { /* sikertelen mentés: nincs mit elrakni */ });
        return valasz;
    };

    /* ---------- kirajzolás a kosárban ---------- */

    var betoltottBetuk = {};
    function toltsdABetuket(betuk) {
        (betuk || []).forEach(function (nev) {
            if (/^(serif|sans-serif|monospace|cursive|fantasy|system-ui|inherit)$/i.test(nev)) return;
            if (betoltottBetuk[nev]) return;
            betoltottBetuk[nev] = true;
            var cim = 'https://fonts.googleapis.com/css?family=' + encodeURIComponent(nev).replace(/%20/g, '+') + ':regular';
            if (document.querySelector('link[href="' + cim + '"]')) return;
            var link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = cim;
            document.head.appendChild(link);
        });
    }

    var meretFigyelo = window.ResizeObserver ? new ResizeObserver(function (bejegyzesek) {
        bejegyzesek.forEach(function (b) { meretezd(b.target); });
    }) : null;

    function meretezd(keret, hanyadik) {
        // Az ajándékutalvány kártyája nem Teeinblue-réteg, hanem néhány
        // szöveges sor a lap képén – annak a betűit kell a dobozhoz mérni.
        var buKartya = keret.querySelector('.bu-kosar-elo');
        if (buKartya) { meretezdAzUtalvanyt(keret, buKartya, hanyadik); return; }
        var burok = keret.querySelector('.brinuti-elonezet');
        var mockup = burok && burok.firstElementChild;
        if (!mockup) return;
        var alap = parseFloat(burok.getAttribute('data-bl-magassag')) || 0;
        var meret = Math.min(keret.clientWidth, keret.clientHeight) || keret.clientWidth;
        if (!alap || !meret) {
            // Csukott fiókban és még ki nem nyílt előnézeti ablakban a doboz
            // mérete 0. A ResizeObserver a megnyitáskor szól, de a biztonság
            // kedvéért néhányszor magunktól is újrapróbáljuk.
            var kor = hanyadik || 0;
            if (kor < 10) setTimeout(function () { meretezd(keret, kor + 1); }, 80);
            return;
        }
        mockup.style.transform = 'translate(-50%, -50%) scale(' + (meret / alap) + ')';
        keret.classList.add('brinuti-elonezet-van');
        if (meretFigyelo) meretFigyelo.observe(keret);
    }

    /* ---------- a szerkesztés gomb helyben tartása ----------
       A „Szerkesztés” gombot a Teeinblue teszi a sorokba, a téma csak egy
       üres dobozt ad neki (.tee-edit-customization). Valahányszor a kosár
       újrarajzolódik — kosárba tétel, darabszám, ajándékdoboz, visszalépés —,
       a sorok kicserélődnek, és a gomb a mérések szerint KÖRÜLBELÜL HÁROM
       MÁSODPERCRE eltűnik, amíg az app újra be nem teszi. Több naplónál ez
       villogásnak látszik, és a vásárló hiába nyúl érte.

       Ezért amíg az app dolgozik, ugyanolyan gombot teszünk a helyére. A
       helyőrző az app doboza MELLÉ kerül, nem bele, hogy a beillesztésnek ne
       legyünk útjában. Ha a vásárló addig kattint rá, megvárjuk az igazit, és
       továbbadjuk neki a kattintást — így a gomb nemcsak látszik, hanem
       működik is. */

    var gombMinta = null;   // az app gombjáról vett másolat (ha már láttuk)

    // A helyőrző ugyanazt az osztályt viseli, hogy a téma stílusai ráüljenek,
    // ezért MINDEN keresésből kifejezetten ki kell hagyni — különben a
    // sajátunkat néznénk az app gombjának.
    var APP_DOBOZ = '.tee-edit-customization:not(.brinuti-tee-helyorzo)';

    function valodiGomb(sor) {
        var doboz = sor.querySelector(APP_DOBOZ);
        return doboz ? doboz.querySelector('.tee-edit-button') : null;
    }

    /* Ha a Teeinblue már maga is elkapta a helyőrzőre esett kattintást (a
       saját, dokumentumszintű figyelőjével), a szerkesztő magától megnyílik —
       ilyenkor a mi továbbadott kattintásunk egy MÁSODIK ablakot nyitott az
       első fölé (mérve 2026-10-15). Ezért csak akkor nyomjuk meg a valódi
       gombot, ha addig nem nyílt meg szerkesztő. */
    function varjAGombra(sor, hatra) {
        if (document.querySelector('.tee-edit-popup')) return;
        var gomb = valodiGomb(sor);
        if (gomb) { gomb.click(); return; }
        if (hatra <= 0) return;
        setTimeout(function () { varjAGombra(sor, hatra - 1); }, 150);
    }

    function tartsdAGombot() {
        Array.prototype.forEach.call(
            document.querySelectorAll('.brinuti-cart-actions'), function (sor) {
                var doboz = sor.querySelector(APP_DOBOZ);
                if (!doboz) return;                       // ehhez a sorhoz nincs terv
                var igazi = doboz.querySelector('.tee-edit-button');
                var helyorzo = sor.querySelector('.brinuti-tee-helyorzo');
                if (igazi) {
                    if (!gombMinta) gombMinta = doboz.innerHTML;
                    if (helyorzo) helyorzo.remove();
                    return;
                }
                if (helyorzo || !gombMinta) return;        // minta nélkül nem találgatunk
                helyorzo = document.createElement('div');
                helyorzo.className = 'tee-edit-customization brinuti-tee-helyorzo';
                helyorzo.innerHTML = gombMinta;
                helyorzo.addEventListener('click', function (esemeny) {
                    esemeny.preventDefault();
                    esemeny.stopPropagation();
                    // Kis szünet, hogy a Teeinblue saját nyitása (ha volt) látsszon.
                    setTimeout(function () { varjAGombra(sor, 40); }, 1200);  // utána legfeljebb hat másodperc
                });
                doboz.parentNode.insertBefore(helyorzo, doboz);
            });
    }

    function rajzoldAKosarban() {
        tartsdAGombot();
        var keretek = document.querySelectorAll('[data-brinuti-elo]');
        Array.prototype.forEach.call(keretek, function (keret) {
            var azon = keret.getAttribute('data-brinuti-elo');
            // A csukott fiókban a sor szélessége még 0, ezért a nagyítást a
            // már kirajzolt tervekre is újraszámoljuk minden körben.
            if (keret.querySelector('.brinuti-elonezet')) { meretezd(keret); return; }
            if (!azon) return;
            var adat = olvasd(azon);
            if (!adat) return;
            var burok = keszitsBurkot(adat);
            if (!burok) return;
            keret.appendChild(burok);
            meretezd(keret);
            if (meretFigyelo) meretFigyelo.observe(keret);
        });
        rajzoldAzUtalvanyt();
    }

    /* ---------- az ajándékutalvány kártyája a kosárban (2026-09-29) ----------
       A naplónál a Teeinblue rétegeit másoljuk át; az utalványnál nincs app,
       a kártyát mi rajzoljuk. A szakasz (sections/brinuti-utalvany.liquid)
       kosárba tételkor elteszi a lap képét és a ráírt három sort, ebből a
       kevés adatból áll össze itt a kicsinyített kártya.

       A tároló csak ezen a gépen él. Ha nincs meg a terv (más eszköz, törölt
       böngészőadat), marad a termékkép, és a „Szerkesztés” gomb is rejtve
       marad – üres űrlapot nyitna, ami rosszabb, mint ha ott sincs. */
    var BU_TAR = 'brinuti-utalvany-terv:';

    function olvasdAzUtalvanyTervet(azon) {
        if (!azon) return null;
        try { return JSON.parse(localStorage.getItem(BU_TAR + azon) || 'null'); }
        catch (e) { return null; }
    }

    // A gomb megmutatása nem várhat a rajzolás késleltetésére: a sorok
    // cseréjekor egy pillanatra üresen villanna a helye, ahogy a naplók
    // Szerkesztés gombjánál is (lásd tartsdAGombot fentebb).
    function mutasdAzUtalvanyGombot() {
        Array.prototype.forEach.call(document.querySelectorAll('[data-bu-szerkeszt]'), function (gomb) {
            gomb.hidden = !olvasdAzUtalvanyTervet(gomb.getAttribute('data-bu-szerkeszt'));
        });
    }

    function rajzoldAzUtalvanyt() {
        mutasdAzUtalvanyGombot();
        Array.prototype.forEach.call(document.querySelectorAll('[data-bu-elo]'), function (keret) {
            if (keret.querySelector('.bu-kosar-elo')) { meretezd(keret); return; }
            var adat = olvasdAzUtalvanyTervet(keret.getAttribute('data-bu-elo'));
            if (!adat || !adat.kep) return;
            keret.appendChild(keszitsUtalvanyKartyat(adat));
            meretezd(keret);
            if (meretFigyelo) meretFigyelo.observe(keret);
        });
    }

    function keszitsUtalvanyKartyat(adat) {
        var burok = document.createElement('span');
        burok.className = 'brinuti-elonezet bu-kosar-elo';
        burok.setAttribute('aria-hidden', 'true');
        // Ugyanaz a mértan, mint a termékoldalon: a fájl az EGÉSZ hajtott ívet
        // mutatja, ebből az ALSÓ fél az előlap – ezért 201% magas háttér,
        // alulra igazítva (lásd sections/brinuti-utalvany.liquid).
        burok.style.backgroundImage = 'url(' + String(adat.kep).split('(').join('').split(')').join('') + ')';
        burok.style.backgroundSize = '100% 201%';
        burok.style.backgroundPosition = '50% 100%';
        burok.style.backgroundRepeat = 'no-repeat';

        // A nagy kártyán a szöveg a bal alsó sarokban ül, 20/18 px belső
        // margóval egy kb. 520 px széles lapon – ez arányosan 3,8% és 4,9%.
        // A „sav” azt mondja, meddig tiszta a papír; a rajzos lapokon
        // (Lepke, Porcelán) ez jóval kisebb, a Márványnál balról is behúz.
        var szoveg = document.createElement('span');
        szoveg.style.position = 'absolute';
        szoveg.style.display = 'block';
        szoveg.style.left = (3.8 + (Number(adat.bal) || 0)) + '%';
        szoveg.style.bottom = '4.9%';
        szoveg.style.maxWidth = ((Number(adat.sav) || 90) * 0.92) + '%';
        szoveg.style.overflow = 'hidden';
        szoveg.style.textAlign = 'left';
        szoveg.style.color = '#1f1f1f';

        szoveg.appendChild(utalvanySor('nev', adat.nev, 1, 'var(--font-heading--family, Georgia, serif)'));
        szoveg.appendChild(utalvanySor('alja', adat.alja, 0.9, ''));
        szoveg.appendChild(utalvanySor('felado', adat.felado, 0.75, ''));
        burok.appendChild(szoveg);
        return burok;
    }

    function utalvanySor(nev, szoveg, atlatszo, betu) {
        var el = document.createElement('span');
        el.className = 'bu-kosar-elo__' + nev;
        el.textContent = szoveg || '';
        el.style.display = 'block';
        el.style.lineHeight = '1.15';
        el.style.opacity = String(atlatszo);
        el.style.whiteSpace = 'nowrap';
        el.style.overflow = 'hidden';
        if (betu) {
            el.style.fontFamily = betu;
            el.style.fontWeight = 'var(--font-heading--weight, 600)';
        } else {
            el.style.marginTop = '0.18em';
        }
        return el;
    }

    // A nagy kártyán a betűk a lap szélességéhez mérten 36/14/13 pixelesek
    // egy 520 pixeles lapon – a kosár kis képén ugyanezt az arányt tartjuk,
    // így ugyanazt a lapot látja a vásárló, csak kicsiben.
    function meretezdAzUtalvanyt(keret, burok, hanyadik) {
        var szel = keret.clientWidth;
        if (!szel) {
            // Csukott fiókban a doboz még 0 széles – ugyanaz a türelem, mint
            // a naplók előnézeténél.
            var kor = hanyadik || 0;
            if (kor < 10) setTimeout(function () { meretezdAzUtalvanyt(keret, burok, kor + 1); }, 80);
            return;
        }
        var allitsd = function (valaszto, arany) {
            var el = burok.querySelector(valaszto);
            if (el) el.style.fontSize = Math.max(3, szel * arany).toFixed(2) + 'px';
        };
        allitsd('.bu-kosar-elo__nev', 0.069);
        allitsd('.bu-kosar-elo__alja', 0.027);
        allitsd('.bu-kosar-elo__felado', 0.025);
        keret.classList.add('brinuti-elonezet-van');
        if (meretFigyelo) meretFigyelo.observe(keret);
    }

    /* ---------- az „Előnézet” ablak az utalványnál (2026-10-06) ----------
       A kosár „Előnézet” gombja a nagyító-galériát nyitja (lásd fentebb,
       updateZoomContent), ami eddig az utalvány sorának képét tette nagyra –
       a RÁNYOMTATOTT SZÖVEG NÉLKÜLI lapot. Ez a függvény ugyanazt a kártyát
       rajzolja meg nagyban, mint a kis képen: az előlap a név, a „mire szól”
       sor és az aláírás a helyén. Ha a terv nem él ezen az eszközön, hamis
       értéket ad vissza, és marad a sor képe. */
    window.BrinutiUtalvanyNagy = function (keret, azon) {
        try {
            var adat = olvasdAzUtalvanyTervet(azon);
            if (!keret || !adat || !adat.kep) return false;
            keret.innerHTML = '';
            var burok = keszitsUtalvanyKartyat(adat);
            keret.appendChild(burok);
            keret.style.display = 'block';
            meretezdAzUtalvanyt(keret, burok);
            return true;
        } catch (e) { if (window.console) console.warn('utalvány-előnézet:', e); return false; }
    };

    /* Egy mentett tervből kész, beilleszthető réteghalmazt csinál. A méretét
       a meretezd() adja meg, a befogadó doboz mérete szerint. */
    function keszitsBurkot(adat) {
        if (!adat || !adat.m) return null;
        toltsdABetuket(adat.f);

        szamlalo++;
        var burok = document.createElement('span');
        burok.className = 'brinuti-elonezet';
        burok.setAttribute('aria-hidden', 'true');
        burok.setAttribute('data-bl-magassag', adat.h);
        burok.innerHTML = adat.m;

        // Az SVG-maszkok azonosítói a lapon belül egyediek kell legyenek,
        // különben két kosársor terve összeakadna.
        var atnevezes = {};
        Array.prototype.forEach.call(burok.querySelectorAll('[id]'), function (elem) {
            atnevezes['#' + elem.id] = '#' + elem.id + '-bl' + szamlalo;
            elem.id = elem.id + '-bl' + szamlalo;
        });
        Array.prototype.forEach.call(burok.querySelectorAll('*'), function (elem) {
            ['mask', 'clip-path', 'filter', 'fill'].forEach(function (nev) {
                var ertek = elem.getAttribute(nev);
                if (!ertek) return;
                Object.keys(atnevezes).forEach(function (regi) {
                    if (ertek.indexOf(regi + ')') >= 0) ertek = ertek.replace(regi + ')', atnevezes[regi] + ')');
                });
                elem.setAttribute(nev, ertek);
            });
            // Az ívre írt felirat (textPath) a pálya azonosítójára hivatkozik.
            // Ha ez az átnevezés után a semmibe mutat, a felirat egyszerűen
            // nem jelenik meg — emiatt maradt le a szöveg pl. a My Daily Life
            // naplóról a kosárban.
            ['href', 'xlink:href'].forEach(function (nev) {
                var ertek = elem.getAttribute(nev);
                if (!ertek || ertek.charAt(0) !== '#') return;
                if (atnevezes[ertek]) elem.setAttribute(nev, atnevezes[ertek]);
            });
        });

        var mockup = burok.firstElementChild;
        if (!mockup) return null;
        mockup.style.left = '50%';
        mockup.style.top = '50%';
        mockup.style.transformOrigin = 'center';
        return burok;
    }

    // A kosárbeli nagyított Előnézet is ugyanezt a tervet mutatja (lásd
    // fentebb, updateZoomContent).
    window.brinutiElonezet = { olvasd: olvasd, keszitsBurkot: keszitsBurkot, meretezd: meretezd };

    var rajzIdozito = null;
    function utemezd() {
        // A terv kirajzolása várhat a késleltetésre, a szerkesztés gomb nem:
        // ha csak 120 ezredmásodperccel később lépnénk be a helyére, a sor
        // cseréje egy pillanatra üresen villanna. Ezért erre azonnal reagálunk.
        tartsdAGombot();
        mutasdAzUtalvanyGombot();
        rajzoldAzUjSorokat();
        clearTimeout(rajzIdozito);
        rajzIdozito = setTimeout(rajzoldAKosarban, 120);
    }

    /* VILLOGÁS NÉLKÜL (2026-10-02, a tulaj jelezte): valahányszor a kosár
       újrarajzolódik (kosárba tétel, darabszám, szerkesztés), a téma új
       képkeretet tesz be a gyári dizájnnal, és a saját terv eddig csak a
       120 ms-os késleltetés után került rá — közben a gyári kép látszott,
       vagyis a kép „oda-vissza váltott”.

       A DOM-figyelő a kirajzolás ELŐTT fut le, ezért a frissen bekerült
       (még tervet nem tartalmazó) keretekbe itt AZONNAL berajzoljuk a mentett
       tervet — a gyári kép így meg sem jelenik. A késleltetett kör (lent)
       ugyanúgy lefut, az méretez és pótol.

       A friss előnézetet ez nem érinti: szerkesztés után a parositsd() menti
       az új tervet, kiveszi a régit, és újrarajzol — ez a mentés idején
       történik, nem ettől a késleltetéstől függött. */
    function rajzoldAzUjSorokat() {
        var keretek = document.querySelectorAll('[data-brinuti-elo]');
        for (var i = 0; i < keretek.length; i++) {
            var keret = keretek[i];
            var meglevo = keret.querySelector('.brinuti-elonezet');
            if (meglevo) {
                /* A téma morfolása az osztályt leszedheti (a gyári kép újra
                   látszana a terv mögött) — visszatesszük, ha a terv már
                   méretezve volt. Mérés nélkül: ez minden DOM-változásnál
                   lefut, a méretezés a késleltetett körben van. */
                var mk = meglevo.firstElementChild;
                if (mk && mk.style.transform && !keret.classList.contains('brinuti-elonezet-van')) {
                    keret.classList.add('brinuti-elonezet-van');
                }
                continue;
            }
            var azon = keret.getAttribute('data-brinuti-elo');
            if (!azon) continue;
            var adat = olvasd(azon);
            if (!adat) continue;
            var burok = keszitsBurkot(adat);
            if (!burok) continue;
            keret.appendChild(burok);
            meretezd(keret);
            if (meretFigyelo) meretFigyelo.observe(keret);
        }
    }

    function indulj() {
        // A 2. mockup mértanát előre lekérjük, hogy a kosárba tételkor már
        // kéznél legyen. A Teeinblue a saját kérését az SDK betöltése után
        // indítja, ezért egy ideig visszanézünk rá.
        figyeldAKampanyokat(30000);

        // Ha az előző oldalon a mentés az újratöltés miatt félbemaradt,
        // itt pótoljuk. A kampány mértana ehhez már nem kell: a pillanatkép
        // kész, csak a kosár megfelelő sorához kell kötni.
        potoldAFuggot();

        // A böngészőben rajzolt rétegeket előre átalakítjuk, hogy mentéskor
        // már kéznél legyenek. Másodpercenként elég ránézni.
        alakitsdAtABlobokat();
        setInterval(alakitsdAtABlobokat, 1000);

        rajzoldAKosarban();
        document.addEventListener('cart:update', utemezd);
        var figyelt = document.querySelector('cart-drawer-component') || document.body;
        new MutationObserver(utemezd).observe(figyelt, { childList: true, subtree: true });
        // A fiók nyitása csak attribútumot állít (a sorok nem cserélődnek),
        // ezért azt külön figyeljük — ekkor kapja meg a kis kép a méretét.
        var parbeszed = figyelt.querySelector && figyelt.querySelector('dialog');
        if (parbeszed) {
            new MutationObserver(utemezd).observe(parbeszed, {
                attributes: true,
                attributeFilter: ['open', 'class', 'style']
            });
        }
        var fo = document.getElementById('MainContent');
        if (fo && figyelt !== document.body && fo !== figyelt) {
            new MutationObserver(utemezd).observe(fo, { childList: true, subtree: true });
        }
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', indulj);
    else indulj();
})();

/* =========================================================================
   7. kör – 87. és 88. pont: a személyre szabó szöveges celláinak védelme
   -------------------------------------------------------------------------
   87.: ha a vásárló másik színt / mintát (vagyis másik sablont) választ, a
        Teeinblue újraépíti az űrlapot, és a beírt szöveg helyére visszaáll a
        gyári mintaszöveg. Megjegyezzük, amit a vásárló beírt, és az
        újraépítés után visszatöltjük – minden design-nál, telefonon és
        asztalon is.
   88.: az előre kitöltött (gyári) szöveg úgy viselkedjen, mint egy javaslat:
        telefonon belekattintva a kurzor a szöveg ELEJÉRE ugrik, a szöveg
        halvány szürke, és az első leütésre kitörlődik. (Asztalon marad a
        megszokott szerkesztés.)
   ========================================================================= */
(function () {
    'use strict';

    var URLAP = '#teeFormInputs';
    var HALVANY = 'bl-gyari-szoveg';

    var sajatErtek = {};      /* réteg-azonosító -> amit a vásárló beírt */
    var sorErtek = {};        /* cella sorszáma -> amit a vásárló beírt */
    var visszatoltFut = false;
    var idozito = null;

    function telefon() {
        try { return window.matchMedia('(max-width: 749px)').matches; } catch (e) { return false; }
    }

    function urlap() { return document.querySelector(URLAP); }

    /* A Teeinblue megjegyzi a vásárló korábbi szerkesztését (localStorage),
       és visszatöltéskor ugyanúgy „előre kitöltött” mezőként látjuk. Az ilyen
       szöveg NEM gyári javaslat, tehát nem halványítjuk és nem is töröljük. */
    function mentettSzovegek() {
        var keszlet = {};
        try {
            var nyers = window.localStorage.getItem('teeinblue-customizations');
            if (!nyers) return keszlet;
            JSON.parse(nyers).forEach(function (tetel) {
                var adat = tetel && tetel.customization;
                if (!adat) return;
                Object.keys(adat).forEach(function (nev) {
                    if (typeof adat[nev] === 'string') keszlet[adat[nev]] = true;
                });
            });
        } catch (e) { /* hibás tárolt adat – nem baj */ }
        return keszlet;
    }

    function szovegesMezok() {
        var u = urlap();
        if (!u) return [];
        return Array.prototype.slice.call(
            u.querySelectorAll('textarea, input[type="text"]')
        );
    }

    function kulcs(mezo) {
        var cella = mezo.closest ? mezo.closest('.tee-field') : null;
        var nev = cella ? (cella.className || '') : '';
        var talalat = /tee-field--layer-(\w+)/.exec(nev);
        if (talalat) return talalat[1];
        /* Ha nincs réteg-azonosító, a mező sorszáma a horgony. */
        var mind = szovegesMezok();
        return 'sorszam-' + mind.indexOf(mezo);
    }

    function ertekBe(mezo, ertek) {
        var proto = mezo.tagName === 'TEXTAREA'
            ? window.HTMLTextAreaElement.prototype
            : window.HTMLInputElement.prototype;
        var leiro = Object.getOwnPropertyDescriptor(proto, 'value');
        visszatoltFut = true;
        try {
            if (leiro && leiro.set) leiro.set.call(mezo, ertek);
            else mezo.value = ertek;
            mezo.dispatchEvent(new Event('input', { bubbles: true }));
            mezo.dispatchEvent(new Event('change', { bubbles: true }));
        } finally {
            visszatoltFut = false;
        }
    }

    function gyariSzoveg(mezo) { return mezo.getAttribute('data-bl-gyari') || ''; }

    function gyariAllapot(mezo) {
        return mezo.getAttribute('data-bl-erintve') !== '1'
            && gyariSzoveg(mezo) !== ''
            && mezo.value === gyariSzoveg(mezo);
    }

    function halvanyit(mezo) {
        if (telefon() && gyariAllapot(mezo)) mezo.classList.add(HALVANY);
        else mezo.classList.remove(HALVANY);
    }

    function erintve(mezo) {
        mezo.setAttribute('data-bl-erintve', '1');
        mezo.classList.remove(HALVANY);
    }

    /* ---- egy mező felkészítése (csak egyszer) ---------------------------- */
    function figyeld(mezo) {
        if (mezo.getAttribute('data-bl-fig') === '1') {
            /* Az űrlap újraépítésekor a Teeinblue ugyanazt az elemet is
               visszaadhatja – ilyenkor csak a halványítást frissítjük. */
            halvanyit(mezo);
            return;
        }
        mezo.setAttribute('data-bl-fig', '1');
        mezo.setAttribute('data-bl-gyari', mezo.value || '');
        if (mezo.value && mentettSzovegek()[mezo.value]) mezo.setAttribute('data-bl-erintve', '1');
        halvanyit(mezo);

        function elejere() {
            if (!telefon() || !gyariAllapot(mezo)) return;
            /* 88.: a kurzor a szöveg elejére kerüljön. A telefonok a koppintás
               után késleltetve teszik ki a kurzort, ezért többször is
               visszaállítjuk. */
            [0, 60, 160].forEach(function (kesleltetes) {
                setTimeout(function () {
                    if (document.activeElement !== mezo || !gyariAllapot(mezo)) return;
                    try { mezo.setSelectionRange(0, 0); } catch (e) { /* nem támogatja */ }
                }, kesleltetes);
            });
        }

        mezo.addEventListener('focus', elejere);
        mezo.addEventListener('click', elejere);

        mezo.addEventListener('blur', function () { halvanyit(mezo); });

        mezo.addEventListener('input', function () {
            if (visszatoltFut) return;
            var alap = gyariSzoveg(mezo);
            var most = mezo.value;

            if (telefon() && alap && mezo.getAttribute('data-bl-erintve') !== '1' && most !== alap) {
                /* 88.: az első leütés törölje a gyári javaslatot. A kurzor a
                   szöveg elején áll, ezért az új karakter a minta ELÉ kerül –
                   a minta maradékát vágjuk le. (Ha valahogy mégis mögé
                   kerülne, azt is kezeljük.) */
                var tiszta = null;
                if (most.length > alap.length && most.slice(most.length - alap.length) === alap) {
                    tiszta = most.slice(0, most.length - alap.length);
                } else if (most.length > alap.length && most.slice(0, alap.length) === alap) {
                    tiszta = most.slice(alap.length);
                }
                erintve(mezo);
                if (tiszta !== null && tiszta !== most) {
                    ertekBe(mezo, tiszta);
                    try { mezo.setSelectionRange(tiszta.length, tiszta.length); } catch (e) {}
                }
            } else if (most !== alap) {
                erintve(mezo);
            }

            halvanyit(mezo);
            sajatErtek[kulcs(mezo)] = mezo.value;
            sorErtek[szovegesMezok().indexOf(mezo)] = mezo.value;
        });
    }

    /* ---- 87.: a beírt szövegek visszatöltése az űrlap újjáépítése után --- */
    function visszatolt() {
        szovegesMezok().forEach(function (mezo, sor) {
            figyeld(mezo);
            var k = kulcs(mezo);
            /* Masik sablonnal masok a reteg-azonositok, ezert ha az azonosito
               alapjan nincs talalat, a cella sorszama a horgony. */
            var kell = (k in sajatErtek) ? sajatErtek[k]
                     : ((sor in sorErtek) ? sorErtek[sor] : null);
            if (kell === null) return;
            if (mezo.value === kell) return;
            /* Csak akkor írjuk felül, ha a mező a gyári (frissen épített)
               állapotában van – amit a vásárló azóta beírt, azt nem bántjuk. */
            if (mezo.getAttribute('data-bl-erintve') === '1' && mezo.value !== gyariSzoveg(mezo)) return;
            ertekBe(mezo, kell);
            if (kell !== '') erintve(mezo);
            halvanyit(mezo);
        });
    }

    function utemez() {
        if (idozito) clearTimeout(idozito);
        idozito = setTimeout(function () {
            idozito = null;
            visszatolt();
            /* A Teeinblue néha késleltetve tölti vissza a gyári szöveget,
               ezért kétszer is ellenőrzünk. */
            setTimeout(visszatolt, 600);
            setTimeout(visszatolt, 1500);
        }, 150);
    }

    function indulj() {
        var u = urlap();
        if (!u) return false;
        visszatolt();
        new MutationObserver(function () {
            if (visszatoltFut) return;
            utemez();
        }).observe(u, { childList: true, subtree: true });

        /* Ornagy: a Teeinblue nehany design-nal keson (3-5 mp) tolti vissza a
           sajat mentett allapotat, es ilyenkor felulirja a vasarlo szoveget.
           Ezert masodpercenkent ellenorizzuk - csak akkor irunk, ha tenyleg
           elveszett valami. */
        setInterval(function () {
            if (visszatoltFut) return;
            for (var k in sajatErtek) { visszatolt(); return; }
            for (var s in sorErtek) { visszatolt(); return; }
        }, 1000);
        return true;
    }

    function varakozz(kor) {
        if (indulj()) return;
        if ((kor || 0) > 60) return;
        setTimeout(function () { varakozz((kor || 0) + 1); }, 500);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () { varakozz(0); });
    } else {
        varakozz(0);
    }
})();

/* =========================================================================
   8. kör – 110. pont: a Teeinblue felugró ablakaiban (kép kiválasztása,
   kosárba rakás) a sötét hátterű gombok felirata fehér legyen.
   -------------------------------------------------------------------------
   A 7. kör 86. pontja fekete feliratot adott az előnézet bezárása gombnak,
   de a Teeinblue némelyik felugró ablakában a MEGERŐSÍTŐ gomb is ugyanabba
   az osztályba esik – ott fekete lett a fekete háttéren. Osztálynév helyett
   a tényleges háttérszínt nézzük: ha sötét, a felirat fehér.
   ========================================================================= */
(function () {
    'use strict';

    function vilagossag(szin) {
        var m = /rgba?\(\s*(\d+)[,\s]+(\d+)[,\s]+(\d+)(?:[,/\s]+([\d.]+))?/.exec(szin || '');
        if (!m) return null;
        /* Áttetsző háttér mögött a szülő színe látszik – azt nem tudjuk
           megbízhatóan, ezért az ilyet nem bántjuk. */
        if (m[4] !== undefined && parseFloat(m[4]) < 0.5) return null;
        return 0.299 * +m[1] + 0.587 * +m[2] + 0.114 * +m[3];
    }

    function javit(gomb) {
        var h = vilagossag(getComputedStyle(gomb).backgroundColor);
        if (h === null || h >= 110) return;           /* nem sötét gomb */
        var f = vilagossag(getComputedStyle(gomb).color);
        if (f !== null && f >= 150) return;           /* már fehér a felirat */
        gomb.style.setProperty('color', '#fff', 'important');
        gomb.style.setProperty('-webkit-text-fill-color', '#fff', 'important');
        gomb.querySelectorAll('span, strong, em').forEach(function (b) {
            b.style.setProperty('color', '#fff', 'important');
            b.style.setProperty('-webkit-text-fill-color', '#fff', 'important');
        });
    }

    function korbejar() {
        document.querySelectorAll('.tee-btn, [class*="tee-"] button, [class*="tee"] .btn').forEach(function (g) {
            var r = g.getBoundingClientRect();
            if (r.width && r.height) javit(g);
        });
    }

    var idozito = null;
    function utemez() {
        if (idozito) return;
        idozito = setTimeout(function () { idozito = null; korbejar(); }, 200);
    }

    /* GYORSÍTÁS (2026-10-02): a bejárás minden gombra stílust olvas
       (getComputedStyle + getBoundingClientRect), ezért csak akkor fut, ha
       a változás Teeinblue-elemet érint. Eddig az oldal BÁRMELY változása
       után lefutott — a kollekcióoldalon a kártyák betöltésekor, a
       termékoldalon a Teeinblue minden rajzolásakor. */
    function teeErinti(valtozasok) {
        for (var i = 0; i < valtozasok.length; i++) {
            var v = valtozasok[i];
            if (v.target.nodeType === 1 && v.target.closest('[class*="tee"]')) return true;
            for (var j = 0; j < v.addedNodes.length; j++) {
                var n = v.addedNodes[j];
                if (n.nodeType === 1 && (n.matches('[class*="tee"]') || n.querySelector('[class*="tee"]'))) return true;
            }
        }
        return false;
    }
    function indulj() {
        korbejar();
        new MutationObserver(function (valtozasok) { if (teeErinti(valtozasok)) utemez(); }).observe(document.body, { childList: true, subtree: true });
        document.addEventListener('click', utemez, true);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', indulj);
    } else {
        indulj();
    }
})();

/* =========================================================================
   FOTÓ ÉS SZÍNVÁLTÁS — SZÁNDÉKOSAN NINCS ITT SEMMI
   -------------------------------------------------------------------------
   Több designnál a színválasztó valójában SABLONVÁLTÁS: a Teeinblue ilyenkor
   újraépíti az űrlapot, a fotós cella új réteg-azonosítót kap, és a már
   feltöltött (vagy épp töltődő) fotó elveszik.

   A 8–11. körben három nekifutásban próbáltuk ezt áthidalni: a fotót a
   Teeinblue saját tárolójába visszaírva és az űrlapot újratöltetve. Mindegyik
   változat hozott új bajt — a legsúlyosabb, hogy a visszatöltés a TELJES
   mentett rekordot visszahozta, a sablonválasztással együtt, és a vásárló a
   feltöltéskori színen ragadt. Rossz színű rendelés kockázata nem éri meg a
   kényelmet.

   A tulaj döntése (2026-09-21): maradjon az eredeti viselkedés. A színváltás
   szabadon megtörténik, és egyszerűen megszakítja a fotót — a vásárló újra
   feltölti. Ehelyett a fotócella melletti tipp-dobozban piros figyelmeztetés
   áll (lásd brinuti-tee-varazslo: .bl-foto-vigyazat), hogy töltés közben ne
   váltson színt.

   Ezzel többet NE próbálkozzunk.
   ========================================================================= */

/* =========================================================================
   A KOSÁRBÓL NYÍLÓ SZERKESZTŐ LEGÖRDÜLŐI IS TEGEZZENEK (9. kör, 130. pont)

   A 130. pontot a termékoldali varázsló (brinuti-tee-varazslo) oldotta meg:
   ahol a Teeinblue helyőrzője történetesen egy valódi tétel neve („Kolibris”),
   ott a legördülő első, nem választható sora ismétlődő tételnek látszott.

   Csakhogy a kosárból indított szerkesztés a Teeinblue SAJÁT felugró ablakát
   nyitja meg, és abban ugyanaz az űrlap MÉG EGYSZER ott van – ugyanazzal az
   azonosítóval (`#teeFormInputs`). A varázsló a lap első ilyen űrlapjára
   dolgozik, tehát a felugróban maradt a „Kolibris” kétszer és a magázó
   „Válasszon egy opciót”. Lemérve a Vintage Design naplónál.

   Ez a modul minden Teeinblue-űrlapra ráfut, a felugróra is, és CSAK a
   legördülők első sorát javítja – az elrendezéshez nem nyúl, azt a
   termékoldalon továbbra is a varázsló intézi. A kosárfiók bármelyik oldalon
   megnyílhat, ezért van itt és nem a termékoldali kódban.
   ========================================================================= */
(function () {
    var URLAPOK = '.tee-customization-form';

    function tegez(t) {
        return t
            /* A sorrend számít: a „Válassza ki" előbb, különben a rövidebb
               minta alakítaná át, és „Válasszd ki" lenne belőle. */
            .replace(/Válassza ki/g, 'Válaszd ki')
            .replace(/Válasszon/g, 'Válassz')
            .replace(/Válassza/g, 'Válaszd')
            .replace(/Töltse fel/g, 'Töltsd fel')
            .replace(/Írja be/g, 'Írd be')
            .replace(/Írja le/g, 'Írd le')
            .replace(/Adja meg/g, 'Add meg')
            .replace(/Kattintson/g, 'Kattints')
            .replace(/Húzza/g, 'Húzd');
    }

    /* Nemcsak a legördülők: a Teeinblue gombjai és súgószövegei is
       magázhatnak. A füzeteknél lemérve (2026-09-21): a fotófeltöltő gomb
       felirata „Válasszon egy képet" volt, miközben az oldalon minden más
       tegez. A naplóknál ezt a termékoldali varázsló intézi, de a füzetekre
       és a kosárból nyíló szerkesztőre az nem fut rá — ezért itt, az
       ŰRLAPON BELÜL, minden szövegcsomót átnézünk.
       A legördülők tételeit kihagyjuk: azok termék- és mintanevek, azokhoz a
       fenti, célzott logika nyúl hozzá. */
    var KIHAGY = { SCRIPT: 1, STYLE: 1, OPTION: 1, TEXTAREA: 1 };
    var MAGAZ = /Válassz(on|a)|Töltse fel|Írja (be|le)|Adja meg|Kattintson|Húzza/;

    function szovegekTegezese(urlap) {
        var seta = document.createTreeWalker(urlap, NodeFilter.SHOW_TEXT, {
            acceptNode: function (csomo) {
                if (!MAGAZ.test(csomo.nodeValue || '')) return NodeFilter.FILTER_REJECT;
                var szulo = csomo.parentNode;
                if (szulo && KIHAGY[szulo.nodeName]) return NodeFilter.FILTER_REJECT;
                return NodeFilter.FILTER_ACCEPT;
            }
        });
        var csomok = [];
        var cs;
        while ((cs = seta.nextNode())) csomok.push(cs);
        csomok.forEach(function (csomo) {
            var uj = tegez(csomo.nodeValue);
            if (uj !== csomo.nodeValue) csomo.nodeValue = uj;
        });
    }

    /* A cella saját felirata – ebből lesz a helyőrző, ha az felszólítás. */
    function fejszoveg(cella) {
        var h = cella && cella.querySelector('.tee-field__heading');
        if (!h) return '';
        var s = h.querySelector('span');
        var t = (s ? s.textContent : h.textContent) || '';
        return tegez(t.replace(/\*/g, '').replace(/^\s*\d+\.\s*/, '').replace(/[!.:]\s*$/, '').trim());
    }

    function javitsd() {
        var urlapok = document.querySelectorAll(URLAPOK);
        Array.prototype.forEach.call(urlapok, function (urlap) {
            szovegekTegezese(urlap);
            Array.prototype.forEach.call(urlap.querySelectorAll('select'), function (sel) {
                if (sel.options.length < 2) return;
                var elso = sel.options[0];
                if (!elso.disabled) return;
                var sz = (elso.text || '').trim();
                if (/^(válassz|válaszd|add meg|írd)/i.test(sz)) {
                    var teg = tegez(sz);
                    if (elso.text !== teg) elso.text = teg;
                    return;
                }
                /* Nem felszólítás: ez a kategória mintaszövege, és összekeverhető
                   egy valódi tétellel. A cella feliratát tesszük a helyére. */
                var cim = fejszoveg(sel.closest('.tee-field'));
                var utasitas = /^(válassz|válaszd)/i.test(cim) ? cim : 'Válassz egy opciót';
                if (elso.text !== utasitas) elso.text = utasitas;
            });
        });
    }

    var idozit = null;
    function utemez() {
        if (idozit) return;
        idozit = setTimeout(function () { idozit = null; javitsd(); }, 120);
    }

    /* GYORSÍTÁS (2026-10-02): csak a Teeinblue-űrlapot érintő változásra
       fut le (eddig az oldal bármely változására). */
    function urlapotErinti(valtozasok) {
        for (var i = 0; i < valtozasok.length; i++) {
            var v = valtozasok[i];
            if (v.target.nodeType === 1 && v.target.closest(URLAPOK)) return true;
            for (var j = 0; j < v.addedNodes.length; j++) {
                var n = v.addedNodes[j];
                if (n.nodeType === 1 && (n.matches(URLAPOK) || n.querySelector(URLAPOK))) return true;
            }
        }
        return false;
    }
    function indulj() {
        javitsd();
        new MutationObserver(function (valtozasok) { if (urlapotErinti(valtozasok)) utemez(); }).observe(document.body, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', indulj);
    } else {
        indulj();
    }
})();

/* KÁRTYÁK REJTETT DIÁI: KÉP CSAK HA KELL (2026-10-14, gyorsítás).

   A rácsban a 2.+ dia képe data-bk-src / data-bk-srcset attribútumban jön
   (snippets/card-gallery.liquid), a helyén egy 1×1-es átlátszó kép. Itt
   töltjük be:
     1. azonnal, ha a vásárló a kártyához ér (rámutatás, érintés, fókusz) —
        a lapozás és a rámutatásos hátlap így mindig megjön;
     2. az oldal betöltése után, üresjáratban, a képernyőn és közelében lévő
        kártyáknál — asztalon a hátlap így rámutatás előtt már kész.
   A 2. lépés csak a 2. diát tölti (a hátlapot), a 3.+ diákat csak az 1.
   Színszűrés közben (body.bsz-aktiv) a 2. lépés szünetel: akkor a képcsíkok
   kapják a sávszélességet. A lapozással, szűréssel bekerülő új kártyákat is
   figyeljük. Ha bármi elakadna, a kártya első képe ettől független. */
(function () {
    'use strict';
    var JEL = 'img[data-bk-src]';

    /* csakElso: üresjáratban csak a következő (2.) dia képe — az a rámutatásos
       hátlap és a lapozás első célja. A többi csak a kártya érintésére jön. */
    function toltsdBe(kartya, csakElso) {
        if (!kartya || !kartya.querySelectorAll) return;
        var kepek = kartya.querySelectorAll(JEL);
        for (var i = 0; i < (csakElso ? Math.min(1, kepek.length) : kepek.length); i++) {
            var im = kepek[i];
            var srcset = im.getAttribute('data-bk-srcset');
            var src = im.getAttribute('data-bk-src');
            im.removeAttribute('data-bk-srcset');
            im.removeAttribute('data-bk-src');
            if (srcset) im.setAttribute('srcset', srcset);
            if (src) im.setAttribute('src', src);
        }
    }
    function kartyaja(cel) {
        return cel && cel.closest ? cel.closest('product-card, .product-card, .product-grid__item') : null;
    }
    ['pointerover', 'touchstart', 'focusin'].forEach(function (esemeny) {
        document.addEventListener(esemeny, function (e) {
            var k = kartyaja(e.target);
            if (k && k.querySelector(JEL)) toltsdBe(k);
        }, { passive: true, capture: true });
    });

    if (!('IntersectionObserver' in window)) {
        window.addEventListener('load', function () {
            document.querySelectorAll(JEL).forEach(function (im) { toltsdBe(kartyaja(im) || im.parentNode); });
        });
        return;
    }

    var latott = typeof WeakSet === 'function' ? new WeakSet() : null;
    var megfigyelo = new IntersectionObserver(function (bejegyzesek) {
        if (document.body.classList.contains('bsz-aktiv')) return;
        bejegyzesek.forEach(function (b) {
            if (!b.isIntersecting) return;
            megfigyelo.unobserve(b.target);
            toltsdBe(b.target, true);
        });
    }, { rootMargin: '200px 0px' });

    function felvesz() {
        var kepek = document.querySelectorAll(JEL);
        for (var i = 0; i < kepek.length; i++) {
            var k = kartyaja(kepek[i]);
            if (!k || (latott && latott.has(k))) continue;
            if (latott) latott.add(k);
            megfigyelo.observe(k);
        }
    }
    function indulj() {
        felvesz();
        var utemezve = false;
        new MutationObserver(function () {
            if (utemezve) return;
            utemezve = true;
            setTimeout(function () { utemezve = false; felvesz(); }, 300);
        }).observe(document.body, { childList: true, subtree: true });
        /* Szűrés törlése után a látható kártyák újra sorra kerülnek. */
        new MutationObserver(function () {
            if (document.body.classList.contains('bsz-aktiv')) return;
            document.querySelectorAll(JEL).forEach(function (im) {
                var k = kartyaja(im);
                if (k) { megfigyelo.unobserve(k); megfigyelo.observe(k); }
            });
        }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    }
    /* Csak az oldal betöltése UTÁN, üresjáratban: addig az első képek és a
       csíkok elsőbbséget kapnak. */
    function kesobb() {
        (window.requestIdleCallback || function (f) { setTimeout(f, 200); })(indulj, { timeout: 3000 });
    }
    if (document.readyState === 'complete') kesobb();
    else window.addEventListener('load', kesobb, { once: true });
})();

/* ===================================================================
   A KOSÁRSOR KIS KÉPE SOHA NEM A TEEINBLUE NYILAS KÉPE (2026-10-21, a tulaj
   kérése: „sehol se a nyilas verziót, mindenhol a második”).

   A Teeinblue saját szkriptje a kosársor képét egy saját
   (tee-cart-thumbnail__img) elemre cseréli, amely a nyilas, „1. Válassz
   mintát!” magyarázó réteges kész képet (_customization_image) mutatja. Ha a
   vásárló tervének mentett pillanatképe megvan, az ráfedi (lásd fent); ha
   nincs (más eszköz, törölt böngészőadat), a nyilas kép látszana. Ilyenkor a
   sor képe a vásárló saját levélképe (_brinuti_elonezet), annak híján a
   termék 2. mockupja (a snippets/cart-products.liquid adja, data-bk-mockup2).
   Az app újra is cserélhet, ezért figyeljük, de legfeljebb 8-szor írunk
   ugyanarra a képre vissza (végtelen harc ellen).
   =================================================================== */
(function () {
    var NYILAS = /cdn\.teeinblue\.com\/customizations\//;
    function levelkep(gomb) {
        var t = (gomb.getAttribute('data-props') || '').replace(/\\/g, '');
        var m = t.match(/"_brinuti_elonezet"\s*[,:]\s*"(https?:[^"]+)"/);
        return m ? m[1] : '';
    }
    function javit() {
        Array.prototype.forEach.call(document.querySelectorAll('.cart-items__media img'), function (kep) {
            if (!NYILAS.test(kep.getAttribute('src') || '')) return;
            var sor = kep.closest('.cart-items__table-row, tr, .cart-item');
            var gomb = sor && sor.querySelector('.btn-preview');
            if (!gomb) return;
            var cel = levelkep(gomb) || gomb.getAttribute('data-bk-mockup2') || '';
            if (!cel) return;
            var n = Number(kep.getAttribute('data-bk-vissza') || 0);
            if (n >= 8) return;
            kep.setAttribute('data-bk-vissza', String(n + 1));
            kep.removeAttribute('srcset');
            kep.src = cel;
        });
    }
    var ido = null;
    function utemez() {
        if (ido) return;
        ido = setTimeout(function () { ido = null; javit(); }, 120);
    }
    function indulj() {
        javit();
        try {
            new MutationObserver(function (valtozasok) {
                for (var i = 0; i < valtozasok.length; i++) {
                    var t = valtozasok[i].target;
                    if (t && t.nodeType === 1 && (t.closest ? t.closest('.cart-items__media') : null)) { utemez(); return; }
                    var hozzaadott = valtozasok[i].addedNodes || [];
                    for (var j = 0; j < hozzaadott.length; j++) {
                        var n = hozzaadott[j];
                        if (n.nodeType === 1 && (n.matches('.cart-items__table-row, .cart-items__media, img') || n.querySelector('.cart-items__media'))) { utemez(); return; }
                    }
                }
            }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['src'] });
        } catch (e) { }
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', indulj);
    else indulj();
})();
